export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "de-DE",
    "Messages": {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "%0 %1 temu": "vor %0 %1",
        "%0 ostrzeżeń": "%0 Warnungen",
        "%0 plików": "%0 Dateien",
        "%0 wierszy · %1 px": "%0 Zeilen · %1 px",
        "%0 z %1": "%0 von %1",
        "%0 z %1 uprawnień aktywnych": "%0 von %1 Berechtigungen aktiv",
        "%0 z 12 kolumn siatki": "%0 von 12 Rasterspalten",
        "%0 zaznaczono": "%0 ausgewählt",
        "%0 znaków": "%0 Zeichen",
        "<Brak nazwy>": "<Kein Name>",
        "<iframe src=\"...\"></iframe>": "<iframe src=\"...\"></iframe>",
        "1 godzina": "1 Stunde",
        "1 ostrzeżenie": "1 Warnung",
        "1:1 kwadrat": "1:1 Quadrat",
        "10 minut": "10 Minuten",
        "1024x1024": "1024x1024",
        "1024x1536": "1024x1536",
        "12 godzin": "12 Stunden",
        "15 minut": "15 Minuten",
        "1536x1024": "1536x1024",
        "16:9 panoramiczny": "16:9 Panorama",
        "24 godziny": "24 Stunden",
        "3 godziny": "3 Stunden",
        "3:4 portret": "3:4 Hochformat",
        "30 minut": "30 Minuten",
        "4:3 standard": "4:3 Standard",
        "5 minut": "5 Minuten",
        "6 godzin": "6 Stunden",
        "9:16 mobile": "9:16 Mobil",
        "Abstrakcyjne tło w kolorach marki, gradient": "Abstrakter Hintergrund in Markenfarben, Farbverlauf",
        "Aby móc przetestować poprawność kluczy, najpierw zapisz formularz.": "Um die Gültigkeit der Schlüssel testen zu können, speichern Sie zuerst das Formular.",
        "Administracja": "Administration",
        "Administracja - Kraje": "Administration - Länder",
        "Administracja - Miasta": "Administration - Städte",
        "Administracja - Role": "Administration - Rollen",
        "Administracja - Stanowiska pracy": "Administration - Berufsbezeichnungen",
        "Administracja - Użytkownicy": "Administration - Benutzer",
        "Administracja - Województwa": "Administration - Bundesländer",
        "Administracja - Zespoły": "Administration - Teams",
        "Administrator": "Administrator",
        "Administratorzy": "Administratoren",
        "Adres bazowy API dostawcy.": "Basisadresse der API des Anbieters.",
        "Adres domenowy": "Domänenadresse",
        "Adres e-mail": "E-Mail-Adresse",
        "Adres e-mail administratora": "E-Mail-Adresse des Administrators",
        "Adres e-mail potwierdzony": "E-Mail-Adresse bestätigt",
        "Adres email jest wymagany": "Die E-Mail-Adresse ist erforderlich",
        "Adres email nadawcy": "E-Mail-Adresse des Absenders",
        "Adres IP": "IP-Adresse",
        "Adres lub connection string używany do eksportu telemetrii.": "Adresse oder Connection String für den Export von Telemetriedaten.",
        "Adres nie istnieje lub zasób został usunięty.\nSprawdź link albo poszukaj treści w panelu.": "Die Adresse existiert nicht oder die Ressource wurde gelöscht.\nÜberprüfen Sie den Link oder suchen Sie den Inhalt im Dashboard.",
        "Adres powiadomień systemowych i resetu hasła.": "Adresse für Systembenachrichtigungen und Passwortzurücksetzung.",
        "Adres projektu Sentry, do którego trafiają zdarzenia.": "Adresse des Sentry-Projekts, an das Ereignisse gesendet werden.",
        "Adres serwera poczty wychodzącej.": "Adresse des Postausgangsservers.",
        "Adres URL": "URL-Adresse",
        "Adres używany do logowania, powiadomień i odzyskiwania dostępu.": "Adresse für Anmeldung, Benachrichtigungen und Wiederherstellung des Zugriffs.",
        "Adres w polu „Od” wysyłanych wiadomości.": "Adresse im Feld „Von“ der gesendeten Nachrichten.",
        "Adres źródłowy lub nazwa miejsca, z którego pochodzi materiał.": "Quelladresse oder Name des Ortes, von dem das Material stammt.",
        "Adresy rozdziel przecinkami. Każdy musi zaczynać się od http lub https.": "Trennen Sie die Adressen durch Kommas. Jede muss mit http oder https beginnen.",
        "Agent chce wykonać operację:": "Der Agent möchte folgende Aktion ausführen:",
        "AI": "AI",
        "Akapit": "Absatz",
        "Akcja": "Aktion",
        "Akcje": "Aktionen",
        "Akcje {name}": "Aktionen {name}",
        "Akcje folderu": "Ordneraktionen",
        "Akcje pliku": "Dateiaktionen",
        "Akordeon": "Akkordeon",
        "Aktualizuj": "Aktualisieren",
        "Aktualizuj zestaw": "Set aktualisieren",
        "Aktualna": "Aktuell",
        "Aktualna sesja": "Aktuelle Sitzung",
        "Aktualne hasło": "Aktuelles Passwort",
        "Aktywna": "Aktiv",
        "Aktywne": "Aktiv",
        "Aktywne sesje": "Aktive Sitzungen",
        "Aktywni": "Aktiv",
        "Aktywny": "Aktiv",
        "Aktywuj": "Aktivieren",
        "Akwarela": "Aquarell",
        "Alt opisuje obraz osobom korzystającym z czytników ekranu i jest używany, gdy obraz nie może się załadować.": "Der Alt-Text beschreibt das Bild für Personen, die Screenreader verwenden, und wird angezeigt, wenn das Bild nicht geladen werden kann.",
        "Analiza": "Analyse",
        "Analiza obrazów": "Bildanalyse",
        "Analiza obrazów, rozpoznawanie wzorów wizualnych": "Bildanalyse, Erkennung visueller Muster",
        "Angielski": "Englisch",
        "Anonimizuj": "Anonymisieren",
        "Anonimowy": "Anonym",
        "Anulowano": "Abgebrochen",
        "Anulowano zmianę pozycji widgetu %0.": "Die Positionsänderung des Widgets %0 wurde abgebrochen.",
        "Anuluj": "Abbrechen",
        "Anuluj dodawanie urządzenia": "Gerät hinzufügen abbrechen",
        "Anuluj zmianę nazwy": "Umbenennen abbrechen",
        "Aplikacja monitorująca": "Überwachungsanwendung",
        "Aplikacja uwierzytelniająca": "Authentifizierungs-App",
        "Aplikacja uwierzytelniająca została skonfigurowana.": "Die Authentifizierungs-App wurde eingerichtet.",
        "Aplikacja zostanie zrestartowana w przeciągu maksymalnie 60 sekund.": "Die Anwendung wird innerhalb von maximal 60 Sekunden neu gestartet.",
        "Aranżacja": "Layout",
        "Artykuł": "Artikel",
        "Asystent AI": "KI-Assistent",
        "Asystent będzie wykonywał wszystkie dozwolone operacje bez pytania, również nieodwracalne usuwanie danych.": "Der Assistent führt alle zulässigen Vorgänge ohne Nachfrage aus, auch das unwiderrufliche Löschen von Daten.",
        "Asystent czeka na Twoje potwierdzenie.": "Der Assistent wartet auf Ihre Bestätigung.",
        "Asystent napotkał błąd serwera. Spróbuj ponownie za chwilę.": "Beim Assistenten ist ein Serverfehler aufgetreten. Bitte versuchen Sie es gleich noch einmal.",
        "Asystent nie jest włączony w konfiguracji AI. Skontaktuj się z administratorem.": "Der Assistent ist in der KI-Konfiguration nicht aktiviert. Wenden Sie sich an den Administrator.",
        "Asystent nie widzi Edito": "Der Assistent kann Edito nicht sehen",
        "Asystent pracuje...": "Der Assistent arbeitet …",
        "Asystent prosi o repozytorium": "Der Assistent fordert ein Repository an",
        "Asystent zakończył zadanie.": "Der Assistent hat die Aufgabe abgeschlossen.",
        "Automatyczne zamknięcie panelu. Najedź kursorem, aby wstrzymać.": "Das Panel wird automatisch geschlossen. Bewegen Sie den Mauszeiger darüber, um die automatische Schließung anzuhalten.",
        "Autonomiczny": "Autonom",
        "Autor": "Autor",
        "Autoryzacja wymagana": "Autorisierung erforderlich",
        "Azure AD": "Azure AD",
        "Azure Application Insights": "Azure Application Insights",
        "Bardzo dobre": "Sehr gut",
        "Basic Auth": "Basic Auth",
        "Baza danych": "Datenbank",
        "Bez koloru": "Ohne Farbe",
        "Bez potwierdzeń, również przy usuwaniu": "Ohne Bestätigung, auch beim Löschen",
        "Bez przycinania": "Ohne Zuschneiden",
        "Bezpieczeństwo": "Sicherheit",
        "Bezpieczne połączenie SSL": "Sichere SSL-Verbindung",
        "Biblioteka": "Bibliothek",
        "Biblioteka plików": "Dateibibliothek",
        "Błąd 404. Nie znaleziono żądanego zasobu.": "Fehler 404. Die angeforderte Ressource wurde nicht gefunden.",
        "Błąd asystenta": "Assistentenfehler",
        "Błąd cofania zmian": "Fehler beim Rückgängigmachen der Änderungen",
        "Błąd pobierania rozmów": "Fehler beim Abrufen der Unterhaltungen",
        "Błąd pobierania rozmowy": "Fehler beim Abrufen der Unterhaltung",
        "Błąd połączenia": "Verbindungsfehler",
        "Błąd potwierdzenia operacji": "Fehler beim Bestätigen des Vorgangs",
        "Błąd serwera": "Serverfehler",
        "Błąd wysyłania załącznika": "Fehler beim Senden des Anhangs",
        "Błędne": "Fehlerhaft",
        "Błędy": "Fehler",
        "Błękitny": "Hellblau",
        "Blok kodu": "Codeblock",
        "Blokada konta": "Kontosperrung",
        "Blokada konta do": "Konto gesperrt bis",
        "Blokada konta i sesja": "Kontosperrung und Sitzung",
        "Blokady": "Sperren",
        "Bool": "Bool",
        "Brak": "Keine",
        "Brak aktywnych ankiet z odpowiedziami do pokazania.": "Keine aktiven Umfragen mit anzuzeigenden Antworten.",
        "Brak aktywnych sesji.": "Keine aktiven Sitzungen.",
        "Brak aktywnych zastępstw w wybranym miesiącu.": "Keine aktiven Vertretungen im ausgewählten Monat.",
        "Brak danych": "Keine Daten",
        "Brak danych inspekcji": "Keine Inspektionsdaten",
        "Brak dodatkowych metadanych": "Keine zusätzlichen Metadaten",
        "Brak dodatkowych stylów": "Keine zusätzlichen Stile",
        "Brak dostawcy": "Kein Anbieter",
        "Brak dostępnych opcji": "Keine verfügbaren Optionen",
        "Brak elementów": "Keine Elemente",
        "Brak elementów.": "Keine Elemente.",
        "Brak ikon pasujących do wyszukiwania.": "Keine zum Suchbegriff passenden Symbole.",
        "Brak kluczy": "Keine Schlüssel",
        "Brak nowych powiadomień.": "Keine neuen Benachrichtigungen.",
        "Brak ostrzeżeń": "Keine Warnungen",
        "Brak pasujących dashboardów.": "Keine passenden Dashboards.",
        "Brak pasujących kolumn": "Keine passenden Spalten",
        "Brak pasujących plików": "Keine passenden Dateien",
        "Brak pasujących ról.": "Keine passenden Rollen.",
        "Brak pasujących zestawów": "Keine passenden Sammlungen",
        "Brak pliku": "Keine Datei",
        "Brak produktów do wyświetlenia według aktualnych kryteriów.": "Keine Produkte gemäß den aktuellen Kriterien anzuzeigen.",
        "Brak przypisania": "Keine Zuweisung",
        "Brak ról": "Keine Rollen",
        "Brak rozmów": "Keine Unterhaltungen",
        "Brak różnic między wersjami": "Keine Unterschiede zwischen den Versionen",
        "Brak skonfigurowanych urządzeń": "Keine konfigurierten Geräte",
        "Brak treści": "Kein Inhalt",
        "Brak treści do wyświetlenia w wybranym zakresie.": "Im ausgewählten Zeitraum gibt es keine anzuzeigenden Inhalte.",
        "Brak uprawnień": "Keine Berechtigungen",
        "Brak uprawnień do asystenta.": "Keine Berechtigungen für den Assistenten.",
        "Brak użytkownika": "Kein Benutzer",
        "Brak użytkowników lub rejestracji do wyświetlenia w tym zakresie.": "In diesem Zeitraum gibt es keine Benutzer oder Registrierungen anzuzeigen.",
        "Brak wersji": "Keine Versionen",
        "Brak witryn.": "Keine Websites.",
        "Brak wpisów do wyświetlenia": "Keine Einträge zum Anzeigen",
        "Brak wpisów w dzienniku.": "Keine Protokolleinträge.",
        "Brak wyboru": "Keine Auswahl",
        "Brak wyników": "Keine Ergebnisse",
        "Brak wyników dla podanego wyszukiwania.": "Keine Ergebnisse für die angegebene Suche.",
        "Brak zapamiętanych urządzeń.": "Keine gespeicherten Geräte.",
        "Brak zapisanych zestawów": "Keine gespeicherten Sammlungen",
        "Brak zdefiniowanych ról.": "Keine definierten Rollen.",
        "Brak zmian dla wybranego filtra": "Keine Änderungen für den ausgewählten Filter",
        "Brakuje emoji?": "Fehlt ein Emoji?",
        "Brakuje informacji o typie jednego z plików. Odśwież listę.": "Für eine der Dateien fehlen Angaben zum Dateityp. Aktualisieren Sie die Liste.",
        "Brakuje znaku?": "Fehlt ein Zeichen?",
        "Breakpoint nieustawiony": "Breakpoint nicht festgelegt",
        "Brzoskwiniowy": "Pfirsichfarben",
        "Build": "Build",
        "Cały obraz": "Gesamtes Bild",
        "Caption wyświetla się nad tabelą i poprawia jej dostępność dla czytników ekranu.": "Die Beschriftung wird über der Tabelle angezeigt und verbessert deren Zugänglichkeit für Screenreader.",
        "Chat": "Chat",
        "Chat i krótkie podsumowania o niskiej latencji.": "Chat und kurze Zusammenfassungen mit geringer Latenz.",
        "Chat, generowanie treści i podsumowań - szybkie odpowiedzi": "Chat, Generierung von Inhalten und Zusammenfassungen – schnelle Antworten",
        "Chat, generowanie treści i podsumowań - zaawansowane odpowiedzi": "Chat, Generierung von Inhalten und Zusammenfassungen – erweiterte Antworten",
        "Chat, generowanie treści i podsumowań.": "Chat, Generierung von Inhalten und Zusammenfassungen.",
        "Ciemny nagłówek": "Dunkle Kopfzeile",
        "Claude Code - instalacja i pierwsze kroki": "Claude Code – Installation und erste Schritte",
        "Claude Code - połączenia MCP": "Claude Code – MCP-Verbindungen",
        "Claude Code Desktop - rozpoczęcie pracy": "Claude Code Desktop – Erste Schritte",
        "Claude nie pokazuje karty Code": "Claude zeigt die Code-Karte nicht an",
        "Claymation": "Claymation",
        "Client ID": "Client-ID",
        "Client Secret": "Client-Secret",
        "Co {interval} {unit}": "Alle {interval} {unit}",
        "co 3 miesiące": "Alle 3 Monate",
        "co 30 dni": "Alle 30 Tage",
        "co 6 miesięcy": "Alle 6 Monate",
        "Co będzie potrzebne": "Was wird benötigt?",
        "Co było nie tak? (opcjonalnie)": "Was ist schiefgelaufen? (optional)",
        "Co godzinę": "Stündlich",
        "Co któreś": "Jeden wievielten",
        "Co miesiąc": "Monatlich",
        "Co minutę": "Jede Minute",
        "Co możesz zrobić": "Was Sie tun können",
        "co rok": "Jährlich",
        "Co zrobić": "Was ist zu tun?",
        "Codex - aplikacja i instalacja": "Codex – Anwendung und Installation",
        "Codex - konfiguracja projektu": "Codex – Projektkonfiguration",
        "Codex - projekty i foldery": "Codex – Projekte und Ordner",
        "Codziennie": "Täglich",
        "Cofanie w toku...": "Wird rückgängig gemacht...",
        "Cofnąć te zmiany? Wykonam operacje odwrotne przez narzędzia CMS.": "Möchten Sie diese Änderungen rückgängig machen? Ich führe die umgekehrten Vorgänge über die CMS-Tools aus.",
        "Cofnięcie odrzucone — zmiana pozostaje.": "Rückgängigmachen abgelehnt – die Änderung bleibt bestehen.",
        "Cofnięto": "Rückgängig gemacht",
        "Cofnij": "Rückgängig machen",
        "Cofnij zmiany": "Änderungen rückgängig machen",
        "Coś nie zadziałało po naszej stronie.\nSpróbuj ponownie za chwilę.": "Auf unserer Seite ist ein Fehler aufgetreten.\nBitte versuchen Sie es in Kürze erneut.",
        "Coś nie zadziałało po naszej stronie.\nZdarzenie zostało zapisane - spróbuj ponownie za chwilę.": "Auf unserer Seite ist ein Fehler aufgetreten.\nDas Ereignis wurde gespeichert – bitte versuchen Sie es in Kürze erneut.",
        "Cron": "Cron",
        "CSS gradientu": "CSS-Verlauf",
        "Cyberpunk": "Cyberpunk",
        "cyfra %0 z %1": "Ziffer %0 von %1",
        "Cyfrowe malarstwo": "Digitale Malerei",
        "Cytat": "Zitat",
        "Czas na zatwierdzenie planu minął.": "Die Zeit zum Bestätigen des Plans ist abgelaufen.",
        "Czas nieaktywności użytkownika": "Inaktivitätszeit des Benutzers",
        "Czas trwania blokady": "Sperrdauer",
        "Czas uruchomienia": "Startzeit",
        "Czego szukasz?": "Wonach suchen Sie?",
        "czeka na potwierdzenie": "wartet auf Bestätigung",
        "czerwiec": "Juni",
        "Część": "Teil",
        "Część harmonogramu": "Teil des Zeitplans",
        "Część wklejonej treści została usunięta ze względów bezpieczeństwa.": "Ein Teil des eingefügten Inhalts wurde aus Sicherheitsgründen entfernt.",
        "Czy na pewno chcesz opuścić widok bez zapisywania?": "Möchten Sie die Ansicht wirklich verlassen, ohne zu speichern?",
        "Czy na pewno chcesz usunąć sekcję wraz z treścią?": "Möchten Sie den Abschnitt einschließlich seines Inhalts wirklich löschen?",
        "Czy na pewno chcesz usunąć to urządzenie?": "Möchten Sie dieses Gerät wirklich löschen?",
        "Czy na pewno chcesz usunąć widget?": "Möchten Sie das Widget wirklich löschen?",
        "Czy na pewno chcesz usunąć wybrane pliki i katalogi?": "Möchten Sie die ausgewählten Dateien und Verzeichnisse wirklich löschen?",
        "Czy na pewno chcesz zrestartować aplikację?": "Möchten Sie die Anwendung wirklich neu starten?",
        "Czyści zaznaczenia w formularzu i ustawia wyrażenie * * * * *. Zmiany pozostają lokalne do kliknięcia „Zapisz”.": "Entfernt die Auswahl im Formular und setzt den Ausdruck auf * * * * *. Die Änderungen bleiben lokal, bis Sie auf „Speichern“ klicken.",
        "Czytniki ekranu i użytkownicy nie widzą, gdzie prowadzi link bez tekstu. Taki link może też wyglądać jak przypadkowy znacznik w treści.": "Screenreader und Benutzer können ohne Linktext nicht erkennen, wohin ein Link führt. Ein solcher Link kann im Inhalt auch wie ein versehentliches Zeichen aussehen.",
        "Dalej": "Weiter",
        "Dane dodatkowe": "Zusätzliche Daten",
        "Dane inspekcji są niedostępne": "Inspektionsdaten sind nicht verfügbar",
        "Dane pliku": "Dateidaten",
        "Dane po zmianie": "Daten nach der Änderung",
        "Dane przed zmianą": "Daten vor der Änderung",
        "Dane serwera używanego do wysyłki wiadomości.": "Daten des Servers, der zum Versenden von Nachrichten verwendet wird.",
        "Dane techniczne": "Technische Daten",
        "Dane widoczne w wiadomościach wysyłanych z panelu.": "Daten, die in über das Bedienfeld versendeten Nachrichten angezeigt werden.",
        "Dane wykorzystania limitu są prezentowane automatycznie, gdy źródło usług AI jest dostępne.": "Die Nutzungsdaten zum Limit werden automatisch angezeigt, wenn die Quelle für KI-Dienste verfügbar ist.",
        "Dashboard": "Dashboard",
        "Dashboard aktywny": "Aktives Dashboard",
        "Dashboard domyślny": "Standard-Dashboard",
        "Dashboard został dodany.": "Das Dashboard wurde hinzugefügt.",
        "Dashboard został skopiowany.": "Das Dashboard wurde kopiert.",
        "Dashboard został usunięty.": "Das Dashboard wurde gelöscht.",
        "Dashboard został zaktualizowane.": "Das Dashboard wurde aktualisiert.",
        "Dashboardy": "Dashboards",
        "Data": "Datum",
        "Data do": "Datum bis",
        "Data dodania": "Hinzufügedatum",
        "Data modyfikacji": "Änderungsdatum",
        "Data od": "Datum von",
        "Data rejestracji": "Registrierungsdatum",
        "Data uruchomienia": "Startdatum",
        "Data usunięcia": "Löschdatum",
        "Data wylogowania": "Abmeldedatum",
        "Data zalogowania": "Anmeldedatum",
        "Data zdarzenia": "Ereignisdatum",
        "DateTime": "Datum und Uhrzeit",
        "Dlaczego to problem": "Warum ist das ein Problem?",
        "Długość historii haseł": "Passworthistorie-Länge",
        "dni": "Tage",
        "Dni": "Tage",
        "Dni tygodnia": "Wochentage",
        "Do": "Bis",
        "do %0 MB": "bis zu %0 MB",
        "Do akceptacji": "Zur Freigabe",
        "do czasu ręcznego odblokowania": "bis zur manuellen Entsperrung",
        "Do filmu można dodać jedną ścieżkę napisów w formacie .vtt.": "Zu einem Video kann eine Untertitelspur im .vtt-Format hinzugefügt werden.",
        "Do lewej": "Linksbündig",
        "Do prawej": "Rechtsbündig",
        "Do środka": "Zentriert",
        "Do tej daty użytkownik nie może się zalogować. Puste pole oznacza brak blokady.": "Bis zu diesem Datum kann sich der Benutzer nicht anmelden. Ein leeres Feld bedeutet, dass keine Sperre besteht.",
        "Dobre": "Gut",
        "Dodaj": "Hinzufügen",
        "Dodaj aplikację uwierzytelniającą, aby generować kody bez dostępu do skrzynki e-mail.": "Fügen Sie eine Authentifizierungs-App hinzu, um Codes ohne Zugriff auf das E-Mail-Postfach zu generieren.",
        "Dodaj dashboard": "Dashboard hinzufügen",
        "Dodaj dostawcę": "Anbieter hinzufügen",
        "Dodaj filtr": "Filter hinzufügen",
        "Dodaj kolejne": "Weitere hinzufügen",
        "Dodaj kolejne pliki": "Weitere Dateien hinzufügen",
        "Dodaj kolumnę": "Spalte hinzufügen",
        "Dodaj kolumny": "Spalten hinzufügen",
        "Dodaj komórki TH w pierwszym wierszu albo przebuduj tabelę.": "Fügen Sie TH-Zellen in der ersten Zeile hinzu oder erstellen Sie die Tabelle neu.",
        "Dodaj krótki opis tego, co obraz wnosi do treści. Dla dekoracji zostaw pusty alt tylko wtedy, gdy komponent na to świadomie pozwala.": "Fügen Sie eine kurze Beschreibung dazu hinzu, was das Bild zum Inhalt beiträgt. Lassen Sie den Alt-Text bei dekorativen Bildern nur dann leer, wenn die Komponente dies ausdrücklich zulässt.",
        "Dodaj model": "Modell hinzufügen",
        "Dodaj nofollow": "Nofollow hinzufügen",
        "Dodaj opis alternatywny dla obrazka.": "Alternativtext für das Bild hinzufügen.",
        "Dodaj osobne grafiki dla wybranych szerokości ekranu. Presety przyspieszają pracę, a własny breakpoint pozwala wpisać dowolną wartość. Każdy wariant może mieć też własne wymiary HTML.": "Fügen Sie separate Grafiken für ausgewählte Bildschirmbreiten hinzu. Voreinstellungen beschleunigen die Arbeit, und mit einem benutzerdefinierten Breakpoint können Sie einen beliebigen Wert eingeben. Für jede Variante können Sie außerdem eigene HTML-Abmessungen festlegen.",
        "Dodaj pierwszy widget, a następnie ułóż go na siatce metodą przeciągnij i upuść.": "Fügen Sie das erste Widget hinzu und ordnen Sie es anschließend per Drag-and-drop im Raster an.",
        "Dodaj pliki": "Dateien hinzufügen",
        "Dodaj pliki albo przeciągnij je tutaj.": "Fügen Sie Dateien hinzu oder ziehen Sie sie hierher.",
        "Dodaj preset": "Voreinstellung hinzufügen",
        "Dodaj preset, jeśli chcesz szybko ustawić popularny breakpoint, albo wpisz własną szerokość ekranu w pikselach.": "Fügen Sie eine Voreinstellung hinzu, um schnell einen gängigen Breakpoint festzulegen, oder geben Sie eine benutzerdefinierte Bildschirmbreite in Pixeln ein.",
        "Dodaj rolę": "Rolle hinzufügen",
        "Dodaj sekcję": "Abschnitt hinzufügen",
        "Dodaj stop": "Stopp hinzufügen",
        "Dodaj tekst linku albo usuń pusty link.": "Fügen Sie Linktext hinzu oder entfernen Sie den leeren Link.",
        "Dodaj uprawnienia": "Berechtigungen hinzufügen",
        "Dodaj urządzenie": "Gerät hinzufügen",
        "Dodaj urządzenie uwierzytelniające": "Authentifizierungsgerät hinzufügen",
        "Dodaj użytkownika": "Benutzer hinzufügen",
        "Dodaj widget": "Widget hinzufügen",
        "Dodaj własną proporcję": "Benutzerdefiniertes Seitenverhältnis hinzufügen",
        "Dodaj własny breakpoint": "Benutzerdefinierten Breakpoint hinzufügen",
        "Dodaj zastępstwo w module Zastępstwa lub zmień miesiąc w filtrze listy.": "Fügen Sie eine Vertretung im Modul „Vertretungen“ hinzu oder ändern Sie den Monat im Listenfilter.",
        "Dodaje delikatne tło co drugiemu wierszowi, więc łatwiej śledzić dane poziomo.": "Fügt jede zweite Zeile einen dezenten Hintergrund hinzu, damit sich die Daten leichter horizontal verfolgen lassen.",
        "dodał": "hinzugefügt",
        "dodane": "hinzugefügt",
        "Dodane": "Hinzugefügt",
        "Dodanie": "Hinzufügen",
        "Dodanie dashboardu": "Dashboard hinzufügen",
        "Dodanie roli": "Rolle hinzufügen",
        "Dodanie użytkownika": "Benutzer hinzufügen",
        "Dodanie znaku wodnego": "Wasserzeichen hinzufügen",
        "dodano": "hinzugefügt",
        "Dodano": "Hinzugefügt",
        "dodany": "hinzugefügt",
        "Dodatkowe": "Zusätzliche",
        "Dodatkowe informacje przypisane do Twojego profilu.": "Zusätzliche Informationen zu Ihrem Profil.",
        "Dodatkowy krok przy logowaniu do panelu.": "Zusätzlicher Schritt bei der Anmeldung im Verwaltungsbereich.",
        "Dodatkowy opis treści lub przeznaczenia pliku.": "Zusätzliche Beschreibung des Inhalts oder Verwendungszwecks der Datei.",
        "Dodawanie plików do kolejki": "Dateien zur Warteschlange hinzufügen",
        "Dokument": "Dokument",
        "Dokument ma załączniki": "Dokument enthält Anhänge",
        "Dokument PDF": "PDF-Dokument",
        "Dokument Studio": "Dokument Studio",
        "Dokument tekstowy": "Textdokument",
        "Dół": "Unten",
        "Dołącz": "Anhängen",
        "Dołącz dokument Studio": "Dokument Studio anhängen",
        "Dołącz pliki": "Dateien anhängen",
        "Dołącz stack trace": "Stacktrace anhängen",
        "Dołącz zasób (dokument lub plik)": "Ressource anhängen (Dokument oder Datei)",
        "Dołącza identyfikator i podstawowe dane użytkownika do zdarzenia.": "Fügt der Ereignisbenachrichtigung die ID und grundlegende Benutzerdaten hinzu.",
        "Dołącza pełny stos wywołań do raportu błędu.": "Fügt dem Fehlerbericht den vollständigen Aufrufstapel hinzu.",
        "Domyślna": "Standard",
        "Domyślna ścieżka napisów": "Standard-Untertitelpfad",
        "Domyślne": "Standard",
        "Domyślnie": "Standardmäßig",
        "Domyślny": "Standard",
        "Domyślny dashboard jest otwierany użytkownikom jako pierwszy.": "Das Standard-Dashboard wird Benutzern als Erstes angezeigt.",
        "Domyślny poziom logowania": "Standard-Protokollierungsstufe",
        "Dopasowanie miniatur": "Miniaturbild-Anpassung",
        "Dopasuj miniaturę – pokaż cały obraz": "Miniaturbild anpassen – gesamtes Bild anzeigen",
        "Dostawca": "Anbieter",
        "Dostawcy": "Anbieter",
        "Dostęp": "Zugriff",
        "Dostęp do panelu będzie ograniczony do podanych adresów. Wpisz adresy po przecinku.": "Der Zugriff auf den Verwaltungsbereich wird auf die angegebenen Adressen beschränkt. Geben Sie die Adressen durch Kommas getrennt ein.",
        "Dostęp niezdefiniowany": "Zugriff nicht definiert",
        "Dostępna jest nowa aktualizacja": "Ein neues Update ist verfügbar",
        "Dostępne akcje:": "Verfügbare Aktionen:",
        "Dostępne ikony": "Verfügbare Symbole",
        "Double": "Doppelt",
        "Dowolne": "Beliebige",
        "dowolny": "beliebig",
        "Dozwolone": "Zulässig",
        "Dozwolone są wyłącznie pliki JPEG i PNG.": "Nur JPEG- und PNG-Dateien sind zulässig.",
        "Dozwolone typy: image/jpeg, image/png · max %0 MB": "Zulässige Typen: image/jpeg, image/png · max. %0 MB",
        "Drzewo": "Baum",
        "Dsn": "DSN",
        "Duże litery": "Großbuchstaben",
        "Duże rzymskie": "Große römische Zahlen",
        "Duży układ siatki": "Großes Rasterlayout",
        "Działania dla zaznaczonych elementów": "Aktionen für ausgewählte Elemente",
        "Działania dla zaznaczonych elementów kosza": "Aktionen für ausgewählte Elemente im Papierkorb",
        "Dziedzicz - z ról / domyślne": "Von Rollen übernehmen / Standard",
        "Dziedziczone": "Geerbt",
        "dzień": "Tag",
        "Dziennik zdarzeń": "Ereignisprotokoll",
        "Dziś": "Heute",
        "Dzisiaj": "Heute",
        "E-mail": "E-Mail",
        "E-mail potwierdzony": "E-Mail bestätigt",
        "Edito": "Edito",
        "Edycja aranżacji - podgląd układu na danych demonstracyjnych": "Layout bearbeiten – Layoutvorschau mit Demodaten",
        "Edycja aranżacji dashboardu": "Dashboard-Layout bearbeiten",
        "Edycja Crona · {name}": "Cron bearbeiten · {name}",
        "Edycja dashboardu": "Dashboard bearbeiten",
        "Edycja i publikacja treści": "Inhalte bearbeiten und veröffentlichen",
        "Edycja logów": "Protokolle bearbeiten",
        "Edycja obrazu": "Bild bearbeiten",
        "Edycja roli": "Rolle bearbeiten",
        "Edycja uprawnień": "Berechtigungen bearbeiten",
        "Edycja użytkownika": "Benutzer bearbeiten",
        "Edycja zaznaczonych": "Ausgewählte bearbeiten",
        "Edytor kodu": "Code-Editor",
        "Edytor kodu HTML": "HTML-Code-Editor",
        "Edytor treści": "Inhaltseditor",
        "Edytor treści · pełny ekran": "Inhaltseditor · Vollbild",
        "Edytuj": "Bearbeiten",
        "Edytuj aranżację": "Layout bearbeiten",
        "Edytuj filtr": "Filter bearbeiten",
        "Edytuj link": "Link bearbeiten",
        "Edytuj uprawnienia": "Berechtigungen bearbeiten",
        "Edytuj wiadomość": "Nachricht bearbeiten",
        "Ekran jest zbyt wąski": "Der Bildschirm ist zu schmal",
        "Eksport": "Export",
        "Eksport śladów, metryk i logów do zewnętrznej platformy monitorującej.": "Export von Traces, Metriken und Protokollen auf eine externe Monitoring-Plattform.",
        "Eksportuj przefiltrowanych": "Gefilterte exportieren",
        "Eksportuj wszystkich": "Alle exportieren",
        "Element został przywrócony.": "Das Element wurde wiederhergestellt.",
        "Element został trwale usunięty.": "Das Element wurde endgültig gelöscht.",
        "Elementów na stronie": "Elemente pro Seite",
        "Elementy": "Elemente",
        "Embedding": "Embedding",
        "Embeddingi do wyszukiwania semantycznego.": "Embeddings für die semantische Suche.",
        "Emoji": "Emoji",
        "Endpoint": "Endpunkt",
        "Esc – zamknij podgląd": "Esc – Vorschau schließen",
        "Etap": "Schritt",
        "Etap przetwarzania wiadomości": "Schritt der Nachrichtenverarbeitung",
        "Etap wykonania zadania": "Schritt der Aufgabenausführung",
        "Etykieta napisów": "Untertitelbeschriftung",
        "Etykiety": "Beschriftungen",
        "False": "False",
        "Filtr": "Filter",
        "Filtr widgetu": "Widget-Filter",
        "Filtr zmian": "Änderungsfilter",
        "Filtr został usunięty": "Der Filter wurde gelöscht",
        "Filtry": "Filter",
        "Filtry listy": "Listenfilter",
        "Filtry wyszukiwania": "Suchfilter",
        "Folder": "Ordner",
        "Folder docelowy": "Zielordner",
        "Folder główny": "Stammordner",
        "Folder plików": "Dateiordner",
        "Folderów nie można wstawić w tym miejscu.": "Ordner können an dieser Stelle nicht eingefügt werden.",
        "Foldery": "Ordner",
        "Format obrazów": "Bildformat",
        "Format zapisu": "Speicherformat",
        "Formatowanie": "Formatierung",
        "Formularz": "Formular",
        "Fotografia": "Fotografie",
        "Fragment odpowiedzi": "Antwortausschnitt",
        "Gdy przycisk pobrania zniknął": "Wenn die Download-Schaltfläche verschwunden ist",
        "Generowanie obrazów": "Bildgenerierung",
        "Generowanie obrazów zakończone": "Bildgenerierung abgeschlossen",
        "Generowanie obrazu AI": "KI-Bildgenerierung",
        "Generowanie, edycja i modyfikacja obrazów oraz grafik": "Bilder und Grafiken generieren, bearbeiten und ändern",
        "Generuj": "Generieren",
        "Generuj hasło": "Passwort generieren",
        "Generuj kod QR": "QR-Code generieren",
        "Generuj metadane": "Metadaten generieren",
        "Generuj obraz": "Bild generieren",
        "Globalna polityka 2FA": "Globale 2FA-Richtlinie",
        "Globalny": "Global",
        "godz.": "Std.",
        "Godziny": "Stunden",
        "Google Authenticator, Microsoft Authenticator lub podobna aplikacja TOTP.": "Google Authenticator, Microsoft Authenticator oder eine ähnliche TOTP-App.",
        "Góra": "Oben",
        "Gotowe": "Fertig",
        "gotowy do pracy": "betriebsbereit",
        "Gradient": "Verlauf",
        "Grafana Cloud": "Grafana Cloud",
        "Grubość ramki": "Rahmenstärke",
        "grudzień": "Dezember",
        "Grupa": "Gruppe",
        "Grupuje powiązane usługi w platformie monitorującej.": "Gruppiert zusammengehörige Dienste auf der Monitoring-Plattform.",
        "Grupy zmian": "Änderungsgruppen",
        "Harmonogram jest wykonywany według czasu UTC.": "Der Zeitplan wird nach UTC ausgeführt.",
        "Harmonogram zadań": "Aufgabenplanung",
        "Harmonogram został zmieniony": "Der Zeitplan wurde geändert",
        "Hasła": "Passwörter",
        "Hasła nie są identyczne.": "Die Passwörter stimmen nicht überein.",
        "Hasło": "Passwort",
        "Hasło lub klucz aplikacji dla tego konta.": "Passwort oder Anwendungsschlüssel für dieses Konto.",
        "Hasło musi zawierać co najmniej jeden znak specjalny, np.: ~ @ # $ % ^ & *": "Das Passwort muss mindestens ein Sonderzeichen enthalten, z. B.: ~ @ # $ % ^ & *",
        "Hasło zostało skopiowane.": "Das Passwort wurde kopiert.",
        "Hasło zostało zmienione. Zaloguj się ponownie": "Das Passwort wurde geändert. Melden Sie sich erneut an",
        "high": "Hoch",
        "Historia logowania": "Anmeldeverlauf",
        "Historia rozmów": "Gesprächsverlauf",
        "Historia rozmów została wyczyszczona.": "Der Gesprächsverlauf wurde geleert.",
        "Historia sesji": "Sitzungsverlauf",
        "Historia wersji": "Versionsverlauf",
        "Historia wersji ({count})": "Versionsverlauf ({count})",
        "Historia zadania": "Aufgabenverlauf",
        "Host": "Host",
        "href=\"#\" zwykle jest placeholderem zostawionym po szkicu treści. Na stronie może przewijać użytkownika do góry albo nie robić nic.": "href=\"#\" ist in der Regel ein Platzhalter aus einem Inhaltsentwurf. Auf der Seite kann dadurch zum Seitenanfang gescrollt werden oder es passiert nichts.",
        "i": "und",
        "Id": "ID",
        "ID": "ID",
        "ID lub typ zadania": "Aufgaben-ID oder -Typ",
        "Id modelu": "Modell-ID",
        "Id obiektu": "Objekt-ID",
        "Id sesji": "Sitzungs-ID",
        "ID zadania": "Aufgaben-ID",
        "Identyfikator aplikacji Microsoft Entra.": "Microsoft-Entra-Anwendungs-ID.",
        "Identyfikator dzierżawy Microsoft 365.": "Microsoft-365-Mandanten-ID.",
        "Identyfikator modelu po stronie dostawcy.": "Modell-ID beim Anbieter.",
        "Identyfikator zadania": "Aufgaben-ID",
        "Ignoruj szybkie zapytania SQL": "Schnelle SQL-Abfragen ignorieren",
        "Ikona chmury, płaska ilustracja wektorowa": "Wolkensymbol, flache Vektorillustration",
        "Ikona filtra": "Filtersymbol",
        "Ile ostatnich haseł nie może zostać ponownie użytych (0 = bez ograniczeń).": "Wie viele der zuletzt verwendeten Passwörter nicht wiederverwendet werden dürfen (0 = keine Einschränkung).",
        "Im więcej szczegółów – kompozycja, światło, nastrój – tym lepszy wynik.": "Je mehr Details – Komposition, Licht, Stimmung –, desto besser das Ergebnis.",
        "Imię": "Vorname",
        "Imię i nazwisko": "Vor- und Nachname",
        "Imię i nazwisko autora lub nazwa twórcy materiału.": "Vor- und Nachname des Autors oder Name des Erstellers des Materials.",
        "Import użytkowników": "Benutzer importieren",
        "Indeks dolny": "Tiefgestellt",
        "Indeks górny": "Hochgestellt",
        "Indywidualne": "Individuell",
        "Informacje": "Informationen",
        "Informacje o typie konta i ostatnim logowaniu.": "Informationen zum Kontotyp und zur letzten Anmeldung.",
        "Informacje o zdarzeniu": "Ereignisinformationen",
        "Inspekcja": "Prüfung",
        "Inspekcja będzie dostępna po zapisaniu konta.": "Die Prüfung ist verfügbar, sobald das Konto gespeichert wurde.",
        "Inspekcja nie zwróciła szczegółowych wpisów uprawnień.": "Bei der Prüfung wurden keine detaillierten Berechtigungseinträge gefunden.",
        "Inspekcja uprawnień": "Berechtigungsprüfung",
        "Instalacja": "Installation",
        "Int": "Int",
        "Interlinia": "Zeilenabstand",
        "Jak długo konto pozostaje zablokowane przed kolejną próbą.": "Wie lange das Konto vor einem erneuten Versuch gesperrt bleibt.",
        "Jak korzystać na co dzień": "So verwenden Sie es im Alltag",
        "Jakość": "Qualität",
        "Jakość obrazu": "Bildqualität",
        "Jasność": "Helligkeit",
        "Jeśli program zapyta, zatwierdź zaufanie do projektu i połączenie z serwerem „edito”.": "Wenn Sie dazu aufgefordert werden, bestätigen Sie das Vertrauen in das Projekt und die Verbindung zum Server „edito“.",
        "Jeśli program zapyta, zatwierdź zaufanie do projektu i serwera „edito”.": "Wenn Sie dazu aufgefordert werden, bestätigen Sie das Vertrauen in das Projekt und den Server „edito“.",
        "Jeśli zostawisz szerokość pustą, wyrównanie użyje naturalnej szerokości tabeli.": "Wenn Sie die Breite leer lassen, verwendet die Ausrichtung die natürliche Tabellenbreite.",
        "Język": "Sprache",
        "Język bloku kodu": "Sprache des Codeblocks",
        "Język interfejsu panelu dla tego użytkownika.": "Sprache der Panel-Oberfläche für diesen Benutzer.",
        "Język napisów": "Untertitelsprache",
        "Język zakresu": "Bereichssprache",
        "Kadr. Strzałki przesuwają, Alt i strzałki zmieniają rozmiar. Shift zwiększa krok.": "Zuschneiden. Mit den Pfeiltasten verschieben, mit Alt und den Pfeiltasten die Größe ändern. Mit Umschalt wird der Schritt vergrößert.",
        "Kadrowanie": "Zuschneiden",
        "Kadrowanie obrazu": "Bild zuschneiden",
        "kadrowanie, transformacje, filtry, znak wodny i eksport": "Zuschneiden, Transformationen, Filter, Wasserzeichen und Export",
        "Kalendarz - Kategorie zasobów": "Kalender – Ressourcenkategorien",
        "Katalog został utworzony": "Der Katalog wurde erstellt",
        "Kategorie": "Kategorien",
        "Kategorie powiadomień": "Benachrichtigungskategorien",
        "Kategorie widżetów": "Widget-Kategorien",
        "Każdy": "Jeder",
        "Każdy układ wstawi gotową strukturę z przykładową zawartością, którą możesz od razu nadpisać.": "Jedes Layout fügt eine fertige Struktur mit Beispielinhalten ein, die Sie sofort überschreiben können.",
        "Klasy CSS": "CSS-Klassen",
        "Klienci": "Kunden",
        "Kliknij „Utwórz token”. Po udanym zapisie pozostaw okno otwarte: pojawi się token i sekcja „Połącz Edito z asystentem AI”, potrzebna w następnym kroku.": "Klicken Sie auf „Token erstellen“. Lassen Sie das Fenster nach dem erfolgreichen Speichern geöffnet: Das Token und der Abschnitt „Edito mit dem KI-Assistenten verbinden“ werden angezeigt und im nächsten Schritt benötigt.",
        "Klucz API": "API-Schlüssel",
        "Klucz prywatny": "Privater Schlüssel",
        "Klucz publiczny": "Öffentlicher Schlüssel",
        "Klucz został skopiowany.": "Der Schlüssel wurde kopiert.",
        "Klucze nie są poprawne": "Die Schlüssel sind nicht korrekt",
        "Klucze są nieprawidłowe.": "Die Schlüssel sind ungültig.",
        "Klucze są poprawne": "Die Schlüssel sind korrekt",
        "Klucze są prawidłowe.": "Die Schlüssel sind gültig.",
        "Kod C#": "C#-Code",
        "Kod CSS": "CSS-Code",
        "Kod do osadzenia": "Einbettungscode",
        "Kod HTML": "HTML-Code",
        "Kod JavaScript": "JavaScript-Code",
        "Kod jednorazowy": "Einmalcode",
        "Kod jednorazowy wysyłamy na Twój adres e-mail przy każdym logowaniu.": "Bei jeder Anmeldung senden wir einen Einmalcode an Ihre E-Mail-Adresse.",
        "Kod jest nieprawidłowy lub konfiguracja wygasła. Spróbuj ponownie.": "Der Code ist ungültig oder die Konfiguration ist abgelaufen. Versuchen Sie es erneut.",
        "Kod QR jest gotowy. Zeskanuj go w aplikacji uwierzytelniającej.": "Der QR-Code ist bereit. Scannen Sie ihn mit der Authentifizierungs-App.",
        "Kod QR konfiguracji aplikacji uwierzytelniającej": "QR-Code zur Konfiguration der Authentifizierungs-App",
        "Kod TypeScript": "TypeScript-Code",
        "Kod Vue (Single-File Component)": "Vue-Code (Single-File Component)",
        "Kod weryfikacyjny": "Bestätigungscode",
        "Kod weryfikacyjny jest nieprawidłowy lub wygasł.": "Der Bestätigungscode ist ungültig oder abgelaufen.",
        "Kod weryfikacyjny jest nieprawidłowy.": "Der Bestätigungscode ist ungültig.",
        "Kod z wiadomości został potwierdzony. Nadaj nowe hasło do konta.": "Der Code aus der Nachricht wurde bestätigt. Legen Sie ein neues Kontopasswort fest.",
        "Kod zmienia się co 30 sekund. Upewnij się, że czas na urządzeniu jest prawidłowy.": "Der Code ändert sich alle 30 Sekunden. Stellen Sie sicher, dass die Uhrzeit auf Ihrem Gerät korrekt ist.",
        "Kod źródłowy": "Quellcode",
        "Kohorta": "Kohorte",
        "Kolejka": "Warteschlange",
        "Kolejka wysyłania": "Versandwarteschlange",
        "Koło": "Kreis",
        "Kolor": "Farbe",
        "Kolor tekstu": "Textfarbe",
        "Kolor tła": "Hintergrundfarbe",
        "Kolor widżetu": "Widget-Farbe",
        "Kolor wyróżnia ikonę i linię pod nagłówkiem.": "Die Farbe hebt das Symbol und die Linie unter der Überschrift hervor.",
        "Kolumny": "Spalten",
        "Komentarz": "Kommentar",
        "Komponent React": "React-Komponente",
        "Komunikat": "Nachricht",
        "Kończę odpowiedź...": "Ich beende die Antwort...",
        "Konfiguracja": "Konfiguration",
        "Konfiguracja AI": "KI-Konfiguration",
        "Konfiguracja dashboardu": "Dashboard-Konfiguration",
        "Konfiguracja harmonogramu (czas UTC)": "Zeitplankonfiguration (UTC-Zeit)",
        "Konfiguracja krok po kroku": "Schritt-für-Schritt-Konfiguration",
        "Konfiguracja modułu Studio": "Konfiguration des Studio-Moduls",
        "Konfiguracja została zmieniona.": "Die Konfiguration wurde geändert.",
        "Konsola aplikacji": "Anwendungskonsole",
        "Konsola aplikacji nigdy nie rejestruje logów z poniższych przestrzeni nazw:": "Die Anwendungskonsole protokolliert niemals Logs aus den folgenden Namespaces:",
        "Konta użytkowników zostały odblokowane": "Benutzerkonten wurden entsperrt",
        "Konta użytkowników zostały usunięte z systemu": "Benutzerkonten wurden aus dem System gelöscht",
        "Konta użytkowników zostały zablokowane": "Benutzerkonten wurden gesperrt",
        "Kontakty - Typ działania": "Kontakte – Aktionstyp",
        "Konto": "Konto",
        "Konto aktywne": "Konto aktiv",
        "Konto pozostanie nieaktywne, dopóki adres e-mail nie zostanie potwierdzony.": "Das Konto bleibt inaktiv, bis die E-Mail-Adresse bestätigt wurde.",
        "Konto z dostępem do panelu": "Konto mit Zugriff auf das Dashboard",
        "Konto zanonimizowane": "Konto anonymisiert",
        "Konto, z którego wysyłana jest poczta.": "Konto, von dem aus E-Mails versendet werden.",
        "Kontrast": "Kontrast",
        "Kontrolowany": "Kontrolliert",
        "Kopiuj": "Kopieren",
        "Kopiuj hasło": "Passwort kopieren",
        "Kopiuj identyfikator rozmowy": "Gesprächs-ID kopieren",
        "Kopiuj klucz": "Schlüssel kopieren",
        "Kopiuj link": "Link kopieren",
        "Kopiuj odpowiedź": "Antwort kopieren",
        "Kopiuj pole": "Feld kopieren",
        "Kopiuj polecenie": "Befehl kopieren",
        "Korzystasz z właściwego panelu i tokenu opisanego swoim imieniem i nazwiskiem.": "Sie verwenden das richtige Dashboard und den Token, der mit Ihrem Vor- und Nachnamen gekennzeichnet ist.",
        "Kosz": "Papierkorb",
        "Kosz został opróżniony.": "Der Papierkorb wurde geleert.",
        "Kotwica": "Anker",
        "Krój czcionki": "Schriftart",
        "Kroki konfiguracji MCP": "MCP-Konfigurationsschritte",
        "kroków": "Schritte",
        "Kropki": "Punkte",
        "Krótki opis obrazu…": "Kurze Bildbeschreibung…",
        "Krótki opis ułatwia rozpoznanie przeznaczenia dashboardu.": "Eine kurze Beschreibung erleichtert es, den Zweck des Dashboards zu erkennen.",
        "Krótki opis zawartości obrazu, odczytywany przez czytniki ekranu.": "Kurze Beschreibung des Bildinhalts, die von Screenreadern vorgelesen wird.",
        "Krótko, czego dotyczy ten dashboard…": "Kurz gesagt: Worum geht es in diesem Dashboard…",
        "Kursywa": "Kursiv",
        "Kwadraty": "Quadrate",
        "kwiecień": "april",
        "Ładowanie": "Wird geladen",
        "Ładowanie logo witryn...": "Website-Logos werden geladen...",
        "Ładowanie obrazu...": "Bild wird geladen...",
        "Laptop na biurku, minimalistyczna kompozycja": "Laptop auf einem Schreibtisch, minimalistische Komposition",
        "lat": "Jahre",
        "lata": "Jahre",
        "Lawendowy": "Lavendel",
        "Legenda": "Legende",
        "Lewo": "Links",
        "Lewy dolny": "Unten links",
        "Lewy górny": "Oben links",
        "Lewy panel": "Linkes Bedienfeld",
        "Licencja": "Lizenz",
        "Liczba": "Anzahl",
        "Liczba nieudanych prób logowania, po której konto zostaje zablokowane.": "Anzahl fehlgeschlagener Anmeldeversuche, nach denen das Konto gesperrt wird.",
        "Liczba obrazów": "Anzahl der Bilder",
        "Licznik kolejnych błędnych prób logowania.": "Zähler für aufeinanderfolgende fehlgeschlagene Anmeldeversuche.",
        "Limonkowy": "Limettengrün",
        "Linia": "Linie",
        "Linia pozioma": "Horizontale Linie",
        "Linie": "Linien",
        "Link": "Link",
        "Link bez adresu": "Link ohne Zieladresse",
        "Link bez adresu wygląda jak aktywny element, ale nie prowadzi użytkownika do celu.": "Ein Link ohne Zieladresse sieht wie ein aktives Element aus, führt den Benutzer aber nicht zum Ziel.",
        "Link bez tekstu": "Link ohne Text",
        "Link do admina": "Admin-Link",
        "Link do dokumentu": "Link zum Dokument",
        "Link skopiowany do schowka.": "Link in die Zwischenablage kopiert.",
        "Link w treści publicznej nie powinien prowadzić do panelu.": "Ein Link in einem öffentlichen Inhalt sollte nicht zum Dashboard führen.",
        "Link z href=\"#\"": "Link mit href=\"#\"",
        "Lint nie znalazł problemów w tej treści.": "Lint hat keine Probleme in diesem Inhalt gefunden.",
        "Lint treści": "Inhaltsprüfung",
        "lipiec": "juli",
        "Lista kontrolna": "Checkliste",
        "Lista miejsc użycia została ograniczona.": "Die Liste der Verwendungsorte wurde eingeschränkt.",
        "Lista nie zawiera jeszcze żadnych elementów.": "Die Liste enthält noch keine Elemente.",
        "Lista numerowana": "Nummerierte Liste",
        "Lista punktowana": "Aufzählungsliste",
        "Lista rozmów jest teraz niedostępna. Spróbuj pobrać ją ponownie. Jeśli problem się powtarza, sprawdź połączenie z siecią lub spróbuj później.": "Die Gesprächsliste ist derzeit nicht verfügbar. Versuchen Sie, sie erneut abzurufen. Wenn das Problem weiterhin auftritt, überprüfen Sie Ihre Netzwerkverbindung oder versuchen Sie es später erneut.",
        "Lista rozmów odświeżona": "Gesprächsliste aktualisiert",
        "Lista rozmów została pobrana. Możesz wybrać rozmowę z panelu historii.": "Die Gesprächsliste wurde abgerufen. Sie können im Verlaufsbereich ein Gespräch auswählen.",
        "Lista zaufanych adresów IP": "Liste vertrauenswürdiger IP-Adressen",
        "listopad": "november",
        "Listy": "Listen",
        "Log zadania został skopiowany.": "Das Aufgabenprotokoll wurde kopiert.",
        "Logi poniżej tego poziomu nie będą zbierane niezależnie od pozostałych ustawień.": "Protokolle unterhalb dieser Stufe werden unabhängig von den übrigen Einstellungen nicht erfasst.",
        "Logi wydajnościowe": "Leistungsprotokolle",
        "Login do panelu, unikalny w całej instancji.": "Anmeldename für das Panel, innerhalb der gesamten Instanz eindeutig.",
        "Logo": "Logo",
        "Logo witryny": "Website-Logo",
        "Logowanie": "Anmeldung",
        "Logowanie nazwą użytkownika i hasłem.": "Anmeldung mit Benutzername und Passwort.",
        "Logowanie zakończyło się niepowodzeniem.": "Die Anmeldung ist fehlgeschlagen.",
        "Logowanie zdarzeń": "Ereignisprotokollierung",
        "Lokalizacja": "Standort",
        "Lokalne": "Lokal",
        "Long": "Lang",
        "low": "niedrig",
        "Low‑poly": "Low-Poly",
        "Lub wybierz zakres": "Oder wählen Sie einen Bereich aus",
        "luty": "Februar",
        "macOS: w folderze „Pobrane” kliknij ZIP dwukrotnie.": "macOS: Doppelklicken Sie im Ordner „Downloads“ auf die ZIP-Datei.",
        "maj": "Mai",
        "Maksymalna rozdzielczość: %0 × %1 px.": "Maximale Auflösung: %0 × %1 px.",
        "Maksymalna szerokość ekranu (px)": "Maximale Bildschirmbreite (px)",
        "Maksymalny czas trwania zapytania uznawanego za szybkie (ms)": "Maximale Dauer einer Abfrage, die als schnell gilt (ms)",
        "Maksymalny rozmiar jednego pliku to 20 MB.": "Die maximale Größe einer Datei beträgt 20 MB.",
        "Małe litery": "Kleinbuchstaben",
        "Małe rzymskie": "Kleine römische Zahlen",
        "Malejąco": "Absteigend",
        "Mały układ siatki": "Kleines Rasterlayout",
        "Margines dolny": "Unterer Rand",
        "Margines górny": "Oberer Rand",
        "marzec": "März",
        "Masz niezapisane zmiany.": "Sie haben nicht gespeicherte Änderungen.",
        "Materiały dodatkowe": "Zusätzliches Material",
        "Media": "Medien",
        "medium": "mittel",
        "Medium": "Mittel",
        "Menu": "Menü",
        "Menu konta": "Kontomenü",
        "Menu kontekstowe edytora": "Kontextmenü des Editors",
        "Menu: %0": "Menü: %0",
        "Metadane pliku": "Dateimetadaten",
        "Metoda autentykacji": "Authentifizierungsmethode",
        "Metoda weryfikacji": "Verifizierungsmethode",
        "Microsoft Aspire": "Microsoft Aspire",
        "mies.": "Mon.",
        "Miesiąc": "Monat",
        "Miesiące": "Monate",
        "Mieszane": "Gemischt",
        "Miętowy": "Mintgrün",
        "min": "Min.",
        "min. 8 znaków": "mind. 8 Zeichen",
        "Miniatura artykułu {title}": "Artikel-Miniaturansicht {title}",
        "Minimalizuj": "Minimieren",
        "Minimalna długość hasła": "Mindestlänge des Passworts",
        "Minuty": "Minuten",
        "Mocniejsze obramowanie": "Stärkerer Rahmen",
        "Model": "Modell",
        "Model użyty przez panel dla każdego rodzaju zadania.": "Das vom Panel für jede Aufgabenart verwendete Modell.",
        "Modele": "Modelle",
        "Modele pochodzą z konfiguracji wybranego dostawcy.": "Die Modelle stammen aus der Konfiguration des ausgewählten Anbieters.",
        "Modele udostępnione w panelu wraz z ich możliwościami.": "Im Panel verfügbare Modelle und ihre Funktionen.",
        "Moduł": "Modul",
        "Modyfikacja": "Änderung",
        "Modyfikacja obrazu przed wysłaniem": "Bild vor dem Hochladen bearbeiten",
        "Modyfikuj obrazy przed wysłaniem": "Bilder vor dem Hochladen bearbeiten",
        "Moje": "Meine",
        "Moje pliki": "Meine Dateien",
        "Monitor kolejek": "Warteschlangenmonitor",
        "Monitoring": "Überwachung",
        "Monitoring aplikacji": "Anwendungsüberwachung",
        "Monitorowane adresy URL dla żądań HTTP": "Überwachte URLs für HTTP-Anfragen",
        "Monitoruj bazy danych (SQL, Redis, ElasticSearch)": "Datenbanken überwachen (SQL, Redis, ElasticSearch)",
        "Monitoruj statystyki .NET": ".NET-Statistiken überwachen",
        "Monitoruj żądania HTTP": "HTTP-Anfragen überwachen",
        "Morelowy": "Aprikosenfarben",
        "Możesz dołączyć maksymalnie {0} zasobów.": "Sie können maximal {0} Ressourcen anhängen.",
        "Możesz dołączyć maksymalnie 4 pliki.": "Sie können maximal 4 Dateien anhängen.",
        "Możesz dołączyć obrazy oraz pliki PDF, DOCX, XLSX, TXT, MD i CSV.": "Sie können Bilder sowie PDF-, DOCX-, XLSX-, TXT-, MD- und CSV-Dateien anhängen.",
        "Możesz przeciągnąć tutaj kolejne pliki": "Sie können weitere Dateien hierher ziehen",
        "Możesz wybrać maksymalnie %0 plików.": "Sie können maximal %0 Dateien auswählen.",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Die Möglichkeit, dieses Konto zu bearbeiten, ist eingeschränkt. Inaktive Felder werden mit der externen Datenbank %0 synchronisiert.",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "Die Möglichkeit, dieses Konto zu bearbeiten, ist eingeschränkt. Inaktive Felder werden mit der externen Datenbank %0 synchronisiert.",
        "Możliwość zmiany hasła jest zablokowana. Obsługa hasła znajduje się po stronie zewnętrznej bazy danych %0.": "Die Möglichkeit, das Passwort zu ändern, ist gesperrt. Die Passwortverwaltung erfolgt über die externe Datenbank %0.",
        "Możliwości": "Funktionen",
        "Możliwości wybranego modelu": "Funktionen des ausgewählten Modells",
        "Mroczne fantasy": "Dark Fantasy",
        "Multimedia": "Multimedia",
        "Na liście tokenów kliknij „Dodaj token”. W otwartym oknie znajdziesz formularz nowego połączenia.": "Klicken Sie in der Tokenliste auf „Token hinzufügen“. Im geöffneten Fenster finden Sie das Formular für eine neue Verbindung.",
        "Na ten adres trafi wiadomość testowa.": "An diese Adresse wird eine Testnachricht gesendet.",
        "Naciśnij spację lub Enter, aby podnieść widget. Użyj strzałek oraz klawiszy Home i End, następnie naciśnij spację lub Enter, aby zatwierdzić. Escape anuluje zmianę.": "Drücken Sie die Leertaste oder die Eingabetaste, um das Widget anzuheben. Verwenden Sie die Pfeiltasten sowie die Tasten Pos1 und Ende und drücken Sie anschließend die Leertaste oder die Eingabetaste, um die Änderung zu bestätigen. Mit Escape brechen Sie die Änderung ab.",
        "Nadaj roli nazwę i określ sposób jej przypisywania.": "Geben Sie der Rolle einen Namen und legen Sie fest, wie sie zugewiesen wird.",
        "Nadane bezpośrednio": "Direkt zugewiesen",
        "Nadawca": "Absender",
        "Nagłówek": "Kopfzeile",
        "Nagłówek dostaje ciemne tło i mocniejszy kontrast, więc od razu odróżnia się od danych.": "Die Kopfzeile erhält einen dunklen Hintergrund und einen stärkeren Kontrast und hebt sich dadurch sofort von den Daten ab.",
        "Nagłówek komórki": "Zellenüberschrift",
        "Nagłówki HTTP": "HTTP-Header",
        "Najczęściej 587 lub 465.": "Am häufigsten 587 oder 465.",
        "Najczęstsze problemy": "Häufigste Probleme",
        "Najkrótsze hasło, jakie użytkownik może ustawić.": "Das kürzeste Passwort, das ein Benutzer festlegen kann.",
        "Najpierw ustaw obraz główny.": "Legen Sie zuerst das Hauptbild fest.",
        "Najpierw zapisz wprowadzone zmiany": "Speichern Sie zuerst die vorgenommenen Änderungen",
        "Napisy WebVTT": "WebVTT-Untertitel",
        "Napisz wiadomość...": "Nachricht schreiben...",
        "Narzędzia": "Werkzeuge",
        "Następna strona": "Nächste Seite",
        "Następne trafienie": "Nächster Treffer",
        "Następny miesiąc": "Nächster Monat",
        "Następny plik": "Nächste Datei",
        "Następny rok": "Nächstes Jahr",
        "Nasycenie": "Sättigung",
        "Natychmiast przywraca domyślny harmonogram zadania i zapisuje tę zmianę. Zamyka okno bez potrzeby klikania „Zapisz”.": "Stellt sofort den Standardzeitplan der Aufgabe wieder her und speichert diese Änderung. Schließt das Fenster, ohne dass Sie auf „Speichern“ klicken müssen.",
        "Nawigacja mobilna": "Mobile Navigation",
        "Nazwa": "Name",
        "Nazwa będzie widoczna na liście dashboardów i w nagłówku widoku.": "Der Name wird in der Dashboard-Liste und in der Ansichtskopfzeile angezeigt.",
        "Nazwa dashboardu": "Dashboardname",
        "Nazwa identyfikująca aplikację w narzędziu monitorującym.": "Name, der die Anwendung im Überwachungstool identifiziert.",
        "Nazwa katalogu": "Verzeichnisname",
        "Nazwa katalogu została zmieniona.": "Der Verzeichnisname wurde geändert.",
        "Nazwa licencji lub informacja o prawach do wykorzystania materiału.": "Lizenzname oder Angaben zu den Nutzungsrechten des Materials.",
        "Nazwa nadawcy": "Absendername",
        "Nazwa nowego pliku": "Name der neuen Datei",
        "Nazwa nowych plików": "Name der neuen Dateien",
        "Nazwa pliku": "Dateiname",
        "Nazwa pliku została zmieniona.": "Der Dateiname wurde geändert.",
        "Nazwa pola": "Feldname",
        "Nazwa roli": "Rollenname",
        "Nazwa rozmowy": "Name der Unterhaltung",
        "Nazwa typu": "Typname",
        "Nazwa urządzenia": "Gerätename",
        "Nazwa urządzenia została zmieniona.": "Der Gerätename wurde geändert.",
        "Nazwa usługi": "Dienstname",
        "Nazwa użytkownika": "Benutzername",
        "Nazwa używana do logowania i identyfikacji konta.": "Name, der zur Anmeldung und zur Identifizierung des Kontos verwendet wird.",
        "Nazwa widoczna na liście ról i w ustawieniach użytkownika.": "Name, der in der Rollenliste und in den Benutzereinstellungen angezeigt wird.",
        "Nazwa widoczna przy wyborze modelu dla zadań.": "Name, der bei der Modellauswahl für Aufgaben angezeigt wird.",
        "Nazwa widoczna w nagłówku widżetu.": "Name, der in der Widget-Kopfzeile angezeigt wird.",
        "Nazwa wyświetlana": "Anzeigename",
        "Nazwa wyświetlana w aplikacji uwierzytelniającej": "Name, der in der Authentifizierungs-App angezeigt wird",
        "Nazwa zadania": "Aufgabenname",
        "Nazwa zestawu": "Name des Satzes",
        "nazwa-kotwicy": "Ankername",
        "Nazwij połączenie i określ ważność dostępu.": "Benennen Sie die Verbindung und legen Sie die Gültigkeitsdauer des Zugriffs fest.",
        "Nazwij urządzenie, zeskanuj kod QR i potwierdź kodem z aplikacji.": "Benennen Sie das Gerät, scannen Sie den QR-Code und bestätigen Sie mit dem Code aus der App.",
        "Nazwisko": "Nachname",
        "Nie": "Nein",
        "Nie dodano jeszcze wariantów responsywnych": "Es wurden noch keine responsiven Varianten hinzugefügt",
        "Nie dotyczy plików SVG i ICO.": "Gilt nicht für SVG- und ICO-Dateien.",
        "Nie jesteś zalogowany albo sesja straciła ważność.\nZaloguj się ponownie, aby wrócić do panelu.": "Sie sind nicht angemeldet oder Ihre Sitzung ist abgelaufen.\nMelden Sie sich erneut an, um zum Dashboard zurückzukehren.",
        "Nie ma dostępnych kluczy do wstawienia w treści.": "Es sind keine Schlüssel zum Einfügen in den Inhalt verfügbar.",
        "Nie ma zapisanych wpisów uprawnień do wyświetlenia.": "Es sind keine Berechtigungseinträge zum Anzeigen gespeichert.",
        "Nie masz jeszcze ostatnio używanych emoji.": "Sie haben noch keine zuletzt verwendeten Emojis.",
        "Nie masz uprawnień do panelu administracyjnego.": "Sie haben keine Berechtigung für das Administrationspanel.",
        "Nie masz uprawnień do tego widoku. Stan widoku mógł ulec zmianie, odśwież i sprawdź lub spróbuj ponownie później.": "Sie haben keine Berechtigung für diese Ansicht. Der Ansichtsstatus wurde möglicherweise geändert. Aktualisieren Sie die Seite und überprüfen Sie den Status oder versuchen Sie es später erneut.",
        "Nie możesz modyfikować profilu zastępowanego użytkownika.": "Sie können das Profil des vertretenen Benutzers nicht bearbeiten.",
        "Nie możesz modyfikować uprawnień": "Sie können die Berechtigungen nicht bearbeiten",
        "Nie możesz usunąć jedynego urządzenia, gdy aktywna metoda 2FA to Aplikacja uwierzytelniająca. Przełącz na metodę Email, aby móc usunąć to urządzenie.": "Sie können das einzige Gerät nicht entfernen, solange die Authentifizierungs-App als aktive 2FA-Methode festgelegt ist. Wechseln Sie zur E-Mail-Methode, um dieses Gerät entfernen zu können.",
        "Nie możesz usunąć jedynego urządzenia, gdy aktywna metoda 2FA to Aplikacja uwierzytelniająca. Wyłącz 2FA lub przełącz na metodę Email, aby móc usunąć to urządzenie.": "Sie können das einzige Gerät nicht entfernen, solange die Authentifizierungs-App als aktive 2FA-Methode festgelegt ist. Deaktivieren Sie 2FA oder wechseln Sie zur E-Mail-Methode, um dieses Gerät entfernen zu können.",
        "Nie możesz usunąć jedynego urządzenia, gdy weryfikacja przez aplikację uwierzytelniającą jest wymagana przez system.": "Sie können das einzige Gerät nicht entfernen, wenn die Überprüfung über die Authentifizierungs-App vom System vorgeschrieben ist.",
        "Nie można cofnąć tej zmiany.": "Diese Änderung kann nicht rückgängig gemacht werden.",
        "Nie można dodać pliku \"%0\" z powodu: %1.": "Die Datei \"%0\" konnte aus folgendem Grund nicht hinzugefügt werden: %1.",
        "Nie można odczytać zapisanego zestawu.": "Der gespeicherte Satz konnte nicht gelesen werden.",
        "Nie można usunąć swojego konta.": "Sie können Ihr eigenes Konto nicht löschen.",
        "Nie można wysłać kodu. Spróbuj zalogować się ponownie.": "Der Code konnte nicht gesendet werden. Versuchen Sie, sich erneut anzumelden.",
        "Nie można wyświetlić podglądu pliku. Wybierz inny plik.": "Die Dateivorschau konnte nicht angezeigt werden. Wählen Sie eine andere Datei aus.",
        "Nie można zainicjować konfiguracji. Spróbuj ponownie.": "Die Konfiguration konnte nicht initialisiert werden. Versuchen Sie es erneut.",
        "Nie pamiętam hasła": "Ich habe mein Passwort vergessen",
        "Nie pokazuj tokenu ani plików konfiguracyjnych w rozmowach lub na zrzutach ekranu.": "Zeigen Sie das Token oder die Konfigurationsdateien nicht in Unterhaltungen oder auf Screenshots.",
        "Nie pomijaj poziomów nagłówków. Po H2 użyj H3, po H3 użyj H4 itd.": "Überspringen Sie keine Überschriftenebenen. Verwenden Sie nach H2 H3, nach H3 H4 usw.",
        "Nie przechowuj folderu we współdzielonym OneDrive, SharePoint ani na dysku sieciowym.": "Speichern Sie den Ordner nicht auf einem freigegebenen OneDrive, SharePoint oder Netzlaufwerk.",
        "Nie udało się — ponów": "Fehlgeschlagen – erneut versuchen",
        "Nie udało się cofnąć": "Rückgängigmachen fehlgeschlagen",
        "Nie udało się odtworzyć wybranych plików.": "Die ausgewählten Dateien konnten nicht wiederhergestellt werden.",
        "Nie udało się otworzyć pliku w repozytorium.": "Die Datei konnte nicht im Repository geöffnet werden.",
        "Nie udało się otworzyć rozmowy.": "Die Unterhaltung konnte nicht geöffnet werden.",
        "Nie udało się otworzyć strony": "Die Seite konnte nicht geöffnet werden",
        "Nie udało się pobrać danych ankiet.": "Die Umfragedaten konnten nicht abgerufen werden.",
        "Nie udało się pobrać danych o użytkownikach.": "Die Benutzerdaten konnten nicht abgerufen werden.",
        "Nie udało się pobrać danych produktowych.": "Die Produktdaten konnten nicht abgerufen werden.",
        "Nie udało się pobrać danych z CMS.": "Die Daten aus dem CMS konnten nicht abgerufen werden.",
        "Nie udało się pobrać danych z Google Analytics.": "Die Daten aus Google Analytics konnten nicht abgerufen werden.",
        "Nie udało się pobrać danych z modułu dynamicznego.": "Die Daten aus dem dynamischen Modul konnten nicht abgerufen werden.",
        "Nie udało się pobrać danych ze sklepu.": "Die Daten aus dem Shop konnten nicht abgerufen werden.",
        "Nie udało się pobrać dziennika.": "Das Protokoll konnte nicht abgerufen werden.",
        "Nie udało się pobrać konfiguracji AI. Sprawdź połączenie i spróbuj ponownie.": "Die KI-Konfiguration konnte nicht abgerufen werden. Überprüfen Sie die Verbindung und versuchen Sie es erneut.",
        "Nie udało się pobrać konfiguracji dashboardu": "Die Dashboard-Konfiguration konnte nicht abgerufen werden",
        "Nie udało się pobrać listy filtrów": "Die Filterliste konnte nicht abgerufen werden",
        "Nie udało się pobrać listy kolejek": "Die Warteschlangenliste konnte nicht abgerufen werden",
        "Nie udało się pobrać listy ról": "Die Rollenliste konnte nicht abgerufen werden",
        "Nie udało się pobrać listy typów modeli": "Die Liste der Modelltypen konnte nicht abgerufen werden",
        "Nie udało się pobrać listy zastępstw.": "Die Liste der Vertretungen konnte nicht abgerufen werden.",
        "Nie udało się pobrać miejsc użycia pliku.": "Die Verwendungsorte der Datei konnten nicht abgerufen werden.",
        "Nie udało się pobrać uprawnień użytkownika. Spróbuj ponownie.": "Die Berechtigungen des Benutzers konnten nicht abgerufen werden. Versuchen Sie es erneut.",
        "Nie udało się pobrać wersji do porównania.": "Die Versionen zum Vergleichen konnten nicht abgerufen werden.",
        "Nie udało się pobrać widżetów": "Die Widgets konnten nicht abgerufen werden",
        "Nie udało się połączyć z asystentem. Sprawdź połączenie sieciowe.": "Die Verbindung zum Assistenten konnte nicht hergestellt werden. Überprüfen Sie Ihre Netzwerkverbindung.",
        "Nie udało się przenieść plików.": "Die Dateien konnten nicht verschoben werden.",
        "Nie udało się przeszukać dokumentów": "Die Dokumente konnten nicht durchsucht werden",
        "Nie udało się przygotować akcji — rozmowa została odświeżona.": "Die Aktion konnte nicht vorbereitet werden – die Unterhaltung wurde aktualisiert.",
        "Nie udało się skopiować dziennika.": "Das Protokoll konnte nicht kopiert werden.",
        "Nie udało się skopiować klucza. Skopiuj go ręcznie.": "Der Schlüssel konnte nicht kopiert werden. Kopieren Sie ihn manuell.",
        "Nie udało się skopiować polecenia. Zaznacz i skopiuj tekst ręcznie.": "Der Befehl konnte nicht kopiert werden. Markieren und kopieren Sie den Text manuell.",
        "Nie udało się ukończyć operacji": "Der Vorgang konnte nicht abgeschlossen werden",
        "Nie udało się uruchomić asystenta.": "Der Assistent konnte nicht gestartet werden.",
        "Nie udało się usunąć rozmowy.": "Das Gespräch konnte nicht gelöscht werden.",
        "Nie udało się usunąć szablonu": "Die Vorlage konnte nicht gelöscht werden",
        "Nie udało się wczytać aranżacji dashboardu": "Das Dashboard-Layout konnte nicht geladen werden",
        "Nie udało się wczytać opcji. Otwórz listę ponownie, aby spróbować jeszcze raz.": "Die Optionen konnten nicht geladen werden. Öffnen Sie die Liste erneut, um es noch einmal zu versuchen.",
        "Nie udało się wczytać ról": "Die Rollen konnten nicht geladen werden",
        "Nie udało się wczytać rozmów": "Die Gespräche konnten nicht geladen werden",
        "Nie udało się wczytać szczegółów zdarzenia.": "Die Ereignisdetails konnten nicht geladen werden.",
        "Nie udało się wczytać uprawnień": "Die Berechtigungen konnten nicht geladen werden",
        "Nie udało się wczytać uprawnień.": "Die Berechtigungen konnten nicht geladen werden.",
        "Nie udało się wczytać zawartości folderu.": "Der Inhalt des Ordners konnte nicht geladen werden.",
        "Nie udało się wczytać zestawów.": "Die Sammlungen konnten nicht geladen werden.",
        "Nie udało się wyczyścić historii rozmów.": "Der Gesprächsverlauf konnte nicht gelöscht werden.",
        "Nie udało się wykonać edycji zaznaczonych obrazów.": "Die ausgewählten Bilder konnten nicht bearbeitet werden.",
        "Nie udało się wykonać planu.": "Der Plan konnte nicht ausgeführt werden.",
        "Nie udało się wysłać pliku": "Die Datei konnte nicht gesendet werden",
        "Nie udało się wysłać pliku. Sprawdź połączenie.": "Die Datei konnte nicht gesendet werden. Überprüfen Sie Ihre Verbindung.",
        "Nie udało się zaktualizować zestawu.": "Die Sammlung konnte nicht aktualisiert werden.",
        "Nie udało się załadować danych": "Die Daten konnten nicht geladen werden",
        "Nie udało się załadować elementów": "Die Elemente konnten nicht geladen werden",
        "Nie udało się zapisać obrazu.": "Das Bild konnte nicht gespeichert werden.",
        "Nie udało się zapisać oceny.": "Die Bewertung konnte nicht gespeichert werden.",
        "Nie udało się zapisać ustawień dashboardu": "Die Dashboard-Einstellungen konnten nicht gespeichert werden",
        "Nie udało się zapisać zestawu.": "Die Sammlung konnte nicht gespeichert werden.",
        "Nie udało się zmienić nazwy rozmowy.": "Das Gespräch konnte nicht umbenannt werden.",
        "Nie udało się zmienić trybu działania.": "Der Betriebsmodus konnte nicht geändert werden.",
        "Nie udostępniaj paczki ani folderu innym osobom, również przez e-mail lub komunikator.": "Geben Sie das Paket oder den Ordner nicht an andere Personen weiter, auch nicht per E-Mail oder Messenger.",
        "Nie ustawiono tego uprawnienia. Dostęp może wynikać z innych przypisań.": "Diese Berechtigung wurde nicht festgelegt. Der Zugriff kann sich aus anderen Zuweisungen ergeben.",
        "Nie używaj paczki innej osoby ani paczki z innej instancji Edito.": "Verwenden Sie weder das Paket einer anderen Person noch ein Paket aus einer anderen Edito-Instanz.",
        "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "Nicht alle ausgewählten Elemente wurden verschoben. Sie verfügen nicht über die erforderlichen Berechtigungen oder, beim Verschieben von Verzeichnissen, das Zielverzeichnis ist ein Unterverzeichnis des Quellverzeichnisses. Verzeichnisse und Dateien, die nicht verschoben werden konnten, befinden sich weiterhin im Tab „Ausgewählt“.",
        "Nie wybrano ikony": "Kein Symbol ausgewählt",
        "Nie wybrano jeszcze plików": "Es wurden noch keine Dateien ausgewählt",
        "Nie wybrano obrazu do edycji": "Kein Bild zur Bearbeitung ausgewählt",
        "Nie wybrano plików": "Keine Dateien ausgewählt",
        "Nie wybrano pliku": "Keine Datei ausgewählt",
        "Nie wybrano żadnego użytkownika.": "Es wurde kein Benutzer ausgewählt.",
        "Nie wykonano": "Nicht ausgeführt",
        "nie wymuszaj zmiany hasła": "Passwortänderung nicht erzwingen",
        "Nie zdefiniowano jeszcze ról użytkowników.": "Es wurden noch keine Benutzerrollen definiert.",
        "Nie znaleziono pasujących elementów.": "Keine passenden Elemente gefunden.",
        "Nie znaleziono strony": "Seite nicht gefunden",
        "Nie znaleziono właściwego widgetu": "Kein passendes Widget gefunden",
        "Nie znaleziono wyników dla „%0”": "Keine Ergebnisse für „%0“ gefunden",
        "Nie znaleziono wyników.": "Keine Ergebnisse gefunden.",
        "Nieaktywna": "Inaktiv",
        "Nieaktywne": "Inaktiv",
        "Nieaktywni": "Inaktive",
        "Nieaktywny": "Inaktiv",
        "Nieaktywny dashboard pozostaje zapisany, ale nie jest dostępny do użycia.": "Das inaktive Dashboard bleibt gespeichert, steht aber nicht zur Verwendung zur Verfügung.",
        "Niebieski": "Blau",
        "niedozwolone rozszerzenie pliku (%0)": "unzulässige Dateierweiterung (%0)",
        "niedozwolony typ pliku (%0)": "unzulässiger Dateityp (%0)",
        "Niemiecki": "Deutsch",
        "Niepotwierdzeni": "Unbestätigte",
        "Niepowodzenie": "Fehlgeschlagen",
        "Nieprawidłowy adres email": "Ungültige E-Mail-Adresse",
        "Nieprawidłowy adres URL": "Ungültige URL",
        "Nieprawidłowy format. Użyj np. 13px, 18px, 90%": "Ungültiges Format. Verwenden Sie z. B. 13px, 18px, 90%",
        "Nieprawidłowy format. Użyj np. 16px, 24px, 90%": "Ungültiges Format. Verwenden Sie z. B. 16px, 24px, 90%",
        "Nieprzeczytane": "Ungelesen",
        "Nieprzydatna": "Nicht hilfreich",
        "Nieprzydatna odpowiedź": "Nicht hilfreiche Antwort",
        "nieprzydatne": "nicht hilfreich",
        "Nietrafiona odpowiedź": "Unpassende Antwort",
        "Nieudane logowania": "Fehlgeschlagene Anmeldungen",
        "Nieustawione": "Nicht festgelegt",
        "Niezapisane zmiany": "Nicht gespeicherte Änderungen",
        "Nieznane": "Unbekannt",
        "Nieznany stan": "Unbekannter Status",
        "Nieznany typ pliku": "Unbekannter Dateityp",
        "Nieznany użytkownik": "Unbekannter Benutzer",
        "Nikomu nie przydzielono uprawnień.": "Niemandem wurden Berechtigungen zugewiesen.",
        "Nowa rozmowa": "Neues Gespräch",
        "Nowa wartość": "Neuer Wert",
        "Nowe hasło": "Neues Passwort",
        "Nowe hasło użytkownika. Pozostaw puste, aby go nie zmieniać.": "Neues Benutzerpasswort. Lassen Sie das Feld leer, um es nicht zu ändern.",
        "Nowe pliki zostały zapisane.": "Die neuen Dateien wurden gespeichert.",
        "Nowy folder": "Neuer Ordner",
        "Nowy folder w bieżącym katalogu": "Neuer Ordner im aktuellen Verzeichnis",
        "Nowy katalog powstanie w:": "Das neue Verzeichnis wird erstellt in:",
        "Np. 820": "Z. B. 820",
        "np. Edito": "z. B. Edito",
        "np. iPhone": "z. B. iPhone",
        "np. Sprzedaż — podsumowanie": "z. B. Vertrieb – Zusammenfassung",
        "np. Zestawienie wyników za Q1": "z. B. Ergebnisübersicht für Q1",
        "Numer sesji": "Sitzungsnummer",
        "Numer telefonu": "Telefonnummer",
        "Numeracja prawnicza": "Juristische Nummerierung",
        "O godzinach": "Zu den Uhrzeiten",
        "OAuth2 dla Exchange Online": "OAuth2 für Exchange Online",
        "Obecny kolor": "Aktuelle Farbe",
        "Obiekt %0 został %1": "Das Objekt %0 wurde %1",
        "Obiekt JSON": "JSON-Objekt",
        "Obraz": "Bild",
        "Obraz bez alt": "Bild ohne Alt-Text",
        "Obraz główny": "Hauptbild",
        "Obraz startowy": "Startbild",
        "Obraz został pomyślnie opisany": "Das Bild wurde erfolgreich beschrieben",
        "Obraz został przetworzony ale mogły wystąpić problemy z zapisem": "Das Bild wurde verarbeitet, beim Speichern können jedoch Probleme aufgetreten sein",
        "Obraz został zapisany jako nowy plik.": "Das Bild wurde als neue Datei gespeichert.",
        "Obrazy": "Bilder",
        "Obrazy oraz pliki PDF, DOCX, XLSX, TXT, MD i CSV, maksymalnie 4.": "Bilder sowie Dateien im Format PDF, DOCX, XLSX, TXT, MD und CSV, maximal 4.",
        "Obrazy zostały przeniesione.": "Die Bilder wurden verschoben.",
        "Obrót obrazu": "Bilddrehung",
        "Ocena": "Bewertung",
        "Oceny asystenta AI": "Bewertungen des KI-Assistenten",
        "Ochrona formularzy przed automatycznymi zgłoszeniami i nadużyciami.": "Schutz von Formularen vor automatischen Einreichungen und Missbrauch.",
        "Ochrona przed atakami na hasła oraz czas trwania sesji.": "Schutz vor Passwortangriffen und Sitzungsdauer.",
        "Oczekująca wiadomość": "Ausstehende Nachricht",
        "Oczekujące": "Ausstehend",
        "Oczekujące zaproszenia": "Ausstehende Einladungen",
        "Oczekuje": "Wartet",
        "Od": "Von",
        "Od początku roku": "Seit Jahresbeginn",
        "Odbicie pionowe": "Vertikal spiegeln",
        "Odbicie poziome": "Horizontal spiegeln",
        "Odbij X": "X spiegeln",
        "Odbij Y": "Y spiegeln",
        "Odblokuj": "Entsperren",
        "Odblokuj proporcje": "Seitenverhältnis entsperren",
        "Odblokuj proporcje wariantu": "Seitenverhältnis der Variante entsperren",
        "Odczytaj strukturę Edito i opisz dostępny workflow redaktora bez wykonywania zmian.": "Lies die Struktur von Edito aus und beschreibe den verfügbaren Redaktions-Workflow, ohne Änderungen vorzunehmen.",
        "Odnośniki": "Links",
        "Odpowiedzi na pytania o pierwsze połączenie.": "Antworten auf Fragen zur ersten Verbindung.",
        "Odpowiedzi szybkie": "Schnelle Antworten",
        "Odpowiedzi zaawansowane": "Erweiterte Antworten",
        "Odrzuć": "Ablehnen",
        "Odrzuca połączenie przy nieprawidłowym certyfikacie.": "Lehnt die Verbindung bei einem ungültigen Zertifikat ab.",
        "Odrzucone": "Abgelehnt",
        "Odstęp w pionie": "Vertikaler Abstand",
        "Odstęp w poziomie": "Horizontaler Abstand",
        "Odśwież": "Aktualisieren",
        "Odśwież stronę lub sprawdź ustawienia źródła danych w widgetcie.": "Aktualisieren Sie die Seite oder überprüfen Sie die Datenquelleneinstellungen im Widget.",
        "Odwróć": "Umkehren",
        "Odznacz": "Auswahl aufheben",
        "Odzyskaj połączenie przez rotację tokenu.": "Stellen Sie die Verbindung durch Rotation des Tokens wieder her.",
        "Oficjalne instrukcje i dokumentacja.": "Offizielle Anleitungen und Dokumentation.",
        "Ogólne": "Allgemein",
        "Ok": "OK",
        "Okręgi": "Kreise",
        "Okres": "Zeitraum",
        "Określ dostęp do funkcji systemu dla użytkowników przypisanych do tej roli.": "Legen Sie den Zugriff auf Systemfunktionen für Benutzer fest, die dieser Rolle zugewiesen sind.",
        "Określ dostępność i sposób wyświetlania dashboardu.": "Legen Sie die Verfügbarkeit und Anzeige des Dashboards fest.",
        "Określ minimalny poziom ważności zdarzeń rejestrowanych w aplikacji.": "Legen Sie die Mindestschwere der in der Anwendung protokollierten Ereignisse fest.",
        "Określa, czy dashboard jest publiczny, czy dostępny wyłącznie według przypisanych uprawnień.": "Legt fest, ob das Dashboard öffentlich oder nur entsprechend den zugewiesenen Berechtigungen zugänglich ist.",
        "Określa, czy weryfikacja dwuetapowa jest wymagana dla wszystkich użytkowników.": "Legt fest, ob die Zwei-Faktor-Authentifizierung für alle Benutzer erforderlich ist.",
        "Określa, jak obraz ma być pozycjonowany względem tekstu.": "Legt fest, wie das Bild relativ zum Text positioniert werden soll.",
        "Okruszki nawigacyjne": "Brotkrümelnavigation",
        "Olej na płótnie": "Öl auf Leinwand",
        "Opcje linku": "Linkoptionen",
        "Opcjonalna miniatura wyświetlana przed rozpoczęciem odtwarzania wideo.": "Optionales Vorschaubild, das vor dem Start der Videowiedergabe angezeigt wird.",
        "Opcjonalne": "Optional",
        "Opcjonalne. Ustaw osobne width i height, jeśli ten wariant ma inną proporcję niż obraz główny.": "Optional. Legen Sie separate Werte für width und height fest, wenn diese Variante ein anderes Seitenverhältnis als das Hauptbild hat.",
        "Opcjonalne. Ustawia atrybuty width i height na głównym obrazie renderowanym w HTML.": "Optional. Legt die Attribute width und height für das im HTML gerenderte Hauptbild fest.",
        "Opcjonalny podpis pod obrazem…": "Optionale Bildunterschrift …",
        "OpenTelemetry": "OpenTelemetry",
        "Operacja nieodwracalna": "Unwiderruflicher Vorgang",
        "Opis": "Beschreibung",
        "Opis obrazka": "Bildbeschreibung",
        "Opis obrazu": "Bildbeschreibung",
        "Opisy i SEO": "Beschreibungen und SEO",
        "Opisz obraz, który chcesz stworzyć": "Beschreiben Sie das Bild, das Sie erstellen möchten",
        "Opisz obraz, np. zespół w nowoczesnym biurze, ciepłe światło, szerokie ujęcie": "Beschreiben Sie das Bild, z. B. ein Team in einem modernen Büro, warmes Licht, Weitwinkelaufnahme",
        "Opróżnić kategorię?": "Kategorie leeren?",
        "Opróżnić kosz?": "Papierkorb leeren?",
        "Opróżnij kategorię": "Kategorie leeren",
        "Opróżnij kosz": "Papierkorb leeren",
        "Optymalizuj rozdzielczość obrazów": "Bildauflösung optimieren",
        "Opublikowany": "Veröffentlicht",
        "Opublikuj ankietę na witrynie i poczekaj na odpowiedzi albo zmień liczbę ankiet w ustawieniach widgetu.": "Veröffentlichen Sie die Umfrage auf der Website und warten Sie auf Antworten oder ändern Sie die Anzahl der Umfragen in den Widget-Einstellungen.",
        "Opublikuj treść na witrynie, sprawdź ustawienia witryny w widgetcie lub wybierz inny okres bądź filtr.": "Veröffentlichen Sie den Inhalt auf der Website, überprüfen Sie die Website-Einstellungen im Widget oder wählen Sie einen anderen Zeitraum oder Filter.",
        "Opuść bez zapisywania": "Verlassen, ohne zu speichern",
        "Organizacja": "Organisation",
        "Oryginalny": "Original",
        "Oryginalny format": "Originalformat",
        "Osadź": "Einbetten",
        "Osiągnięto limit plików": "Dateilimit erreicht",
        "Osiągnięto limit wybranych plików.": "Das Limit für ausgewählte Dateien wurde erreicht.",
        "Ostatni miesiąc": "Letzter Monat",
        "Ostatni rok": "Letztes Jahr",
        "Ostatnia aktywność": "Letzte Aktivität",
        "Ostatnia strona": "Letzte Seite",
        "Ostatnie": "Letzte",
        "Ostatnie 24h": "Letzte 24 Stunden",
        "Ostatnie 30 dni": "Letzte 30 Tage",
        "Ostatnie 7 dni": "Letzte 7 Tage",
        "Ostatnie 90 dni": "Letzte 90 Tage",
        "Ostatnie logowanie": "Letzte Anmeldung",
        "Ostatnio używane": "Zuletzt verwendet",
        "Ostrzeżenia": "Warnungen",
        "Ostrzeżenie": "Warnung",
        "Otwórz": "Öffnen",
        "Otwórz aplikację Claude i przejdź do karty „Code”.": "Öffnen Sie die Claude-App und wechseln Sie zur Registerkarte „Code“.",
        "Otwórz aplikację uwierzytelniającą i zeskanuj kod. Nie możesz zeskanować? Wpisz klucz ręcznie:": "Öffnen Sie die Authentifizierungs-App und scannen Sie den Code. Sie können ihn nicht scannen? Geben Sie den Schlüssel manuell ein:",
        "Otwórz Codex i dodaj lokalny projekt z folderu na komputerze.": "Öffnen Sie Codex und fügen Sie ein lokales Projekt aus einem Ordner auf Ihrem Computer hinzu.",
        "Otwórz edycję układu dashboardu, a następnie ustawienia tego widgetu.": "Öffnen Sie die Bearbeitung des Dashboard-Layouts und anschließend die Einstellungen dieses Widgets.",
        "Otwórz link": "Link öffnen",
        "Otwórz projekt w wybranym programie": "Projekt im ausgewählten Programm öffnen",
        "Otwórz rozmowę": "Gespräch öffnen",
        "Otwórz tokeny dostępu": "Zugriffstoken öffnen",
        "Otwórz tokeny dostępu i znajdź token po nadanej wcześniej nazwie.": "Öffnen Sie die Zugriffstoken und suchen Sie das Token anhand des zuvor vergebenen Namens.",
        "Otwórz ustawienia widgetu (menu ⋮) i sprawdź źródło danych oraz wybrany okres.": "Öffnen Sie die Widget-Einstellungen (Menü ⋮) und überprüfen Sie die Datenquelle sowie den ausgewählten Zeitraum.",
        "Otwórz w nowej karcie": "In neuem Tab öffnen",
        "Oznacz jako nieprzeczytane": "Als ungelesen markieren",
        "Oznacz jako przeczytane": "Als gelesen markieren",
        "Oznacz powiadomienia": "Benachrichtigungen markieren",
        "Oznacz wszystkie jako przeczytane": "Alle als gelesen markieren",
        "Paczka odpowiada wybranemu programowi i jest rozpakowana w prywatnym miejscu.": "Das Paket gehört zum ausgewählten Programm und wurde an einem privaten Ort entpackt.",
        "Paczka prowadzi do niewłaściwej instancji Edito": "Das Paket verweist auf die falsche Edito-Instanz",
        "Padding": "Innenabstand",
        "Padding komórek": "Zelleninnenabstand",
        "Paginacja": "Paginierung",
        "Paleta": "Palette",
        "Panel": "Panel",
        "Panel administracyjny wymaga szerokości co najmniej 360 pikseli. Poszerz okno przeglądarki lub użyj urządzenia z szerszym ekranem.": "Das Administrationspanel erfordert eine Breite von mindestens 360 Pixeln. Vergrößern Sie das Browserfenster oder verwenden Sie ein Gerät mit einem breiteren Bildschirm.",
        "Panel jest chwilowo niedostępny.\nWykonujemy zaplanowaną aktualizację systemu.": "Das Panel ist vorübergehend nicht verfügbar.\nWir führen ein geplantes Systemupdate durch.",
        "Patch": "Patch",
        "październik": "Oktober",
        "Pełna autonomia": "Volle Autonomie",
        "Pełna ścieżka": "Vollständiger Pfad",
        "Pełne uprawnienia": "Vollständige Berechtigungen",
        "Pełny administrator": "Vollständiger Administrator",
        "Pełny dostęp do systemu": "Voller Systemzugriff",
        "Pełny ekran": "Vollbild",
        "Pierwsza strona": "Erste Seite",
        "Pierwsze polecenie tylko odczytuje dane.": "Der erste Befehl liest nur Daten aus.",
        "Pierwsze uruchomienie. Utwórz konto głównego administratora. Będzie miało pełne uprawnienia do panelu.": "Erster Start. Erstellen Sie ein Hauptadministratorkonto. Es erhält vollständige Berechtigungen für das Panel.",
        "Pisz zwykłym językiem. Możesz zacząć od takich poleceń:": "Schreiben Sie in natürlicher Sprache. Sie können mit solchen Befehlen beginnen:",
        "Pixar": "Pixar",
        "Pixel art": "Pixel Art",
        "Plan gotowy": "Plan bereit",
        "Plan wygasł": "Plan abgelaufen",
        "Plan zawiera operacje destrukcyjne i będzie wymagał dodatkowego potwierdzenia.": "Der Plan enthält destruktive Vorgänge und erfordert eine zusätzliche Bestätigung.",
        "Planowana": "Geplant",
        "Planowane": "Geplant",
        "Planowane zmiany": "Geplante Änderungen",
        "plik": "Datei",
        "Plik": "Datei",
        "Plik {0}": "Datei {0}",
        "Plik audio": "Audiodatei",
        "Plik binarny": "Binärdatei",
        "Plik CSS": "CSS-Datei",
        "Plik CSV": "CSV-Datei",
        "Plik DOC": "DOC-Datei",
        "Plik DOCX": "DOCX-Datei",
        "Plik GIF": "GIF-Datei",
        "Plik graficzny": "Bilddatei",
        "Plik HTML": "HTML-Datei",
        "Plik JPEG": "JPEG-Datei",
        "Plik JPG": "JPG-Datei",
        "Plik MP4": "MP4-Datei",
        "Plik nie jest jeszcze używany.": "Die Datei wird noch nicht verwendet.",
        "Plik PNG": "PNG-Datei",
        "Plik przekracza dozwolony rozmiar %0 MB.": "Die Datei überschreitet die zulässige Größe von %0 MB.",
        "Plik skompresowany": "Komprimierte Datei",
        "Plik WEBP": "WEBP-Datei",
        "Plik wideo": "Videodatei",
        "Plik z logami": "Protokolldatei",
        "Plik z repozytorium": "Datei aus dem Repository",
        "Plik ZIP": "ZIP-Datei",
        "Pliki": "Dateien",
        "Pliki w kolejce": "Dateien in der Warteschlange",
        "Pliki współdzielone": "Freigegebene Dateien",
        "Pliki zostały przeniesione.": "Die Dateien wurden verschoben.",
        "Pliki zostały wysłane": "Die Dateien wurden hochgeladen",
        "plików": "Dateien",
        "PNG, JPG, PDF": "PNG, JPG, PDF",
        "Po": "Nach",
        "po %0 nieudanych próbach logowania": "nach %0 fehlgeschlagenen Anmeldeversuchen",
        "Po tym czasie bezczynności użytkownik zostanie wylogowany z panelu.": "Nach diesem Zeitraum der Inaktivität wird der Benutzer vom Panel abgemeldet.",
        "Po tym czasie panel poprosi o ustawienie nowego hasła.": "Nach diesem Zeitraum fordert das Panel dazu auf, ein neues Passwort festzulegen.",
        "Po utracie komputera lub przypadkowym udostępnieniu paczki usuń token w panelu i utwórz nowy.": "Wenn Sie Ihren Computer verlieren oder das Paket versehentlich weitergeben, löschen Sie das Token im Panel und erstellen Sie ein neues.",
        "Po włączeniu uprawnienia indywidualne i z ról nie są brane pod uwagę - użytkownik ma dostęp do wszystkiego.": "Wenn diese Option aktiviert ist, werden individuelle und rollenbasierte Berechtigungen nicht berücksichtigt – der Benutzer hat Zugriff auf alles.",
        "Po zakończeniu współpracy usuń token z listy tokenów dostępu.": "Löschen Sie das Token nach Beendigung der Zusammenarbeit aus der Liste der Zugriffstoken.",
        "Po zapisaniu nowa konfiguracja zacznie obowiązywać dopiero po ponownym uruchomieniu procesu aplikacji. Zaplanuj restart w bezpiecznym momencie, ponieważ aktywne żądania i zadania w tle mogą zostać na krótko przerwane.": "Nach dem Speichern wird die neue Konfiguration erst nach einem Neustart des Anwendungsprozesses wirksam. Planen Sie den Neustart zu einem geeigneten Zeitpunkt, da aktive Anfragen und Hintergrundaufgaben kurzzeitig unterbrochen werden können.",
        "Pobieranie rozmów…": "Gespräche werden abgerufen…",
        "Pobierz": "Herunterladen",
        "Pobierz kolor z ekranu": "Farbe vom Bildschirm aufnehmen",
        "Pobierz paczkę od razu. Po zamknięciu widoku pełny token nie będzie ponownie dostępny. Paczka zawiera prywatny token - nie wysyłaj jej innym osobom ani nie wklejaj tokenu do rozmowy.": "Laden Sie das Paket sofort herunter. Nach dem Schließen der Ansicht ist das vollständige Token nicht mehr verfügbar. Das Paket enthält ein privates Token – senden Sie es nicht an andere Personen und fügen Sie das Token nicht in ein Gespräch ein.",
        "Pobierz plik": "Datei herunterladen",
        "Pobierz rozmowy ponownie": "Gespräche erneut abrufen",
        "Pobierz właściwą paczkę": "Das richtige Paket herunterladen",
        "Pobrano paczkę dla niewłaściwego programu": "Paket für das falsche Programm heruntergeladen",
        "Pobrano rozmowy": "Gespräche abgerufen",
        "Poczekaj na zakończenie operacji na pliku.": "Warten Sie, bis der Dateivorgang abgeschlossen ist.",
        "Poczekaj, aż asystent skończy bieżące zadanie.": "Warten Sie, bis der Assistent die aktuelle Aufgabe abgeschlossen hat.",
        "Poczta wychodząca": "Ausgehende E-Mail",
        "Podaj 6-cyfrowy kod z aplikacji uwierzytelniającej.": "Geben Sie den 6-stelligen Code aus der Authentifizierungs-App ein.",
        "Podaj 6-znakowy kod weryfikacyjny wysłany na Twój adres email.": "Geben Sie den 6-stelligen Bestätigungscode ein, der an Ihre E-Mail-Adresse gesendet wurde.",
        "Podaj adres e-mail przypisany do konta – wyślemy jednorazowy kod do zmiany hasła.": "Geben Sie die mit Ihrem Konto verknüpfte E-Mail-Adresse ein – wir senden Ihnen einen einmaligen Code zum Ändern Ihres Passworts.",
        "Podaj sześciocyfrowy kod weryfikacyjny wysłany na Twój adres e-mail.": "Geben Sie den sechsstelligen Bestätigungscode ein, der an Ihre E-Mail-Adresse gesendet wurde.",
        "Podana wartość nie jest prawidłowym adresem email": "Der eingegebene Wert ist keine gültige E-Mail-Adresse",
        "Podanie adresu API jest wymagane.": "Die Angabe der API-Adresse ist erforderlich.",
        "Podanie klucza API jest wymagane.": "Die Angabe des API-Schlüssels ist erforderlich.",
        "Podanie modelu jest wymagane.": "Die Angabe des Modells ist erforderlich.",
        "Podanie nazwy jest wymagane.": "Die Angabe des Namens ist erforderlich.",
        "Podczas próby logowania wystąpił problem z zapisem recaptcha. Spróbuj ponownie": "Beim Speichern von reCAPTCHA ist während des Anmeldeversuchs ein Problem aufgetreten. Versuchen Sie es erneut",
        "Podczas przesyłania plików wystąpił nieznany błąd": "Beim Hochladen der Dateien ist ein unbekannter Fehler aufgetreten",
        "Podgląd": "Vorschau",
        "Podgląd multimediów": "Medienvorschau",
        "Podgląd na żywo": "Live-Vorschau",
        "Podgląd obrazu": "Bildvorschau",
        "Podgląd obrazu startowego": "Vorschau des Startbilds",
        "Podgląd pliku": "Dateivorschau",
        "Podgląd tego typu pliku nie jest dostępny.": "Für diesen Dateityp ist keine Vorschau verfügbar.",
        "Podgląd uwzględnia presety, szerokość, wyrównanie i padding.": "Die Vorschau berücksichtigt Presets, Breite, Ausrichtung und Padding.",
        "Podkreślenie": "Unterstreichen",
        "Podmień # na docelowy adres, kotwicę istniejącej sekcji albo usuń link.": "Ersetzen Sie # durch die Zieladresse, einen Anker einer bestehenden Sektion oder entfernen Sie den Link.",
        "Podmień link na publiczny adres strony, pliku albo modułu.": "Ersetzen Sie den Link durch die öffentliche Adresse der Seite, Datei oder des Moduls.",
        "Podmień placeholder na realny adres.": "Ersetzen Sie den Platzhalter durch eine echte Adresse.",
        "Podniesiono widget %0. Użyj klawiszy strzałek, aby zmienić jego pozycję.": "Widget %0 wurde nach oben verschoben. Verwenden Sie die Pfeiltasten, um seine Position zu ändern.",
        "Podpis obrazu (figcaption)": "Bildunterschrift (figcaption)",
        "Podpis tabeli (caption)": "Tabellenüberschrift (caption)",
        "Podstawowe dane używane do logowania i kontaktu.": "Grundlegende Daten für die Anmeldung und Kontaktaufnahme.",
        "Podsumowanie": "Zusammenfassung",
        "Pogrubienie": "Fett",
        "Pojawi się wkrótce na docelowym ekranie.": "Wird demnächst auf dem Zielbildschirm angezeigt.",
        "Pojedyncze rozwinięcie": "Einzelausklappen",
        "Pokaż bloki": "Blöcke anzeigen",
        "Pokaż cały obraz": "Ganzes Bild anzeigen",
        "Pokaż hasło": "Passwort anzeigen",
        "Pokaż historię": "Verlauf anzeigen",
        "Pokaż klucz prywatny": "Privaten Schlüssel anzeigen",
        "Pokaż mniej": "Weniger anzeigen",
        "Pokaż pliki": "Dateien anzeigen",
        "Pokaż pozostałą zmianę": "Verbleibende Änderung anzeigen",
        "Pokaż pozostałe {count} zmian": "Verbleibende {count} Änderungen anzeigen",
        "Pokaż pozostałe {count} zmiany": "Verbleibende {count} Änderungen anzeigen",
        "Pokaż rozmowy": "Unterhaltungen anzeigen",
        "Pokaż szczegóły": "Details anzeigen",
        "Pokaż tylko moje dokumenty": "Nur meine Dokumente anzeigen",
        "Pokaż w bibliotece": "In der Bibliothek anzeigen",
        "Pokaż w treści": "Im Inhalt anzeigen",
        "Pokaż więcej": "Mehr anzeigen",
        "Pokaż wszystkie": "Alle anzeigen",
        "Pokaż znaki niedrukowalne": "Nicht druckbare Zeichen anzeigen",
        "Pokazano {0} z {1} wyników.": "{0} von {1} Ergebnissen angezeigt.",
        "Pola dodatkowe": "Zusätzliche Felder",
        "Połącz Edito z zewnętrznym asystentem AI przez MCP. W sekcji tokenów utwórz token dostępu i pobierz gotowy projekt dla Codexa lub Claude Code.": "Verbinden Sie Edito über MCP mit einem externen KI-Assistenten. Erstellen Sie im Token-Bereich ein Zugriffstoken und laden Sie ein fertiges Projekt für Codex oder Claude Code herunter.",
        "Połączenia z API dostawców modeli.": "Verbindungen zu Modellanbieter-APIs.",
        "Połączenie działa, gdy asystent odczyta dostępne obszary redakcyjne bez błędu, nie poprosi o repozytorium ani kod projektu i nie wykona żadnej zmiany.": "Die Verbindung ist funktionsfähig, wenn der Assistent die verfügbaren Redaktionsbereiche fehlerfrei ausliest, weder nach dem Repository noch nach dem Projektcode fragt und keine Änderungen vornimmt.",
        "Połączenie wcześniej działało, a teraz nie działa": "Die Verbindung hat zuvor funktioniert, funktioniert jetzt aber nicht mehr",
        "Połączenie z asystentem zostało przerwane.": "Die Verbindung zum Assistenten wurde unterbrochen.",
        "Połączenie z MCP": "MCP-Verbindung",
        "Połączenie z MCP - dokumentacja Edito": "MCP-Verbindung – Edito-Dokumentation",
        "Pole \"Email\" jest wymagane.": "Das Feld „E-Mail“ ist erforderlich.",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "Das Feld „Benutzername“ ist erforderlich.",
        "Pole \"Nazwa\" jest wymagane.": "Das Feld „Name“ ist erforderlich.",
        "Pole \"Szerokość\" jest wymagane.": "Das Feld „Breite“ ist erforderlich.",
        "Pole \"Tytuł\" jest wymagane.": "Das Feld „Titel“ ist erforderlich.",
        "Pole jest wymagane": "Das Feld ist erforderlich",
        "Pole nie może zawierać spacji": "Das Feld darf keine Leerzeichen enthalten",
        "Pole skopiowane": "Feld kopiert",
        "Pole wymagane": "Pflichtfeld",
        "Polecenie skopiowane do schowka.": "Befehl in die Zwischenablage kopiert.",
        "Polecenie testowe": "Testbefehl",
        "Polityka prywatności": "Datenschutzerklärung",
        "Polski": "Polnisch",
        "Pomiń": "Überspringen",
        "Pominięto": "Übersprungen",
        "Pominięty poziom nagłówka": "Übersprungene Überschriftenebene",
        "Pomniejsz": "Verkleinern",
        "Pomoc": "Hilfe",
        "Pomóż mi przesłać zdjęcie i dodać je do przygotowywanej aktualności.": "Helfen Sie mir, ein Foto hochzuladen und zur vorbereiteten Meldung hinzuzufügen.",
        "Pomóż mi przygotować nową aktualność, ale jeszcze jej nie publikuj.": "Helfen Sie mir, eine neue Meldung vorzubereiten, aber veröffentlichen Sie sie noch nicht.",
        "Pon-pt": "Mo–Fr",
        "Ponów": "Wiederholen",
        "Ponów wyszukiwanie": "Erneut suchen",
        "Popraw błędy formularza przed zapisaniem.": "Beheben Sie die Formularfehler, bevor Sie speichern.",
        "Popraw hierarchię nagłówków bez przeskakiwania poziomów.": "Korrigieren Sie die Überschriftenhierarchie, ohne Ebenen zu überspringen.",
        "Poprzedni miesiąc": "Vorheriger Monat",
        "Poprzedni okres": "Vorheriger Zeitraum",
        "Poprzedni plik": "Vorherige Datei",
        "Poprzedni rok": "Vorheriges Jahr",
        "Poprzednia strona": "Vorherige Seite",
        "Poprzednie trafienie": "Vorheriger Treffer",
        "Porównaj": "Vergleichen",
        "Porównaj z aktualną wersją": "Mit der aktuellen Version vergleichen",
        "Porównaj: poprzedni okres": "Vergleich: vorheriger Zeitraum",
        "Porównanie wersji": "Versionsvergleich",
        "Port": "Port",
        "Postęp całkowity": "Gesamtfortschritt",
        "Postęp workflow": "Workflow-Fortschritt",
        "Postęp wysyłania": "Upload-Fortschritt",
        "Postęp wysyłania plików": "Fortschritt beim Hochladen von Dateien",
        "Potwierdź": "Bestätigen",
        "Potwierdź i zatwierdź plan": "Bestätigen und Plan genehmigen",
        "Potwierdź usunięcie": "Löschen bestätigen",
        "Potwierdź usunięcie filtra": "Filterlöschung bestätigen",
        "Potwierdź zmiany destrukcyjne": "Destruktive Änderungen bestätigen",
        "Potwierdzasz tylko usuwanie danych": "Sie bestätigen nur das Löschen von Daten",
        "Potwierdzasz usuwanie i wszystkie większe zmiany": "Sie bestätigen das Löschen und alle größeren Änderungen",
        "Potwierdzenia": "Bestätigungen",
        "Potwierdzenie": "Bestätigung",
        "Potwierdzenie kopiowania": "Kopierbestätigung",
        "Potwierdzenie usunięcia": "Löschbestätigung",
        "Potwierdzenie zmiany statusu": "Bestätigung der Statusänderung",
        "powiadomienia": "Benachrichtigungen",
        "Powiadomienia": "Benachrichtigungen",
        "Powiadomienie": "Benachrichtigung",
        "Powiększ": "Vergrößern",
        "Powiększenie obrazu": "Bildvergrößerung",
        "Powrót": "Zurück",
        "Powrót do harmonogramu zadań": "Zurück zum Aufgabenplaner",
        "Powtórz hasło": "Passwort wiederholen",
        "Powtórzone": "Wiederholt",
        "Poziom dostępu": "Zugriffsebene",
        "Pozostałe": "Sonstige",
        "Pozostało %0 znaków.": "Noch %0 Zeichen übrig.",
        "Pozwala przekazać własne nagłówki autoryzacyjne eksportera.": "Ermöglicht die Übergabe eigener Autorisierungsheader an den Exporter.",
        "Pozycja stopu %0": "Stopp-Position %0",
        "Pozycja X znaku wodnego": "X-Position des Wasserzeichens",
        "Pozycja Y znaku wodnego": "Y-Position des Wasserzeichens",
        "Pozycja znaku wodnego": "Position des Wasserzeichens",
        "pozycji": "Positionen",
        "pracuje…": "arbeitet…",
        "Prawo": "Recht",
        "Prawy dolny": "Unten rechts",
        "Prawy górny": "Oben rechts",
        "Prawy panel": "Rechtes Bedienfeld",
        "Preset": "Voreinstellung",
        "Próbkowanie": "Abtastung",
        "Profil": "Profil",
        "Profil użytkownika": "Benutzerprofil",
        "Profil został zaktualizowany.": "Das Profil wurde aktualisiert.",
        "Proporcja": "Verhältnis",
        "Proporcje": "Verhältnisse",
        "Proporcje kadru": "Seitenverhältnis",
        "Proszę zapisać postęp pracy i kliknąć przycisk „Aktualizuj”. Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "Bitte speichern Sie Ihren Arbeitsfortschritt und klicken Sie auf „Aktualisieren“. Sie können das Update auch übernehmen, indem Sie das Browserfenster aktualisieren. Ohne Update kann es zu Fehlern kommen.",
        "Prywatny": "Privat",
        "Prywatny klucz służący do weryfikacji odpowiedzi po stronie serwera.": "Privater Schlüssel zur serverseitigen Überprüfung der Antwort.",
        "Przechowywany zaszyfrowany, widoczny tylko przy edycji.": "Verschlüsselt gespeichert und nur beim Bearbeiten sichtbar.",
        "Przeciągnij pliki albo kliknij, aby wybrać": "Ziehen Sie Dateien hierher oder klicken Sie, um sie auszuwählen",
        "Przeciągnij pliki, nie foldery.": "Ziehen Sie Dateien, keine Ordner, hierher.",
        "Przeciągnij tutaj pliki lub wybierz je z dysku": "Ziehen Sie Dateien hierher oder wählen Sie sie von Ihrem Laufwerk aus",
        "Przeciągnij, aby zmienić kolejność": "Ziehen, um die Reihenfolge zu ändern",
        "Przeczytane": "Gelesen",
        "Przed": "Vor",
        "przed chwilą": "gerade eben",
        "Przed zapisem asystent powinien przedstawić plan i poprosić o zatwierdzenie konkretnej zmiany. Przeczytaj plan przed wyrażeniem zgody.": "Vor dem Speichern sollte der Assistent einen Plan vorlegen und um die Bestätigung einer konkreten Änderung bitten. Lesen Sie den Plan, bevor Sie zustimmen.",
        "Przeglądarka nie udostępniła obrazu ze schowka.": "Der Browser hat kein Bild aus der Zwischenablage bereitgestellt.",
        "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "Der von Ihnen verwendete Browser unterstützt keine Push-Benachrichtigungen.",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "Gehen Sie zur Konfiguration, um die Tools zu aktivieren",
        "Przejdź do pliku": "Zur Datei gehen",
        "Przejrzyj zmiany przed zatwierdzeniem i upewnij się, że usuwane elementy są właściwe.": "Überprüfen Sie die Änderungen vor der Bestätigung und stellen Sie sicher, dass die zu löschenden Elemente korrekt sind.",
        "Przekreślenie": "Durchgestrichen",
        "przekroczony dozwolony rozmiar pliku (%0 MB)": "Die zulässige Dateigröße wurde überschritten (%0 MB)",
        "Przenieś": "Verschieben",
        "Przenieś {name}": "{name} verschieben",
        "Przenieś element": "Element verschieben",
        "Przenieś element %0": "Element %0 verschieben",
        "Przenieś plik {name}": "Datei {name} verschieben",
        "Przenieś plik %0": "Datei %0 verschieben",
        "Przenieś rozpakowany folder w prywatne miejsce, np. Dokumenty/Edito AI. Nie zmieniaj plików wewnątrz - zawierają gotową konfigurację, instrukcje dla asystenta i token dostępu.": "Verschieben Sie den entpackten Ordner an einen privaten Speicherort, z. B. Dokumente/Edito AI. Ändern Sie keine Dateien im Ordner – sie enthalten die fertige Konfiguration, Anweisungen für den Assistenten und das Zugriffstoken.",
        "Przenieś sekcję niżej": "Abschnitt nach unten verschieben",
        "Przenieś sekcję wyżej": "Abschnitt nach oben verschieben",
        "Przenieś widget %0": "Widget %0 verschieben",
        "Przenieś wiersz": "Zeile verschieben",
        "Przenieś wybrane elementy": "Ausgewählte Elemente verschieben",
        "Przeniesienie": "Verschieben",
        "przeniesione": "verschoben",
        "Przeniesione": "Verschoben",
        "Przeniesiono widget %0 do kolumny %1, wiersza %2.": "Widget %0 wurde in Spalte %1, Zeile %2 verschoben.",
        "przeniesiony do kosza": "in den Papierkorb verschoben",
        "przeniósł do kosza": "hat in den Papierkorb verschoben",
        "Przepisz kod wygenerowany przez aplikację, aby potwierdzić konfigurację.": "Geben Sie den von der Anwendung generierten Code erneut ein, um die Konfiguration zu bestätigen.",
        "Przeskok poziomu nagłówka psuje hierarchię dokumentu. Czytniki ekranu używają tej struktury do szybkiej nawigacji po treści.": "Das Überspringen einer Überschriftenebene beeinträchtigt die Dokumenthierarchie. Bildschirmleseprogramme nutzen diese Struktur, um schnell durch den Inhalt zu navigieren.",
        "Prześlij": "Hochladen",
        "Przestawiaj widżety i dostosowuj ich ustawienia, aby uporządkować dashboard. Przycisk „Zapisz aranżację” zapisuje wyłącznie układ i ustawienia widżetów - filtry oraz pozostałe akcje są wyłączone w podglądzie.": "Ordnen Sie Widgets neu an und passen Sie ihre Einstellungen an, um das Dashboard zu gestalten. Die Schaltfläche „Anordnung speichern“ speichert ausschließlich das Layout und die Widget-Einstellungen – Filter und andere Aktionen sind in der Vorschau deaktiviert.",
        "Przestrzeń nazw": "Namensraum",
        "Przesunięcie kadru": "Bildausschnitt verschieben",
        "Przesuwa całą tabelę jako blok bez zmiany wyrównania tekstu w komórkach.": "Verschiebt die gesamte Tabelle als Block, ohne die Textausrichtung in den Zellen zu ändern.",
        "Przesuwanie widoku": "Ansicht verschieben",
        "Przesyłanie plików": "Dateien hochladen",
        "Przetestuj poprawność zapisanych kluczy": "Gespeicherte Schlüssel auf Gültigkeit testen",
        "Przetestuj ustawienia poczty": "E-Mail-Einstellungen testen",
        "Przetwarzane": "Wird verarbeitet",
        "Przetwarzanie…": "Verarbeitung…",
        "Przezroczystość": "Transparenz",
        "Przezroczystość znaku wodnego": "Transparenz des Wasserzeichens",
        "Przy niskim ruchu to normalne — sprawdź, czy rejestracja jest włączona na witrynie i czy wybrany okres ma sens.": "Bei geringem Datenverkehr ist das normal – prüfen Sie, ob die Registrierung auf der Website aktiviert ist und ob der ausgewählte Zeitraum sinnvoll ist.",
        "Przydatna": "Nützlich",
        "Przydatna odpowiedź": "Nützliche Antwort",
        "przydatne": "nützlich",
        "Przygotowanie obrazów": "Bilder werden vorbereitet",
        "Przygotowanie wysłanych plików do wyboru…": "Hochgeladene Dateien werden für die Auswahl vorbereitet…",
        "Przygotuj dostęp do właściwego panelu Edito oraz jeden wybrany program: Codex lub aplikację Claude z kartą Code. Zainstaluj program i zaloguj się na konto z dostępem do wybranego asystenta.": "Halten Sie den Zugang zum richtigen Edito-Bedienfeld und eines der folgenden Programme bereit: Codex oder die Claude-App mit der Registerkarte Code. Installieren Sie das Programm und melden Sie sich mit einem Konto an, das Zugriff auf den ausgewählten Assistenten hat.",
        "Przygotuj panel i wybrany program.": "Bereiten Sie das Bedienfeld und das ausgewählte Programm vor.",
        "Przykładowe polecenia do wykorzystania w rozmowie.": "Beispielbefehle zur Verwendung im Gespräch.",
        "Przypisanie modeli do zadań": "Modellzuweisung für Aufgaben",
        "Przypisanie ról": "Rollenzuweisung",
        "Przywróć": "Wiederherstellen",
        "Przywróć okno lintera": "Linter-Fenster wiederherstellen",
        "Przywróć wersję": "Version wiederherstellen",
        "Przywróć zestaw": "Set wiederherstellen",
        "Przywrócenie": "Wiederherstellung",
        "przywrócił z kosza": "aus dem Papierkorb wiederhergestellt",
        "przywrócony z kosza": "aus dem Papierkorb wiederhergestellt",
        "Przyznaj dostęp": "Zugriff gewähren",
        "Przyznaj wszystkie uprawnienia w grupie": "Alle Berechtigungen in der Gruppe gewähren",
        "Publiczna nazwa lub tytuł materiału.": "Öffentlicher Name oder Titel des Materials.",
        "Publiczny": "Öffentlich",
        "Publiczny klucz witryny otrzymany w konsoli Google ReCaptcha.": "Öffentlicher Website-Schlüssel aus der Google-ReCaptcha-Konsole.",
        "Publikacja": "Veröffentlichung",
        "Pusta lista wyłącza monitoring żądań HTTP.": "Eine leere Liste deaktiviert die Überwachung von HTTP-Anfragen.",
        "Puste akapity często powstają po przypadkowym Enterze albo wklejeniu treści. Mogą robić nierówne odstępy na stronie.": "Leere Absätze entstehen häufig durch versehentliches Drücken der Eingabetaste oder durch eingefügte Inhalte. Sie können zu ungleichmäßigen Abständen auf der Seite führen.",
        "Pusty akapit": "Leerer Absatz",
        "Raportowanie błędów aplikacji i opcjonalnych danych wydajnościowych.": "Berichterstattung über Anwendungsfehler und optionale Leistungsdaten.",
        "ReCaptcha": "ReCaptcha",
        "Regeneruj odpowiedź": "Antwort neu generieren",
        "Rejestr zmian": "Änderungsprotokoll",
        "Rejestruje operacje bazodanowe jako dane telemetryczne.": "Erfasst Datenbankoperationen als Telemetriedaten.",
        "Render 3D": "3D-Rendering",
        "Repozytorium plików": "Dateirepository",
        "Reset": "Zurücksetzen",
        "Reset edytora": "Editor zurücksetzen",
        "Reset filtrów": "Filter zurücksetzen",
        "Resetuj filtr": "Filter zurücksetzen",
        "Resetuj urządzenia 2FA": "2FA-Geräte zurücksetzen",
        "Resetuj widok": "Ansicht zurücksetzen",
        "Roczny": "Jährlich",
        "rok": "Jahr",
        "Rok": "Jahr",
        "Rola": "Rolle",
        "Rola aktywna": "Rolle aktiv",
        "Rola domyślna": "Standardrolle",
        "Rola jest domyślnie zaznaczona podczas dodawania nowego użytkownika.": "Die Rolle ist beim Hinzufügen eines neuen Benutzers standardmäßig ausgewählt.",
        "Rola została dodana.": "Die Rolle wurde hinzugefügt.",
        "Rola została usunięta.": "Die Rolle wurde gelöscht.",
        "Rola została zaktualizowana.": "Die Rolle wurde aktualisiert.",
        "Rola: …": "Rolle: …",
        "Rola: %0": "Rolle: %0",
        "Role i uprawnienia": "Rollen und Berechtigungen",
        "Role użytkownika": "Benutzerrollen",
        "Role zostały przypisane": "Rollen wurden zugewiesen",
        "Rosnąco": "Aufsteigend",
        "Rotacja unieważnia poprzedni token. Stara paczka przestanie działać - zastąp ją nowo pobraną.": "Durch die Rotation wird das vorherige Token ungültig. Das alte Paket funktioniert dann nicht mehr – ersetzen Sie es durch das neu heruntergeladene.",
        "Rozdziel komórkę": "Zelle teilen",
        "Rozmiar": "Größe",
        "Rozmiar czcionki": "Schriftgröße",
        "Rozmiar logo": "Logogröße",
        "rozmiar nieznany": "Größe unbekannt",
        "Rozmiar pliku": "Dateigröße",
        "Rozmiar tekstu": "Textgröße",
        "Rozmiar zdjęcia został zmieniony.": "Die Bildgröße wurde geändert.",
        "Rozmiar znaku wodnego": "Wasserzeichengröße",
        "Rozmowa": "Unterhaltung",
        "Rozmowa została usunięta.": "Die Unterhaltung wurde gelöscht.",
        "Rozmowy": "Unterhaltungen",
        "Różowy": "Rosa",
        "Rozpakowany folder jest otwarty jako projekt, a zaufanie do projektu i serwera „edito” zostało zatwierdzone.": "Der entpackte Ordner ist als Projekt geöffnet und das Vertrauen in das Projekt und den Server „edito“ wurde bestätigt.",
        "Rozpakuj nową paczkę, otwórz jej folder jako projekt i ponów test z kroku 6.": "Entpacken Sie das neue Paket, öffnen Sie dessen Ordner als Projekt und wiederholen Sie den Test aus Schritt 6.",
        "Rozpakuj paczkę": "Paket entpacken",
        "Rozpoczęto przenoszenie widgetu %0.": "Das Verschieben des Widgets %0 wurde gestartet.",
        "Rozpoznawanie treści i wzorów wizualnych.": "Erkennung von Inhalten und visuellen Mustern.",
        "Rozwiń": "Erweitern",
        "Rozwiń {name}": "{name} erweitern",
        "Rozwiń menu": "Menü erweitern",
        "Rozwiń sekcję": "Abschnitt erweitern",
        "Rysunek tuszem": "Tuschezeichnung",
        "Scal komórki": "Zellen verbinden",
        "Schowek nie zawiera pliku do wklejenia.": "Die Zwischenablage enthält keine Datei zum Einfügen.",
        "Ścieżka folderu": "Ordnerpfad",
        "Ścieżka zapisu została zmieniona.": "Der Speicherpfad wurde geändert.",
        "Ścieżka:": "Pfad:",
        "sek.": "Sek.",
        "Sekcja": "Abschnitt",
        "Sekcje użytkownika": "Benutzerabschnitte",
        "Sekret aplikacji Microsoft Entra.": "Microsoft Entra-Anwendungsgeheimnis.",
        "Sentry": "Sentry",
        "Separatory": "Trennzeichen",
        "Serwer SMTP": "SMTP-Server",
        "Sesja": "Sitzung",
        "Sesja nr %0": "Sitzung Nr. %0",
        "Sesja użytkownika": "Benutzersitzung",
        "Sesja wygasła": "Sitzung abgelaufen",
        "Sesja wygasła — zaloguj się ponownie.": "Sitzung abgelaufen – melden Sie sich erneut an.",
        "sesji": "Sitzungen",
        "sierpień": "August",
        "Skala": "Skalierung",
        "Skala obrazu": "Bildskalierung",
        "Skala szarości": "Graustufen",
        "Skonfigurowane": "Konfiguriert",
        "Skonfiguruj aplikację uwierzytelniającą, aby kontynuować.": "Richten Sie eine Authentifizierungs-App ein, um fortzufahren.",
        "Skonfiguruj dostawcę": "Anbieter konfigurieren",
        "Skonfiguruj MCP": "MCP konfigurieren",
        "Skonfiguruj model": "Modell konfigurieren",
        "Skopiowano": "Kopiert",
        "Skopiowano identyfikator rozmowy.": "Unterhaltungs-ID kopiert.",
        "Skopiuj polecenie": "Befehl kopieren",
        "Skrypt SQL": "SQL-Skript",
        "Słabe": "Schwach",
        "słów": "Wörter",
        "Słowa": "Wörter",
        "Słowa kluczowe związane z treścią pliku.": "Schlüsselwörter zum Dateiinhalt.",
        "Sortowanie": "Sortierung",
        "Sortowanie plików": "Dateisortierung",
        "Sortuj według": "Sortieren nach",
        "Sposób wyboru wartości": "Auswahlmethode",
        "Sprawdź adres panelu, aby upewnić się, że konfigurujesz właściwą instancję Edito. Następnie kliknij „Otwórz tokeny dostępu” u góry tej strony. Przejdziesz do listy swoich tokenów.": "Überprüfen Sie die Adresse des Admin-Panels, um sicherzustellen, dass Sie die richtige Edito-Instanz konfigurieren. Klicken Sie anschließend oben auf dieser Seite auf „Zugriffstoken öffnen“. Sie gelangen zur Liste Ihrer Token.",
        "Sprawdź dostęp użytkownika do poszczególnych funkcji. Widok uwzględnia zapisane uprawnienia i przypisane role.": "Überprüfen Sie den Zugriff des Benutzers auf die einzelnen Funktionen. Die Ansicht berücksichtigt gespeicherte Berechtigungen und zugewiesene Rollen.",
        "Sprawdź konfigurację przed rozpoczęciem pracy.": "Überprüfen Sie die Konfiguration, bevor Sie mit der Arbeit beginnen.",
        "Sprawdź konfigurację przed zapisaniem zmian.": "Überprüfen Sie die Konfiguration, bevor Sie Änderungen speichern.",
        "Sprawdź moduł, sekcję i filtry w ustawieniach widgetu. Upewnij się, że w module są opublikowane dokumenty.": "Überprüfen Sie Modul, Abschnitt und Filter in den Widget-Einstellungen. Stellen Sie sicher, dass im Modul Dokumente veröffentlicht sind.",
        "Sprawdź moduł, sekcję, filtry oraz uprawnienia w ustawieniach widgetu.": "Überprüfen Sie Modul, Abschnitt, Filter und Berechtigungen in den Widget-Einstellungen.",
        "Sprawdź pisownię lub wpisz krótszą frazę.": "Überprüfen Sie die Schreibweise oder geben Sie einen kürzeren Suchbegriff ein.",
        "Sprawdź pliki": "Dateien überprüfen",
        "Sprawdź połączenie": "Verbindung überprüfen",
        "Sprawdź połączenie z Google Analytics w ustawieniach witryny (CMS → Witryny → integracja GA) oraz czy na stronie działa kod śledzenia. Możesz też wybrać dłuższy okres.": "Überprüfen Sie die Verbindung zu Google Analytics in den Website-Einstellungen (CMS → Websites → GA-Integration) und ob der Tracking-Code auf der Seite aktiv ist. Sie können auch einen längeren Zeitraum auswählen.",
        "Sprawdź SEO wskazanej strony i zaproponuj poprawki. Na razie niczego nie zapisuj.": "Überprüfen Sie das SEO der angegebenen Seite und schlagen Sie Verbesserungen vor. Speichern Sie vorerst nichts.",
        "Sprawdź uprawnienia do modułu użytkowników i spróbuj ponownie.": "Überprüfen Sie Ihre Berechtigungen für das Benutzermodul und versuchen Sie es erneut.",
        "Sprawdź uprawnienia do modułu zastępstw i spróbuj ponownie.": "Überprüfen Sie Ihre Berechtigungen für das Vertretungsmodul und versuchen Sie es erneut.",
        "Sprawdź ustawienia sklepu w widgetcie i spróbuj ponownie.": "Überprüfen Sie die Shop-Einstellungen im Widget und versuchen Sie es erneut.",
        "Sprawdź ustawienia sklepu w widgetcie, wybrany okres oraz czy katalog zawiera dane (sprzedaż, stany magazynowe, oceny).": "Überprüfen Sie die Shop-Einstellungen im Widget, den ausgewählten Zeitraum und ob der Katalog Daten enthält (Verkäufe, Lagerbestände, Bewertungen).",
        "Sprawdź ustawienia widgetu i dostęp do modułu ankiet.": "Überprüfen Sie die Widget-Einstellungen und den Zugriff auf das Umfragemodul.",
        "Sprawdź ustawienia witryny w widgetcie i uprawnienia do modułu treści.": "Überprüfen Sie die Website-Einstellungen im Widget und die Berechtigungen für das Inhaltsmodul.",
        "Sprawdź wersję aplikacji Claude i dostęp konta do Claude Code. W razie potrzeby skontaktuj się z administratorem firmowego konta lub helpdeskiem.": "Überprüfen Sie die Version der Claude-App und den Kontozugriff auf Claude Code. Wenden Sie sich bei Bedarf an den Administrator des Unternehmenskontos oder den Helpdesk.",
        "Sprawdź wybrany folder. Otwórz wyłącznie edito-codex-project albo edito-claude-code-project, zależnie od programu.": "Überprüfen Sie den ausgewählten Ordner. Öffnen Sie je nach Programm ausschließlich edito-codex-project oder edito-claude-code-project.",
        "Sprawdź, czy widget ma ustawiony sklep w ustawieniach i czy masz dostęp do modułu zamówień.": "Überprüfen Sie, ob im Widget in den Einstellungen ein Shop festgelegt ist und ob Sie Zugriff auf das Bestellmodul haben.",
        "Sprawdzamy gotowość panelu…": "Panel-Bereitschaft wird überprüft…",
        "Sprawdzanie poprawności kluczy": "Gültigkeit der Schlüssel überprüfen",
        "Spróbuj ponownie": "Erneut versuchen",
        "Spróbuj ponownie. Jeśli problem się powtarza, sprawdź połączenie z siecią lub spróbuj później.": "Versuchen Sie es erneut. Wenn das Problem weiterhin auftritt, überprüfen Sie Ihre Netzwerkverbindung oder versuchen Sie es später erneut.",
        "Średnia": "Durchschnitt",
        "Średnica kadru": "Bildkreisdurchmesser",
        "Średnie": "Durchschnittliche",
        "Środek": "Mitte",
        "Stały rozmiar kadru": "Feste Bildgröße",
        "Stan konta": "Kontostatus",
        "Stan uprawnienia": "Berechtigungsstatus",
        "Standard": "Standard",
        "Starsze": "Ältere",
        "Start": "Start",
        "Status": "Status",
        "Status dokumentu": "Dokumentstatus",
        "Steampunk": "Steampunk",
        "String": "String",
        "Strona": "Seite",
        "Strona główna": "Startseite",
        "Strony": "Seiten",
        "Studio Ghibli": "Studio Ghibli",
        "styczeń": "Januar",
        "Styl": "Stil",
        "Styl listy numerowanej": "Nummerierungsstil",
        "Styl listy punktowanej": "Aufzählungsstil",
        "Styl ramki": "Rahmenstil",
        "Styl tekstu": "Textstil",
        "Styl z Worda": "Word-Formatvorlagen",
        "Style z Worda przenoszą ukryte klasy i właściwości, które mogą nadpisać wygląd strony poza edytorem.": "Word-Formatvorlagen übernehmen verborgene Klassen und Eigenschaften, die das Erscheinungsbild der Seite außerhalb des Editors überschreiben können.",
        "Symbole": "Symbole",
        "Synthwave": "Synthwave",
        "System": "System",
        "Szablon CMS": "CMS-Vorlage",
        "Szablony": "Vorlagen",
        "Szacowany czas:": "Geschätzte Zeit:",
        "Szczegóły": "Details",
        "Szczegóły folderu": "Ordnerdetails",
        "Szczegóły komunikatu": "Meldungsdetails",
        "Szczegóły kroków": "Schrittdetails",
        "Szczegóły pliku": "Dateidetails",
        "Szczegóły techniczne": "Technische Details",
        "Szczegóły zadania": "Aufgabendetails",
        "Szczegóły zasobu": "Ressourcendetails",
        "Szczegóły zdarzenia": "Ereignisdetails",
        "Szerokość": "Breite",
        "Szerokość kadru": "Bildbreite",
        "Szerokość proporcji": "Seitenverhältnisbreite",
        "Szerokość wynikowa": "Ausgabebreite",
        "Sześć kroków do pierwszego połączenia.": "Sechs Schritte bis zur ersten Verbindung.",
        "Szkic": "Entwurf",
        "Szkic węglem": "Kohlezeichnung",
        "Sztuczna inteligencja": "Künstliche Intelligenz",
        "Szukaj": "Suchen",
        "Szukaj dashboardu": "Dashboard suchen",
        "Szukaj filtra…": "Filter suchen…",
        "Szukaj języka…": "Sprache suchen…",
        "Szukaj kolumn": "Spalten suchen",
        "Szukaj kolumn…": "Spalten suchen…",
        "Szukaj lub wpisz polecenie": "Suchen oder Befehl eingeben",
        "Szukaj po emoji, nazwie lub aliasie...": "Nach Emoji, Name oder Alias suchen...",
        "Szukaj po znaku, nazwie lub aliasie...": "Nach Zeichen, Name oder Alias suchen...",
        "Szukaj roli": "Rolle suchen",
        "Szukaj roli…": "Rolle suchen…",
        "Szukaj rozmowy": "Unterhaltung suchen",
        "Szukaj rozmowy…": "Unterhaltung suchen…",
        "Szukaj uprawnienia lub modułu": "Berechtigung oder Modul suchen",
        "Szukaj uprawnienia lub modułu…": "Berechtigung oder Modul suchen…",
        "Szukaj w opcjach": "In Optionen suchen",
        "Szukaj we wszystkich wersjach": "In allen Versionen suchen",
        "Szukaj widoku lub dokumentu…": "Ansicht oder Dokument suchen…",
        "Szukaj witryny": "Website suchen",
        "Szukaj witryny…": "Website suchen…",
        "Szukaj zestawu": "Set suchen",
        "Szukaj…": "Suchen…",
        "Szukam…": "Suche…",
        "Szybkie": "Schnell",
        "Szybkie style tabeli": "Schnellformatvorlagen für Tabellen",
        "Szyfruje połączenie z serwerem poczty.": "Verschlüsselt die Verbindung zum Mailserver.",
        "Ta opcja służy do włączenia lub wyłączenia dziedziczenia w danym polu": "Mit dieser Option können Sie die Vererbung für das jeweilige Feld aktivieren oder deaktivieren",
        "Ta operacja jest nieodwracalna.": "Dieser Vorgang kann nicht rückgängig gemacht werden.",
        "Ta operacja jest nieodwracalna. Wszystkie elementy w tym widoku zostaną trwale usunięte i nie będzie można ich przywrócić.": "Dieser Vorgang kann nicht rückgängig gemacht werden. Alle Elemente in dieser Ansicht werden dauerhaft gelöscht und können nicht wiederhergestellt werden.",
        "Ta rozmowa została usunięta.": "Diese Unterhaltung wurde gelöscht.",
        "Ta strona jest chroniona przez reCAPTCHA i Google.": "Diese Seite ist durch reCAPTCHA und Google geschützt.",
        "Tabela": "Tabelle",
        "Tabela bez nagłówków": "Tabelle ohne Überschriften",
        "Tabela bez nagłówków jest trudniejsza do zrozumienia dla czytników ekranu i gorzej opisuje relację między kolumnami a danymi.": "Eine Tabelle ohne Überschriften ist für Screenreader schwerer verständlich und beschreibt die Beziehung zwischen Spalten und Daten weniger gut.",
        "Tagi": "Tags",
        "Tak": "Ja",
        "Tarcza zegara": "Zifferblatt",
        "Tekst": "Text",
        "Tekst alternatywny": "Alternativtext",
        "Tekst znaku wodnego": "Wasserzeichentext",
        "Ten dashboard nie zawiera żadnych widgetów": "Dieses Dashboard enthält keine Widgets",
        "Ten element nie zawiera menu kontekstowego.": "Dieses Element enthält kein Kontextmenü.",
        "Ten katalog jest pusty": "Dieses Verzeichnis ist leer",
        "Ten plan usunie {count} elementów. Tej operacji nie można łatwo cofnąć.": "Dieser Plan löscht {count} Elemente. Dieser Vorgang lässt sich nicht einfach rückgängig machen.",
        "Ten typ widgetu nie jest dostępny w tej wersji panelu lub został usunięty.": "Dieser Widget-Typ ist in dieser Version des Dashboards nicht verfügbar oder wurde entfernt.",
        "Tenant ID": "Tenant-ID",
        "Teraz": "Jetzt",
        "Test odczytu zakończył się poprawnie.": "Der Lesetest war erfolgreich.",
        "Test poczty": "E-Mail-Test",
        "Testowy adres email": "Test-E-Mail-Adresse",
        "Tło komórki": "Zellenhintergrund",
        "Tło zostało usunięte i zapisane jako nowy plik": "Der Hintergrund wurde entfernt und als neue Datei gespeichert",
        "To pole jest wymagane": "Dieses Feld ist erforderlich",
        "To uprawnienie zostało jawnie przyznane.": "Diese Berechtigung wurde ausdrücklich erteilt.",
        "To uprawnienie zostało jawnie zabronione.": "Diese Berechtigung wurde ausdrücklich verweigert.",
        "To urządzenie": "Dieses Gerät",
        "To urządzenie zostanie natychmiast wylogowane.": "Dieses Gerät wird sofort abgemeldet.",
        "Token i paczka nie zostały udostępnione innym osobom.": "Token und Paket wurden nicht mit anderen Personen geteilt.",
        "Token i paczka są Twoimi prywatnymi danymi.": "Token und Paket sind Ihre privaten Daten.",
        "Token mógł wygasnąć, zostać usunięty albo zrotowany. Utwórz lub zrotuj token w panelu, pobierz nową paczkę i otwórz jej folder jako projekt.": "Der Token ist möglicherweise abgelaufen, gelöscht oder rotiert worden. Erstellen oder rotieren Sie den Token im Dashboard, laden Sie ein neues Paket herunter und öffnen Sie dessen Ordner als Projekt.",
        "Tokeny dostępu": "Zugriffstoken",
        "Traktuj paczkę i rozpakowany folder jak hasło - zawierają prywatny token, który działa w zakresie uprawnień Twojego konta Edito.": "Behandeln Sie das Paket und den entpackten Ordner wie ein Passwort – sie enthalten einen privaten Token, der im Umfang der Berechtigungen Ihres Edito-Kontos gültig ist.",
        "Transformacje": "Transformationen",
        "Treść": "Inhalt",
        "Treść publiczna nie powinna prowadzić do panelu administracyjnego ani endpointów admina. Dla użytkownika taki link najczęściej kończy się błędem lub ekranem logowania.": "Öffentliche Inhalte sollten nicht zum Administrationsbereich oder zu Admin-Endpunkten führen. Für Benutzer endet ein solcher Link meist mit einer Fehlermeldung oder einem Anmeldebildschirm.",
        "True": "Wahr",
        "Trwa bezpieczne logowanie przez Azure AD…": "Die sichere Anmeldung über Azure AD läuft…",
        "Trwa generowanie obrazów": "Bilder werden generiert",
        "Trwa generowanie opisu dla wybranego obrazu": "Die Beschreibung für das ausgewählte Bild wird generiert",
        "Trwa konserwacja": "Wartungsarbeiten",
        "Tryb akordeonu": "Akkordeonmodus",
        "Tryb ciemny": "Dunkelmodus",
        "Tryb działania": "Betriebsmodus",
        "Tryb jasny": "Hellmodus",
        "Tryb kadrowania": "Zuschneidemodus",
        "Turkusowy": "Türkis",
        "Tutaj ustawiasz opis obrazka. Opcje techniczne są w zakładce Zaawansowane.": "Hier legen Sie die Bildbeschreibung fest. Technische Optionen finden Sie im Tab „Erweitert“.",
        "Twarda spacja": "Geschütztes Leerzeichen",
        "Twój asystent, połączony z Edito": "Ihr Assistent, verbunden mit Edito",
        "Twój wybór": "Ihre Auswahl",
        "Twoje generowania pojawią się tutaj.": "Ihre Generierungen werden hier angezeigt.",
        "Twoje hasło wygasło. Zmień je na nowe.": "Ihr Passwort ist abgelaufen. Ändern Sie es in ein neues Passwort.",
        "Twoje konto nie ma dostępu do tego zasobu.\nPoproś administratora o nadanie uprawnienia.": "Ihr Konto hat keinen Zugriff auf diese Ressource.\nBitten Sie den Administrator, Ihnen die Berechtigung zu erteilen.",
        "Tworzenie i edycja wpisów": "Einträge erstellen und bearbeiten",
        "Tworzenie obrazów…": "Bilder werden erstellt…",
        "Tworzenie, edycja i modyfikacja grafik.": "Grafiken erstellen, bearbeiten und ändern.",
        "Tydzień": "Woche",
        "Tylko aktywna rola wpływa na uprawnienia przypisanych użytkowników.": "Nur die aktive Rolle wirkt sich auf die Berechtigungen der zugewiesenen Benutzer aus.",
        "Tylko moje": "Nur meine",
        "Typ": "Typ",
        "Typ breakpointu": "Breakpoint-Typ",
        "Typ integracji określa sposób uwierzytelniania.": "Der Integrationstyp legt die Authentifizierungsmethode fest.",
        "Typ konta": "Kontotyp",
        "Typ obiektu": "Objekttyp",
        "Typ pliku": "Dateityp",
        "Typ właściwy": "Eigentlicher Typ",
        "Typ znaku wodnego": "Wasserzeichentyp",
        "typu \"%0\" o ID \"%1\"": "vom Typ „%0“ mit der ID „%1“",
        "Typy elementów w koszu": "Elementtypen im Papierkorb",
        "Tytuł sekcji": "Abschnittstitel",
        "Udział dozwolonych uprawnień": "Anteil zulässiger Berechtigungen",
        "Układ": "Layout",
        "Układ kolumn": "Spaltenlayout",
        "Układ listy": "Listenlayout",
        "Układ nie został otwarty, dlatego dodawanie widgetów i zapis są zablokowane. Spróbuj pobrać dane ponownie.": "Das Layout wurde nicht geöffnet. Daher sind das Hinzufügen von Widgets und das Speichern gesperrt. Versuchen Sie, die Daten erneut abzurufen.",
        "Układ widgetów dashboardu": "Dashboard-Widget-Layout",
        "Układy kolumn": "Spaltenlayouts",
        "Ukryj hasło": "Passwort ausblenden",
        "Ukryj klucz prywatny": "Privaten Schlüssel ausblenden",
        "Ukryj postęp wysyłania": "Upload-Fortschritt ausblenden",
        "Ukryj rozmowy": "Unterhaltungen ausblenden",
        "Ukryj szczegóły": "Details ausblenden",
        "Ukryj wszystkie": "Alle ausblenden",
        "Ulubione": "Favoriten",
        "Upewnij się, że widget ma ustawiony właściwy sklep (menu widgetu → Ustawienia) i sprawdź, czy w tym okresie pojawiły się zamówienia. Zmiana okresu w nagłówku może pomóc.": "Vergewissern Sie sich, dass im Widget der richtige Shop eingestellt ist (Widget-Menü → Einstellungen), und prüfen Sie, ob es in diesem Zeitraum Bestellungen gab. Eine Änderung des Zeitraums in der Kopfzeile kann helfen.",
        "Uprawnienia": "Berechtigungen",
        "Uprawnienia indywidualne": "Individuelle Berechtigungen",
        "Uprawnienia ogólne": "Allgemeine Berechtigungen",
        "Uprawnienia roli": "Rollenberechtigungen",
        "Uprawnienia z ról łączą się z indywidualnymi.": "Berechtigungen aus Rollen werden mit individuellen Berechtigungen zusammengeführt.",
        "Upuść pliki, aby dodać je do kolejki": "Legen Sie Dateien hier ab, um sie zur Warteschlange hinzuzufügen",
        "Upuść pliki, żeby je dołączyć": "Legen Sie Dateien hier ab, um sie anzuhängen",
        "Upuść tutaj": "Hier ablegen",
        "Upuść, aby dodać": "Zum Hinzufügen ablegen",
        "Uri / ConnectionString": "URI / ConnectionString",
        "URL": "URL",
        "Uruchamiam wykonanie planu...": "Ich starte die Ausführung des Plans...",
        "Uruchom gotowy projekt bez używania terminala.": "Führen Sie ein fertiges Projekt aus, ohne das Terminal zu verwenden.",
        "Uruchom zadanie": "Aufgabe ausführen",
        "urządzeń": "Geräte",
        "Urządzenia uwierzytelniające": "Authentifizierungsgeräte",
        "Urządzenia uwierzytelniające zostały zresetowane.": "Die Authentifizierungsgeräte wurden zurückgesetzt.",
        "Urządzenie nie zostało znalezione.": "Das Gerät wurde nicht gefunden.",
        "Urządzenie zostało usunięte.": "Das Gerät wurde gelöscht.",
        "Usługa AI jest obecnie niedostępna. Spróbuj ponownie za chwilę.": "Der KI-Dienst ist derzeit nicht verfügbar. Versuchen Sie es in Kürze erneut.",
        "Usługa rozmów jest niedostępna. Pobierz rozmowy ponownie, aby sprawdzić połączenie.": "Der Unterhaltungsdienst ist nicht verfügbar. Laden Sie die Unterhaltungen erneut, um die Verbindung zu überprüfen.",
        "Usługa wyszukiwania nie odpowiedziała. Widoki i polecenia działają normalnie.": "Der Suchdienst hat nicht geantwortet. Ansichten und Befehle funktionieren normal.",
        "Ustaw dla całej grupy": "Für die gesamte Gruppe festlegen",
        "Ustaw dziedziczenie wszystkich uprawnień w grupie": "Die Vererbung aller Berechtigungen in der Gruppe festlegen",
        "Ustaw nazwę i opis dashboardu.": "Legen Sie den Namen und die Beschreibung des Dashboards fest.",
        "Ustaw nowe hasło": "Neues Passwort festlegen",
        "Ustaw poziomy logów, które będą wysyłane do poszczególnych rejestrów.": "Legen Sie fest, welche Protokollstufen an die einzelnen Register gesendet werden.",
        "Ustaw poziomy logów, które będą zbierane z poszczególnych przestrzeni nazw.": "Legen Sie fest, welche Protokollstufen aus den einzelnen Namespaces erfasst werden.",
        "Ustaw prawdziwy adres albo usuń linkowanie z tego fragmentu tekstu.": "Legen Sie eine gültige Adresse fest oder entfernen Sie die Verlinkung aus diesem Textabschnitt.",
        "Ustaw realny adres linku albo usuń link.": "Legen Sie eine gültige Linkadresse fest oder entfernen Sie den Link.",
        "Ustaw ścieżkę": "Pfad festlegen",
        "Ustaw własne wymiary": "Benutzerdefinierte Abmessungen festlegen",
        "Ustaw wyjątki względem dostępu wynikającego z ról. Zmiany zatwierdzisz przyciskiem zapisu użytkownika.": "Legen Sie Ausnahmen für den rollenbasierten Zugriff fest. Über die Schaltfläche zum Speichern des Benutzers bestätigen Sie die Änderungen.",
        "Ustawienia": "Einstellungen",
        "Ustawienia kolumn": "Spalteneinstellungen",
        "Ustawienia roli": "Rolleneinstellungen",
        "Ustawienia weryfikacji dwuetapowej zostały zapisane.": "Die Einstellungen für die zweistufige Verifizierung wurden gespeichert.",
        "Ustawienia widgetów zostały zapisane": "Die Widget-Einstellungen wurden gespeichert",
        "Ustawienia widgetu": "Widget-Einstellungen",
        "Ustawienia wspólne": "Allgemeine Einstellungen",
        "Ustawienia zostały zapisane.": "Die Einstellungen wurden gespeichert.",
        "Ustawienie logo witryny jako znaku wodnego": "Website-Logo als Wasserzeichen festlegen",
        "Ustawienie obowiązuje tylko w tej rozmowie. Nowe rozmowy startują w trybie z potwierdzaniem operacji.": "Die Einstellung gilt nur für diese Unterhaltung. Neue Unterhaltungen starten mit aktivierter Bestätigung von Aktionen.",
        "Usuń": "Löschen",
        "USUŃ": "LÖSCHEN",
        "Usuń akapit. Jeśli odstęp jest celowy, użyj elementu layoutu albo stylu przewidzianego dla tej treści.": "Absatz löschen. Wenn der Abstand beabsichtigt ist, verwenden Sie ein Layoutelement oder einen für diesen Inhalt vorgesehenen Stil.",
        "Usuń bieżącą kolumnę": "Aktuelle Spalte löschen",
        "Usuń blok kodu": "Codeblock löschen",
        "Usuń filtr": "Filter löschen",
        "Usuń formatowanie": "Formatierung löschen",
        "Usuń kolumnę": "Spalte löschen",
        "Usuń kontekst strony": "Seitenkontext löschen",
        "Usuń link": "Link löschen",
        "Usuń napisy": "Untertitel löschen",
        "Usuń obraz": "Bild löschen",
        "Usuń obraz startowy": "Startbild löschen",
        "Usuń plik": "Datei löschen",
        "Usuń plik z listy": "Datei aus der Liste löschen",
        "Usuń pusty akapit, jeśli nie jest potrzebny jako świadomy odstęp.": "Leeren Absatz löschen, wenn er nicht als bewusster Abstand benötigt wird.",
        "Usuń rozmowę": "Unterhaltung löschen",
        "Usuń sekcję": "Abschnitt löschen",
        "Usuń tabelę": "Tabelle löschen",
        "Usuń tło": "Hintergrund löschen",
        "Usuń trwale": "Dauerhaft löschen",
        "Usuń układ kolumn": "Spaltenlayout löschen",
        "Usuń urządzenie": "Gerät löschen",
        "Usuń urządzenie, aby odwołać zapamiętane automatyczne logowanie.": "Löschen Sie das Gerät, um die gespeicherte automatische Anmeldung zu widerrufen.",
        "Usuń wariant breakpointu": "Breakpoint-Variante löschen",
        "Usuń widget z dashboardu (menu ⋮ → Usuń) albo skontaktuj się z administratorem systemu.": "Löschen Sie das Widget aus dem Dashboard (Menü ⋮ → Löschen) oder wenden Sie sich an den Systemadministrator.",
        "Usuń wiersz": "Zeile löschen",
        "Usuń wklejone style Worda i zostaw formatowanie z edytora.": "Eingefügte Word-Formatierungen löschen und die Formatierung des Editors beibehalten.",
        "Usuń wszystkie": "Alle löschen",
        "Usuń wybrane elementy": "Ausgewählte Elemente löschen",
        "Usuń załącznik": "Anhang löschen",
        "Usuń zasób": "Ressource löschen",
        "Usunąć całą historię rozmów? Tej operacji nie można cofnąć.": "Den gesamten Unterhaltungsverlauf löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
        "Usunąć tę rozmowę?": "Diese Unterhaltung löschen?",
        "usunął": "hat gelöscht",
        "Usunął": "Hat gelöscht",
        "Usunięcie": "Löschung",
        "usunięte": "gelöscht",
        "Usunięte": "Gelöscht",
        "usunięto": "gelöscht",
        "usunięty": "gelöscht",
        "Usuwanie tła...": "Hintergrund wird entfernt...",
        "Utwórz katalog": "Katalog erstellen",
        "Utwórz osobisty token, pobierz gotowy projekt i otwórz go w Codexie lub Claude Code. Poniżej znajdziesz dokładną kolejność działań oraz polecenie sprawdzające połączenie.": "Erstellen Sie ein persönliches Token, laden Sie ein fertiges Projekt herunter und öffnen Sie es in Codex oder Claude Code. Nachfolgend finden Sie die genaue Reihenfolge der Schritte sowie einen Befehl zum Überprüfen der Verbindung.",
        "Utwórz token": "Token erstellen",
        "Utworzone zasoby": "Erstellte Ressourcen",
        "Utworzył": "Hat erstellt",
        "Uwierzytelnianie tokenem Microsoft 365.": "Authentifizierung mit einem Microsoft-365-Token.",
        "Uzupełnij wymagane pola przed testem.": "Füllen Sie die erforderlichen Felder vor dem Test aus.",
        "Uzupełnij wymagane ustawienia źródła danych tego widgetu.": "Vervollständigen Sie die erforderlichen Datenquelleneinstellungen für dieses Widget.",
        "Użycia": "Verwendungen",
        "Użyte narzędzia": "Verwendete Tools",
        "Użytkownicy": "Benutzer",
        "Użytkownicy w tej roli": "Benutzer mit dieser Rolle",
        "Użytkownik": "Benutzer",
        "Użytkownik \"%0\" %1 obiekt %2": "Benutzer \"%0\" %1 Objekt %2",
        "Użytkownik ma pełny dostęp niezależnie od indywidualnych przypisań. Lista obejmuje tylko zapisane wpisy.": "Der Benutzer hat unabhängig von individuellen Zuweisungen vollständigen Zugriff. Die Liste enthält nur gespeicherte Einträge.",
        "Użytkownik nie będzie otrzymywał żadnych powiadomień.": "Der Benutzer erhält keine Benachrichtigungen.",
        "Użytkownik nie może się zalogować, dopóki konto nie jest aktywne.": "Der Benutzer kann sich nicht anmelden, solange das Konto nicht aktiv ist.",
        "Użytkownik usunięty": "Benutzer gelöscht",
        "Użytkownik zablokowany": "Benutzer gesperrt",
        "Użytkownik zatwierdzony": "Benutzer genehmigt",
        "Użytkownik został dodany.": "Der Benutzer wurde hinzugefügt.",
        "Użytkownik został usunięty.": "Der Benutzer wurde gelöscht.",
        "Użytkownik został utworzony. Możesz zalogować się na swoje konto.": "Der Benutzer wurde erstellt. Sie können sich bei Ihrem Konto anmelden.",
        "Użytkownik został wylogowany.": "Der Benutzer wurde abgemeldet.",
        "Użytkownik został zaktualizowany.": "Der Benutzer wurde aktualisiert.",
        "Użytkownik został zanonimizowany.": "Der Benutzer wurde anonymisiert.",
        "Używany do budowy linków w treści wiadomości.": "Wird zum Erstellen von Links im Nachrichteninhalt verwendet.",
        "W czym mogę pomóc?": "Wie kann ich Ihnen helfen?",
        "W dniach miesiąca": "An den Tagen des Monats",
        "W dniach tygodnia": "An den Wochentagen",
        "W lewo": "Nach links",
        "W menu z trzema kropkami wybierz „Rotuj”. Przeczytaj komunikat i potwierdź, jeśli chcesz zastąpić dotychczasowy token.": "Wählen Sie im Drei-Punkte-Menü „Rotieren“. Lesen Sie die Meldung und bestätigen Sie, wenn Sie das bisherige Token ersetzen möchten.",
        "W miesiącach": "In Monaten",
        "W minutach": "In Minuten",
        "W nowej rozmowie wyślij poniższe polecenie:": "Senden Sie in einer neuen Unterhaltung den folgenden Befehl:",
        "W polu „Data wygaśnięcia” wybierz uzgodniony termin ważności.": "Wählen Sie im Feld „Ablaufdatum“ den vereinbarten Gültigkeitszeitraum aus.",
        "W polu „Nazwa” wpisz nazwę programu i swoje imię, np. „Codex - Anna Kowalska”. Dzięki temu rozpoznasz token na liście.": "Geben Sie im Feld „Name“ den Namen des Programms und Ihren eigenen Namen ein, z. B. „Codex - Anna Kowalska“. So können Sie das Token in der Liste wiedererkennen.",
        "W prawo": "Nach rechts",
        "W recenzji": "In Prüfung",
        "W toku": "In Bearbeitung",
        "W tym miejscu można wybrać tylko jeden plik.": "Hier kann nur eine Datei ausgewählt werden.",
        "W widoku nowego tokenu pobierz paczkę dla swojego programu, zanim zamkniesz okno.": "Laden Sie in der Ansicht des neuen Tokens das Paket für Ihr Programm herunter, bevor Sie das Fenster schließen.",
        "W wybranym okresie nie ma zamówień spełniających kryteria tego widgetu.": "Im ausgewählten Zeitraum gibt es keine Bestellungen, die den Kriterien dieses Widgets entsprechen.",
        "W wybranym okresie nie odnotowano ruchu w Google Analytics dla tej witryny.": "Im ausgewählten Zeitraum wurde für diese Website kein Traffic in Google Analytics erfasst.",
        "w zakresie": "im Bereich",
        "Walidacja certyfikatu SSL": "SSL-Zertifikatsvalidierung",
        "Walidacja treści": "Inhaltsvalidierung",
        "Wariant dla": "Variante für",
        "Wariant mobilny dodawaj tylko wtedy, gdy na telefonie ma się wyświetlić inna grafika.": "Fügen Sie eine mobile Variante nur hinzu, wenn auf dem Smartphone eine andere Grafik angezeigt werden soll.",
        "Warianty responsywne": "Responsive Varianten",
        "Wartość domyślna": "Standardwert",
        "Wartość musi być liczbą całkowitą": "Der Wert muss eine ganze Zahl sein",
        "Wartość musi być liczbą dodatnią": "Der Wert muss eine positive Zahl sein",
        "Wartość musi być liczbą ujemną": "Der Wert muss eine negative Zahl sein",
        "Wartości od 0 do 1. 0 oznacza 0%, a 1 oznacza 100%.": "Werte zwischen 0 und 1. 0 entspricht 0 % und 1 entspricht 100 %.",
        "Warunki korzystania z usług Google": "Nutzungsbedingungen von Google",
        "Wbudowane": "Integriert",
        "Wczoraj": "Gestern",
        "Wczytaj więcej": "Mehr laden",
        "Wczytanie obrazu": "Bild laden",
        "wczytuje rozmowę…": "Unterhaltung wird geladen…",
        "Wczytuję rozmowę...": "Unterhaltung wird geladen...",
        "Wczytywanie": "Wird geladen",
        "Wczytywanie aktywnych sesji": "Aktive Sitzungen werden geladen",
        "Wczytywanie dziennika…": "Protokoll wird geladen…",
        "Wczytywanie emoji...": "Emojis werden geladen...",
        "Wczytywanie folderów": "Ordner werden geladen",
        "Wczytywanie historii wersji…": "Versionsverlauf wird geladen…",
        "Wczytywanie konfiguracji AI…": "KI-Konfiguration wird geladen…",
        "Wczytywanie miejsc użycia": "Verwendungsorte werden geladen",
        "Wczytywanie plików": "Dateien werden geladen",
        "Wczytywanie powiadomień": "Benachrichtigungen werden geladen",
        "Wczytywanie ról": "Rollen werden geladen",
        "Wczytywanie rozmów…": "Unterhaltungen werden geladen…",
        "Wczytywanie układu dashboardu": "Dashboard-Layout wird geladen",
        "Wczytywanie uprawnień": "Berechtigungen werden geladen",
        "Wczytywanie ustawień zabezpieczeń…": "Sicherheitseinstellungen werden geladen…",
        "Wczytywanie zapamiętanych urządzeń": "Gespeicherte Geräte werden geladen",
        "Wczytywanie zdarzenia…": "Ereignis wird geladen…",
        "Wczytywanie…": "Wird geladen…",
        "Wdrożenie": "Bereitstellung",
        "We wszystkich folderach": "In allen Ordnern",
        "Weekend": "Wochenende",
        "wejść": "Eingänge",
        "wejścia": "Zugänge",
        "wejście": "Eingang",
        "Wektoryzacja tekstu": "Textvektorisierung",
        "Wektoryzacja tekstu, analiza semantyczna": "Textvektorisierung, semantische Analyse",
        "Wersja": "Version",
        "Wersja API": "API-Version",
        "Wersja backendu: %0": "Backend-Version: %0",
        "Wersja compact": "Compact-Version",
        "Wersja językowa": "Sprachversion",
        "Weryfikacja dwuetapowa": "Zwei-Faktor-Authentifizierung",
        "Weryfikacja dwuetapowa (2FA)": "Zwei-Faktor-Authentifizierung (2FA)",
        "Weryfikacja dwuetapowa jest dostępna wyłącznie dla kont lokalnych.": "Die Zwei-Faktor-Authentifizierung ist nur für lokale Konten verfügbar.",
        "Weryfikacja dwuetapowa jest wymagana przez system.": "Die Zwei-Faktor-Authentifizierung ist systemseitig erforderlich.",
        "Weryfikacja dwuetapowa została wyłączona.": "Die Zwei-Faktor-Authentifizierung wurde deaktiviert.",
        "Wiadomość": "Nachricht",
        "Wiadomość do asystenta": "Nachricht an den Assistenten",
        "Wiadomość testowa została wysłana.": "Die Testnachricht wurde gesendet.",
        "Widget": "Widget",
        "Widget nie ma danych do wyświetlenia przy obecnych ustawieniach.": "Das Widget hat bei den aktuellen Einstellungen keine Daten zur Anzeige.",
        "Widget w trakcie przygotowywania": "Widget wird vorbereitet",
        "Widget wymaga konfiguracji": "Widget muss konfiguriert werden",
        "Widoczna na liście dostawców i w wyborze modeli.": "In der Anbieterliste und der Modellauswahl sichtbar.",
        "Widoczne": "Sichtbar",
        "Widoczność": "Sichtbarkeit",
        "Widoczność filtra": "Filtersichtbarkeit",
        "Widok": "Ansicht",
        "Widok plików": "Dateiansicht",
        "Więcej": "Mehr",
        "Więcej akcji": "Weitere Aktionen",
        "Więcej akcji widgetu %0": "Weitere Aktionen für Widget %0",
        "Więcej informacji": "Weitere Informationen",
        "Wiele rozwinięć": "Mehrere Erweiterungen",
        "Wiersz nagłówkowy": "Kopfzeile",
        "Wiersze": "Zeilen",
        "Wiersze naprzemienne": "Abwechselnde Zeilen",
        "Windows: w folderze „Pobrane” kliknij ZIP prawym przyciskiem i wybierz „Wyodrębnij wszystkie”.": "Windows: Klicken Sie im Ordner „Downloads“ mit der rechten Maustaste auf die ZIP-Datei und wählen Sie „Alle extrahieren“.",
        "Wizja": "Vision",
        "Wklej": "Einfügen",
        "Wklej adres strony dokumentu Studio albo wpisz moduł/sekcja/id.": "Fügen Sie die Adresse der Studio-Dokumentseite ein oder geben Sie Modul/Abschnitt/ID ein.",
        "Wklej adres URL…": "URL einfügen…",
        "Wklej bez formatowania": "Ohne Formatierung einfügen",
        "Wklej link do dokumentu Studio w formacie /modules/moduł/sekcja/id.": "Fügen Sie den Link zum Studio-Dokument im Format /modules/Modul/Abschnitt/ID ein.",
        "Wklej treść jako czysty tekst albo usuń formatowanie i ustaw je ponownie narzędziami edytora.": "Fügen Sie den Inhalt als reinen Text ein oder entfernen Sie die Formatierung und wenden Sie sie anschließend mit den Editor-Werkzeugen erneut an.",
        "Włącz": "Aktivieren",
        "Włącz pełną autonomię": "Vollständige Autonomie aktivieren",
        "Włącza śledzenie transakcji i pomiar wydajności.": "Aktiviert die Transaktionsverfolgung und Leistungsmessung.",
        "Włączona": "Aktiviert",
        "Włączone": "Aktiviert",
        "Włączyć pełną autonomię?": "Vollständige Autonomie aktivieren?",
        "Właściwości komórki": "Zelleneigenschaften",
        "Właściwości tabeli": "Tabelleneigenschaften",
        "Własne klasy zależą od stylów projektu i nie są odwzorowane w podglądzie.": "Benutzerdefinierte Klassen hängen von den Projektstilen ab und werden in der Vorschau nicht dargestellt.",
        "Własny": "Benutzerdefiniert",
        "Własny breakpoint": "Benutzerdefinierter Breakpoint",
        "Własny przedział": "Benutzerdefinierter Bereich",
        "Własny rozmiar (np. 13px)": "Benutzerdefinierte Größe (z. B. 13px)",
        "Wpisz 6-cyfrowy kod": "Geben Sie den 6-stelligen Code ein",
        "Wpisz adresy po przecinku.": "Geben Sie die Adressen durch Kommas getrennt ein.",
        "Wpisz co najmniej %0 znaki, aby przeszukać strony i dokumenty.": "Geben Sie mindestens %0 Zeichen ein, um Seiten und Dokumente zu durchsuchen.",
        "Wpisz czytelny tekst linku, dodaj obraz z altem albo usuń pusty link.": "Geben Sie einen aussagekräftigen Linktext ein, fügen Sie ein Bild mit Alt-Text hinzu oder entfernen Sie den leeren Link.",
        "Wpisz USUŃ, aby odblokować wykonanie:": "Geben Sie LÖSCHEN ein, um die Ausführung freizugeben:",
        "Wpisz, aby wyszukać…": "Zum Suchen eingeben …",
        "Wprowadzona wartość jest nieprawidłowa": "Der eingegebene Wert ist ungültig",
        "Wprowadzona wartość jest za długa": "Der eingegebene Wert ist zu lang",
        "Wprowadzona wartość jest za krótka": "Der eingegebene Wert ist zu kurz",
        "Wprowadzona wartość jest za niska": "Der eingegebene Wert ist zu niedrig",
        "Wprowadzona wartość jest za wysoka": "Der eingegebene Wert ist zu hoch",
        "Wprowadzona wartość nie jest poprawna": "Der eingegebene Wert ist nicht korrekt",
        "Wróć do logowania": "Zurück zur Anmeldung",
        "Wróć do pulpitu": "Zurück zum Dashboard",
        "Wróć do rozmowy": "Zurück zum Gespräch",
        "Wróć do widoku nowego lub zrotowanego tokenu i pobierz właściwy wariant: edito-codex-project.zip dla Codexa albo edito-claude-code-project.zip dla Claude Code.": "Kehren Sie zur Ansicht des neuen oder rotierten Tokens zurück und laden Sie die passende Variante herunter: edito-codex-project.zip für Codex oder edito-claude-code-project.zip für Claude Code.",
        "Wróć do zmian": "Zurück zu den Änderungen",
        "wrzesień": "September",
        "Wskaż rozpakowany folder:": "Wählen Sie den entpackten Ordner aus:",
        "Wspólne": "Gemeinsam",
        "Wstaw": "Einfügen",
        "Wstaw / edytuj multimedia": "Medien einfügen / bearbeiten",
        "Wstaw akordeon": "Akkordeon einfügen",
        "Wstaw blok kodu": "Codeblock einfügen",
        "Wstaw cytat": "Zitat einfügen",
        "Wstaw cztery kolumny 1/4": "Vier Spalten zu je 1/4 einfügen",
        "Wstaw dwie kolumny 1/3 oraz 2/3": "Zwei Spalten im Verhältnis 1/3 zu 2/3 einfügen",
        "Wstaw dwie kolumny 2/3 oraz 1/3": "Zwei Spalten im Verhältnis 2/3 zu 1/3 einfügen",
        "Wstaw dwie równe kolumny": "Zwei gleich große Spalten einfügen",
        "Wstaw kolumnę z lewej": "Linke Spalte einfügen",
        "Wstaw kolumnę z prawej": "Rechte Spalte einfügen",
        "Wstaw kotwicę": "Anker einfügen",
        "Wstaw linię poziomą": "Horizontale Linie einfügen",
        "Wstaw link": "Link einfügen",
        "Wstaw multimedia": "Medien einfügen",
        "Wstaw obraz": "Bild einfügen",
        "Wstaw plik": "Datei einfügen",
        "Wstaw tabelę": "Tabelle einfügen",
        "Wstaw trzy kolumny 1/2, 1/4 oraz 1/4": "Drei Spalten im Verhältnis 1/2, 1/4 und 1/4 einfügen",
        "Wstaw trzy kolumny 1/3": "Drei Spalten zu je 1/3 einfügen",
        "Wstaw trzy kolumny 1/4, 1/2 oraz 1/4": "Drei Spalten im Verhältnis 1/4, 1/2 und 1/4 einfügen",
        "Wstaw trzy kolumny 1/4, 1/4 oraz 1/2": "Drei Spalten im Verhältnis 1/4, 1/4 und 1/2 einfügen",
        "Wstaw układ": "Layout einfügen",
        "Wstaw wiersz poniżej": "Zeile darunter einfügen",
        "Wstaw wiersz powyżej": "Zeile darüber einfügen",
        "Wstaw/edytuj obraz": "Bild einfügen/bearbeiten",
        "Wstawianie": "Einfügen",
        "Wstawki": "Einfügungen",
        "Wszyscy użytkownicy": "Alle Benutzer",
        "Wszystkie": "Alle",
        "Wszystkie dane osobowe użytkownika znajdujące się w systemie zostaną usunięte!\n\nCzy na pewno chcesz wykonać akcję?": "Alle im System gespeicherten personenbezogenen Daten des Benutzers werden gelöscht!\n\nMöchten Sie die Aktion wirklich ausführen?",
        "Wszystkie elementy": "Alle Elemente",
        "Wszystkie filtry są już dodane.": "Alle Filter wurden bereits hinzugefügt.",
        "Wszystkie kroki zostały wykonane.": "Alle Schritte wurden ausgeführt.",
        "Wszystkie urządzenia uwierzytelniające tego użytkownika zostaną usunięte.\n\nCzy na pewno chcesz wykonać akcję?": "Alle Authentifizierungsgeräte dieses Benutzers werden gelöscht.\n\nMöchten Sie die Aktion wirklich ausführen?",
        "Wszystkie wiersze": "Alle Zeilen",
        "Wszystko zaznaczone": "Alles ausgewählt",
        "Wybierz": "Auswählen",
        "Wybierz „Pobierz projekt dla Claude Code”.": "Wählen Sie „Projekt für Claude Code herunterladen“.",
        "Wybierz „Pobierz projekt dla Codexa”.": "Wählen Sie „Projekt für Codex herunterladen“.",
        "Wybierz docelową ścieżkę zapisu.": "Wählen Sie den Zielpfad zum Speichern aus.",
        "Wybierz dokument z listy.": "Wählen Sie ein Dokument aus der Liste aus.",
        "Wybierz dostawcę": "Anbieter auswählen",
        "Wybierz emoji": "Emoji auswählen",
        "Wybierz godzinę": "Uhrzeit auswählen",
        "Wybierz ikonę": "Symbol auswählen",
        "Wybierz ikonę filtra": "Filtersymbol auswählen",
        "Wybierz ikonę...": "Symbol auswählen...",
        "Wybierz inny rodzaj operacji albo inną grupę.": "Wählen Sie eine andere Vorgangsart oder eine andere Gruppe aus.",
        "Wybierz jeden lub kilka stylów. Podgląd aktualizuje się przed zapisaniem zmian.": "Wählen Sie einen oder mehrere Stile aus. Die Vorschau wird aktualisiert, bevor die Änderungen gespeichert werden.",
        "Wybierz katalog docelowy dla zaznaczonych plików i katalogów.": "Wählen Sie den Zielordner für die ausgewählten Dateien und Ordner aus.",
        "Wybierz kolor": "Farbe auswählen",
        "Wybierz kolor tekstu": "Textfarbe auswählen",
        "Wybierz kolor tła": "Hintergrundfarbe auswählen",
        "Wybierz logo": "Logo auswählen",
        "Wybierz minutę": "Minute auswählen",
        "Wybierz model": "Modell auswählen",
        "Wybierz napisy ze storage": "Untertitel aus dem Speicher auswählen",
        "Wybierz obraz ze storage": "Bild aus dem Speicher auswählen",
        "Wybierz odbiorcę danych telemetrycznych.": "Wählen Sie den Empfänger der Telemetriedaten aus.",
        "Wybierz paczkę zgodną ze swoim asystentem.": "Wählen Sie das zu Ihrem Assistenten passende Paket aus.",
        "Wybierz plik": "Datei auswählen",
        "Wybierz plik .vtt ze storage": "Eine .vtt-Datei aus dem Speicher auswählen",
        "Wybierz plik napisów w formacie WebVTT (.vtt).": "Wählen Sie eine Untertiteldatei im WebVTT-Format (.vtt) aus.",
        "Wybierz pliki": "Dateien auswählen",
        "Wybierz pliki (do {0})": "Dateien auswählen (bis zu {0})",
        "Wybierz rolę lub osobę": "Rolle oder Person auswählen",
        "Wybierz rozpakowany folder projektu, a nie ZIP ani cały folder „Pobrane”. Nie trzeba kopiować konfiguracji do ustawień aplikacji, instalować Claude Code CLI ani wpisywać komend w terminalu.": "Wählen Sie den entpackten Projektordner aus, nicht die ZIP-Datei oder den gesamten Ordner „Downloads“. Die Konfiguration muss nicht in die Anwendungseinstellungen kopiert werden. Sie müssen weder die Claude Code CLI installieren noch Befehle im Terminal eingeben.",
        "Wybierz ścieżkę zapisu": "Speicherpfad auswählen",
        "Wybierz sposób potwierdzania logowania do swojego konta.": "Wählen Sie aus, wie die Anmeldung bei Ihrem Konto bestätigt werden soll.",
        "Wybierz środowisko „Local”, kliknij „Select folder” i wskaż folder:": "Wählen Sie die Umgebung „Local“ aus, klicken Sie auf „Select folder“ und wählen Sie den Ordner aus:",
        "Wybierz układ kolumn": "Spaltenlayout auswählen",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "Wählen Sie die Benutzer aus, für die Sie Aktionen ausführen möchten",
        "Wybierz wersję %0": "Version %0 auswählen",
        "Wybierz witrynę w ustawieniach tego widgetu.": "Wählen Sie in den Einstellungen dieses Widgets eine Website aus.",
        "Wybierz z dysku": "Von Festplatte auswählen",
        "Wybierz zdjęcie użytkownika": "Benutzerfoto auswählen",
        "Wybierz ze storage": "Aus dem Speicher auswählen",
        "Wybierz znak specjalny": "Sonderzeichen auswählen",
        "Wybierz, kto ma dostęp do dashboardu.": "Wählen Sie aus, wer Zugriff auf das Dashboard hat.",
        "Wybierz...": "Auswählen...",
        "Wybierz…": "Auswählen…",
        "Wybór języka": "Sprachauswahl",
        "Wybrana data jest poza dozwolonym zakresem.": "Das ausgewählte Datum liegt außerhalb des zulässigen Bereichs.",
        "Wybrane": "Ausgewählt",
        "Wybrane elementy zostały przeniesione.": "Die ausgewählten Elemente wurden verschoben.",
        "Wybrane elementy zostały przywrócone.": "Die ausgewählten Elemente wurden wiederhergestellt.",
        "Wybrane elementy zostały trwale usunięte.": "Die ausgewählten Elemente wurden endgültig gelöscht.",
        "Wybrane elementy zostały usunięte.": "Die ausgewählten Elemente wurden gelöscht.",
        "Wybrane pliki": "Ausgewählte Dateien",
        "Wybrane: %0": "Ausgewählt: %0",
        "Wybranie dostawcy jest wymagane.": "Die Auswahl eines Anbieters ist erforderlich.",
        "Wybrano %0 użytkowników.": "%0 Benutzer ausgewählt.",
        "Wybrano jednego użytkownika.": "Ein Benutzer ausgewählt.",
        "Wybrano:": "Ausgewählt:",
        "Wybrany element został usunięty.": "Das ausgewählte Element wurde gelöscht.",
        "Wyczyść": "Leeren",
        "Wyczyść filtry": "Filter löschen",
        "Wyczyść historię": "Verlauf löschen",
        "Wyczyść kolejkę": "Warteschlange leeren",
        "Wyczyść styl": "Stil zurücksetzen",
        "Wyczyść styl tabeli": "Tabellenstil zurücksetzen",
        "Wyczyść wartość": "Wert löschen",
        "Wyczyść wybór": "Auswahl aufheben",
        "Wyczyść wyszukiwanie": "Suche löschen",
        "Wyczyść zaznaczenie (Esc)": "Auswahl aufheben (Esc)",
        "Wygasa:": "Läuft ab:",
        "Wygenerowane obrazy": "Generierte Bilder",
        "Wygenerowany obraz": "Generiertes Bild",
        "Wyjustuj": "Blocksatz",
        "Wykluczenia logów konsoli": "Konsolen-Log-Ausschlüsse",
        "Wykonaj": "Ausführen",
        "Wykonane zmiany": "Vorgenommene Änderungen",
        "Wykonanie planu zostało anulowane.": "Die Ausführung des Plans wurde abgebrochen.",
        "Wykonano": "Ausgeführt",
        "Wykonuję operację...": "Vorgang wird ausgeführt...",
        "Wykonuję plan...": "Plan wird ausgeführt...",
        "Wykonywanie": "Wird ausgeführt",
        "Wykres danych dashboardu": "Dashboard-Datendiagramm",
        "Wyłącz 2FA": "2FA deaktivieren",
        "Wyłączona": "Deaktiviert",
        "wyłączone (użytkownik decyduje sam)": "deaktiviert (Benutzer entscheidet selbst)",
        "Wyłączone wysyłanie powiadomień": "Benachrichtigungsversand deaktiviert",
        "Wyloguj się": "Abmelden",
        "Wyloguj zalogowanego obecnie użytkownika": "Aktuell angemeldeten Benutzer abmelden",
        "wymaga uwagi": "erfordert Aufmerksamkeit",
        "Wymaga zatwierdzenia powyżej.": "Erfordert eine oben genannte Genehmigung.",
        "Wymagaj znaków specjalnych w hasłach": "Sonderzeichen in Passwörtern verlangen",
        "Wymagana tylko dla Azure OpenAI.": "Nur für Azure OpenAI erforderlich.",
        "wymagane - Authenticator": "erforderlich – Authenticator",
        "wymagane - dowolna metoda": "erforderlich – beliebige Methode",
        "wymagane - Email": "erforderlich – E-Mail",
        "Wymagane jest ustawienie minimalnej długości hasła": "Die Einstellung einer Mindestpasswortlänge ist erforderlich",
        "Wymagania stawiane hasłom użytkowników panelu.": "Anforderungen an die Passwörter der Panel-Benutzer.",
        "Wymagany": "Erforderlich",
        "Wymiary": "Abmessungen",
        "Wymiary HTML obrazu głównego": "HTML-Abmessungen des Hauptbildes",
        "Wymiary HTML wariantu": "HTML-Abmessungen der Variante",
        "Wymiary obrazu": "Bildabmessungen",
        "Wymuś zmianę hasła": "Passwortänderung erzwingen",
        "Wynik": "Ergebnis",
        "Wynika z roli": "Ergibt sich aus der Rolle",
        "Wyniki": "Ergebnisse",
        "Wyniki wyszukiwania": "Suchergebnisse",
        "Wypełnij miniaturę": "Miniaturbild ausfüllen",
        "Wypełnij miniaturę – przytnij obraz": "Miniaturbild ausfüllen – Bild zuschneiden",
        "Wypróbuj możliwości AI": "KI-Funktionen ausprobieren",
        "Wyrażenie własne": "Eigener Ausdruck",
        "Wyrównanie": "Ausrichtung",
        "Wyrównanie multimediów": "Medienausrichtung",
        "Wyrównanie obrazu": "Bildausrichtung",
        "Wyrównanie pionowe": "Vertikale Ausrichtung",
        "Wyrównanie tekstu": "Textausrichtung",
        "Wyróżnione": "Hervorgehoben",
        "Wysłane": "Gesendet",
        "wysłano": "gesendet",
        "Wysłano": "Gesendet",
        "Wyślij": "Senden",
        "Wyślij kod": "Code senden",
        "Wyślij pliki": "Dateien senden",
        "Wyślij ponownie": "Erneut senden",
        "Wyślij ponownie (%0s)": "Erneut senden (%0s)",
        "Wysoka": "Hoch",
        "Wysokość": "Höhe",
        "Wysokość kadru": "Bildhöhe",
        "Wysokość proporcji": "Seitenverhältnis-Höhe",
        "Wysokość stała dla tego typu widżetu.": "Feste Höhe für diesen Widget-Typ.",
        "Wysokość wynikowa": "Resultierende Höhe",
        "Wyśrodkuj": "Zentrieren",
        "Wystąpił błąd podczas ładowania obrazu. Spróbuj ponownie.": "Beim Laden des Bildes ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        "Wystąpił błąd podczas próby exportu użytkowników.": "Beim Exportieren der Benutzer ist ein Fehler aufgetreten.",
        "Wystąpił błąd podczas próby importu użytkowników.": "Beim Importieren der Benutzer ist ein Fehler aufgetreten.",
        "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "Es ist ein Verbindungsfehler aufgetreten. Stellen Sie sicher, dass Ihre Internetverbindung aktiviert ist, und versuchen Sie es erneut.",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Bei der Verarbeitung des ausgewählten Vorgangs ist ein Serverfehler aufgetreten. Bitte versuchen Sie es erneut.",
        "Wystąpił nieznany błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Bei der Verarbeitung des ausgewählten Vorgangs ist ein unbekannter Serverfehler aufgetreten. Bitte versuchen Sie es erneut.",
        "Wystąpił problem podczas pobierania danych widgetu.": "Beim Abrufen der Widget-Daten ist ein Problem aufgetreten.",
        "Wystąpił problem podczas przetwarzania obrazu.": "Bei der Bildverarbeitung ist ein Problem aufgetreten.",
        "Wyświetlana jako autor wiadomości.": "Wird als Autor der Nachricht angezeigt.",
        "Wyświetlany domyślnie na wszystkich ekranach, jeśli nie dodasz osobnego wariantu mobilnego.": "Wird standardmäßig auf allen Bildschirmen angezeigt, wenn Sie keine separate mobile Variante hinzufügen.",
        "wyświetleń": "Aufrufe",
        "Wysyłaj dane o użytkowniku": "Benutzerdaten senden",
        "wysyłanie niedostępne": "Senden nicht verfügbar",
        "Wysyłanie plików": "Dateien hochladen",
        "Wysyłanie wiadomości niedostępne": "Nachrichtenversand nicht verfügbar",
        "Wysyłanie…": "Wird gesendet…",
        "Wyszukaj emoji": "Emoji suchen",
        "Wyszukaj ikonę": "Symbol suchen",
        "Wyszukaj ikonę...": "Symbol suchen...",
        "Wyszukaj widget": "Widget suchen",
        "Wyszukaj widget...": "Widget suchen...",
        "Wyszukaj znak specjalny": "Sonderzeichen suchen",
        "Wyszukaj...": "Suchen...",
        "Wyszukaj…": "Suchen…",
        "Wyszukiwanie i polecenia": "Suche und Befehle",
        "Wytnij": "Ausschneiden",
        "Wyzeruj": "Zurücksetzen",
        "Wzmacnia obrys tabeli i linie siatki, dzięki czemu układ jest bardziej wyraźny.": "Verstärkt die Tabellenumrandung und Gitternetzlinien, sodass das Layout deutlicher hervortritt.",
        "X": "X",
        "Y": "Y",
        "z": "z",
        "Z komentarzem": "Mit Kommentar",
        "Z uprawnieniami": "Mit Berechtigungen",
        "za %0 %1": "in %0 %1",
        "za chwilę": "in Kürze",
        "Zaakceptowany": "Akzeptiert",
        "Zaawansowane": "Erweitert",
        "Zabierz dostęp": "Zugriff entziehen",
        "Zablokuj": "Sperren",
        "Zablokuj proporcje": "Seitenverhältnis sperren",
        "Zablokuj proporcje wariantu": "Seitenverhältnis der Variante sperren",
        "Zabroń - jawnie odebrane": "Verweigern – explizit entzogen",
        "Zabroń wszystkich uprawnień w grupie": "Alle Berechtigungen in der Gruppe verweigern",
        "Zabronione": "Verweigert",
        "Zacznij nową rozmowę - pojawi się tutaj.": "Beginnen Sie eine neue Unterhaltung – sie wird hier angezeigt.",
        "Zacznij pisać, aby wyszukać użytkownika…": "Beginnen Sie zu tippen, um einen Benutzer zu suchen…",
        "Zacznij w instancji Edito, z którą chcesz pracować.": "Starten Sie in der Edito-Instanz, mit der Sie arbeiten möchten.",
        "Zadaj pytanie albo poproś o akcję - asystent korzysta z modułów CMS.": "Stellen Sie eine Frage oder bitten Sie um eine Aktion – der Assistent nutzt CMS-Module.",
        "Zadanie zostało uruchomione.": "Die Aufgabe wurde gestartet.",
        "Zadanie zostało włączone": "Die Aufgabe wurde aktiviert",
        "Zadanie zostało wyłączone": "Die Aufgabe wurde deaktiviert",
        "Żądany zasób jest niedostępny albo żądanie jest nieprawidłowe.\nSprawdź adres lub wróć do panelu.": "Die angeforderte Ressource ist nicht verfügbar oder die Anfrage ist ungültig.\nÜberprüfen Sie die Adresse oder kehren Sie zum Dashboard zurück.",
        "Żadna rozmowa nie pasuje do wyszukiwania.": "Keine Unterhaltung entspricht der Suche.",
        "Zaimportowano listę użytkowników.": "Die Benutzerliste wurde importiert.",
        "Zakolejkowane": "In die Warteschlange eingereiht",
        "Zakończ": "Beenden",
        "Zakończ sesję, aby natychmiast wylogować to urządzenie.": "Beenden Sie die Sitzung, um dieses Gerät sofort abzumelden.",
        "Zakończone": "Abgeschlossen",
        "Zakończono": "Abgeschlossen",
        "Zakończono z błędami": "Mit Fehlern abgeschlossen",
        "Zakres": "Bereich",
        "Zakres danych": "Datenbereich",
        "Zakres witryny i języka": "Website- und Sprachbereich",
        "Zalecane": "Empfohlen",
        "Zalogowano jako": "Angemeldet als",
        "Zalogowany": "Angemeldet",
        "Zaloguj się": "Anmelden",
        "Zaloguj się do właściwego panelu i pobierz nową paczkę. Nie przenoś paczek między instancjami.": "Melden Sie sich im richtigen Dashboard an und laden Sie ein neues Paket herunter. Übertragen Sie keine Pakete zwischen Instanzen.",
        "Zaloguj się na swoje konto, aby przejść do panelu.": "Melden Sie sich bei Ihrem Konto an, um zum Dashboard zu gelangen.",
        "Zamień": "Ersetzen",
        "Zamień na": "Ersetzen durch",
        "Zamień na…": "Ersetzen durch…",
        "Zamknij": "Schließen",
        "Zamknij asystenta": "Assistenten schließen",
        "Zamknij komunikat": "Meldung schließen",
        "Zamknij menu": "Menü schließen",
        "Zamknij panel": "Panel schließen",
        "Zamknij pełny ekran": "Vollbild schließen",
        "Zamknij podgląd": "Vorschau schließen",
        "Zamknij projekt i otwórz ponownie folder właściwy dla wybranego programu. Jeśli pojawi się pytanie, zatwierdź zaufanie do projektu i serwera „edito”, a następnie ponów test odczytu.": "Schließen Sie das Projekt und öffnen Sie den für das ausgewählte Programm passenden Ordner erneut. Wenn Sie dazu aufgefordert werden, bestätigen Sie das Vertrauen in das Projekt und den Server „edito“ und wiederholen Sie anschließend den Lesetest.",
        "Zamknij wybór plików": "Dateiauswahl schließen",
        "Zaokrąglenie rogów": "Eckenrundung",
        "Zapamiętaj logowanie": "Angemeldet bleiben",
        "Zapamiętane automatyczne logowanie dla tego urządzenia zostanie odwołane.": "Die gespeicherte automatische Anmeldung für dieses Gerät wird widerrufen.",
        "Zapamiętane urządzenia": "Gespeicherte Geräte",
        "Zapis do:": "Speichern unter:",
        "Zapis obejmuje filtry, sortowanie i kolumny.": "Die Speicherung umfasst Filter, Sortierung und Spalten.",
        "Zapisane": "Gespeichert",
        "Zapisane filtry": "Gespeicherte Filter",
        "Zapisano pozycję widgetu %0.": "Die Position des Widgets %0 wurde gespeichert.",
        "Zapisywanie obrazów zakończone.": "Das Speichern der Bilder ist abgeschlossen.",
        "Zapisywanie obrazów...": "Bilder werden gespeichert...",
        "Zapisywanie obrazu...": "Bild wird gespeichert...",
        "Zapisz": "Speichern",
        "Zapisz aranżację": "Layout speichern",
        "Zapisz do katalogu": "Im Verzeichnis speichern",
        "Zapisz i wróć": "Speichern und zurück",
        "Zapisz i zamknij": "Speichern und schließen",
        "Zapisz jako nowe pliki": "Als neue Dateien speichern",
        "Zapisz jako nowy": "Als neu speichern",
        "Zapisz kolejność": "Reihenfolge speichern",
        "Zapisz konfigurację w prywatnym folderze.": "Die Konfiguration im privaten Ordner speichern.",
        "Zapisz nazwę": "Namen speichern",
        "Zapisz nowe hasło": "Neues Passwort speichern",
        "Zapisz ustawienia": "Einstellungen speichern",
        "Zapisz użytkownika": "Benutzer speichern",
        "Zapisz widget": "Widget speichern",
        "Zaplanowane": "Geplant",
        "Zapytanie do modułu dynamicznego nie zwróciło żadnych rekordów.": "Die Abfrage des dynamischen Moduls hat keine Datensätze zurückgegeben.",
        "Zarządzaj aktywnymi sesjami i zaufanymi urządzeniami przypisanymi do Twojego konta.": "Verwalten Sie aktive Sitzungen und vertrauenswürdige Geräte, die Ihrem Konto zugeordnet sind.",
        "Zarządzaj aplikacjami, które generują kody logowania do konta.": "Verwalten Sie Apps, die Anmeldecodes für Ihr Konto generieren.",
        "Zasady haseł": "Passwortrichtlinien",
        "Zastępstwo": "Vertretung",
        "Zastosuj": "Anwenden",
        "Zastosuj modyfikacje": "Änderungen anwenden",
        "Zatrzymaj": "Anhalten",
        "Zatrzymaj odpowiedź": "Antwort anhalten",
        "Zatwierdź plan": "Plan bestätigen",
        "Zaufane adresy IP": "Vertrauenswürdige IP-Adressen",
        "Zawieszeni 30 dni+": "Seit mehr als 30 Tagen gesperrt",
        "Zaznacz": "Auswählen",
        "Zaznacz co najmniej jeden plik.": "Wählen Sie mindestens eine Datei aus.",
        "Zaznacz obraz": "Bild auswählen",
        "Zaznacz obrazy, które chcesz zapisać w katalogu.": "Wählen Sie die Bilder aus, die Sie im Verzeichnis speichern möchten.",
        "Zaznacz pliki w bibliotece, aby pojawiły się tutaj.": "Wählen Sie Dateien in der Bibliothek aus, damit sie hier angezeigt werden.",
        "Zaznacz wiersz": "Zeile auswählen",
        "Zaznacz wszystkie komórki": "Alle Zellen auswählen",
        "Zaznacz wszystkie wiersze": "Alle Zeilen auswählen",
        "Zaznacz wszystko": "Alles auswählen",
        "Zaznaczenie jest zachowane przy zmianie folderu.": "Die Auswahl bleibt beim Wechsel des Ordners erhalten.",
        "Zaznaczenie zawiera plik w formacie niedozwolonym w tym polu.": "Die Auswahl enthält eine Datei in einem Format, das in diesem Feld nicht zulässig ist.",
        "Zaznaczone zadania będą mogły korzystać z tego modelu.": "Die ausgewählten Aufgaben können dieses Modell verwenden.",
        "zaznaczono %0": "%0 ausgewählt",
        "Zbiera metryki środowiska uruchomieniowego .NET.": "Erfasst .NET-Laufzeitmetriken.",
        "Zbieranie i przechowywanie logów": "Protokolle erfassen und speichern",
        "Zdarzenie": "Ereignis",
        "Zdjęcie użytkownika": "Benutzerfoto",
        "Zeskanuj kod QR": "QR-Code scannen",
        "Zeskanuj w aplikacji": "In der App scannen",
        "Zespół": "Team",
        "Zespół w nowoczesnym biurze, naturalne światło": "Team in einem modernen Büro, natürliches Licht",
        "Zespół: %0": "Team: %0",
        "Zestaw został zaktualizowany.": "Das Set wurde aktualisiert.",
        "Zestaw został zapisany.": "Das Set wurde gespeichert.",
        "Zewnętrzny MCP": "Externes MCP",
        "Zezwól - jawnie przyznane": "Zulassen – ausdrücklich gewährt",
        "Zgodny z API OpenAI": "OpenAI-API-kompatibel",
        "zmian w planie": "Änderungen im Plan",
        "Zmiana": "Änderung",
        "Zmiana filtrów": "Filter ändern",
        "Zmiana hasła": "Passwort ändern",
        "Zmiana jednego wymiaru zachowuje proporcje obrazu.": "Wenn Sie eine Abmessung ändern, bleiben die Bildproportionen erhalten.",
        "Zmiana optymalizacji wymiarów": "Optimierung der Abmessungen ändern",
        "Zmiana pozycji znaku wodnego": "Position des Wasserzeichens ändern",
        "Zmiana proporcji kadrowania": "Zuschnittverhältnis ändern",
        "Zmiana rozmiaru kadru": "Zuschnittgröße ändern",
        "Zmiana rozmiaru obrazu": "Bildgröße ändern",
        "Zmiana skali": "Skalierung ändern",
        "Zmiana trybu kadrowania": "Zuschnittmodus ändern",
        "Zmiana ustawień może doprowadzić do utraty dostępu do panelu!\n\nCzy na pewno chcesz zapisać zmiany?": "Eine Änderung der Einstellungen kann dazu führen, dass Sie den Zugriff auf das Panel verlieren!\n\nMöchten Sie die Änderungen wirklich speichern?",
        "Zmiana wymiarów obrazu": "Bildabmessungen ändern",
        "Zmiana znaku wodnego": "Wasserzeichen ändern",
        "Zmiany niewykonane": "Änderungen nicht ausgeführt",
        "Zmiany pól": "Feldänderungen",
        "Zmiany pominięte": "Änderungen übersprungen",
        "Zmiany ustawień monitoringu wymagają restartu aplikacji.": "Änderungen der Überwachungseinstellungen erfordern einen Neustart der Anwendung.",
        "Zmiany w planie": "Änderungen im Plan",
        "Zmiany zostały zapisane.": "Die Änderungen wurden gespeichert.",
        "Zmień": "Ändern",
        "Zmień filtry lub rozszerz zakres wyszukiwania.": "Ändern Sie die Filter oder erweitern Sie den Suchbereich.",
        "Zmień hasło": "Passwort ändern",
        "Zmień hasło używane do logowania do konta.": "Ändern Sie das Passwort, mit dem Sie sich bei Ihrem Konto anmelden.",
        "Zmień kolejność elementów": "Reihenfolge der Elemente ändern",
        "Zmień kolejność wierszy": "Reihenfolge der Zeilen ändern",
        "Zmień komórki pierwszego wiersza lub kolumny na nagłówki TH.": "Zellen der ersten Zeile oder Spalte in TH-Kopfzeilen umwandeln.",
        "Zmień lub skróć wpisaną frazę.": "Ändern oder kürzen Sie den eingegebenen Suchbegriff.",
        "Zmień motyw: %0": "Design ändern: %0",
        "Zmień nazwę": "Namen ändern",
        "Zmień nazwę katalogu": "Verzeichnis umbenennen",
        "Zmień nazwę pliku": "Datei umbenennen",
        "Zmień nazwę rozmowy": "Unterhaltung umbenennen",
        "Zmień nazwę urządzenia": "Gerät umbenennen",
        "Zmień obraz": "Bild ändern",
        "Zmień rozmiar": "Größe ändern",
        "Zmień rozmiar okna": "Fenstergröße ändern",
        "Zmień ścieżkę zapisu": "Speicherpfad ändern",
        "Zmień szerokość okna": "Fensterbreite ändern",
        "Zmień szukaną nazwę uprawnienia lub modułu.": "Ändern Sie den gesuchten Namen der Berechtigung oder des Moduls.",
        "Zmień treść wiadomości...": "Nachrichteninhalt ändern...",
        "Zmień wysokość okna": "Fensterhöhe ändern",
        "Zmień wyszukiwanie lub wybrany stan.": "Ändern Sie die Suche oder den ausgewählten Status.",
        "Zmienić wspólny zestaw dla innych użytkowników?": "Gemeinsames Set für andere Benutzer ändern?",
        "zmienione": "geändert",
        "Zmienione": "Geändert",
        "Zmieniono": "Geändert",
        "Zmniejsz": "Verkleinern",
        "Zmniejsz duże obrazy do WWW": "Große Bilder für das Web verkleinern",
        "Zmniejsz wcięcie": "Einzug verkleinern",
        "Zmniejsza odstępy w komórkach, żeby tabela była gęstsza i zajmowała mniej miejsca.": "Verringert die Abstände in den Zellen, damit die Tabelle kompakter ist und weniger Platz einnimmt.",
        "zmodyfikował": "hat geändert",
        "Zmodyfikował": "Hat geändert",
        "Zmodyfikowano": "Geändert",
        "zmodyfikowany": "geändert",
        "Zmodyfikuj obraz": "Bild bearbeiten",
        "Znaczniki": "Tags",
        "Znajdź i zamień": "Suchen und ersetzen",
        "Znajdź ostatnio zmienione treści i krótko je podsumuj.": "Finden Sie kürzlich geänderte Inhalte und fassen Sie sie kurz zusammen.",
        "Znajdź w treści": "Im Inhalt suchen",
        "Znajdź w treści…": "Im Inhalt suchen…",
        "Znak specjalny": "Sonderzeichen",
        "Znak wodny": "Wasserzeichen",
        "Znaki": "Zeichen",
        "Znaki specjalne": "Sonderzeichen",
        "znaków": "Zeichen",
        "Zobacz sesję użytkownika": "Benutzersitzung anzeigen",
        "Zobacz szczegóły sesji użytkownika": "Details der Benutzersitzung anzeigen",
        "Zobacz szczegóły zdarzenia": "Ereignisdetails anzeigen",
        "Zobacz wszystkie": "Alle anzeigen",
        "Zobacz wszystkie zmiany": "Alle Änderungen anzeigen",
        "Zobacz wszystko": "Alles anzeigen",
        "Żółty": "Gelb",
        "Został przywrócony oryginalny harmonogram": "Der ursprüngliche Zeitplan wurde wiederhergestellt",
        "Zrestartuj aplikację": "Anwendung neu starten",
        "Źródła logów": "Protokollquellen",
        "Źródła uprawnień": "Berechtigungsquellen",
        "Źródło": "Quelle",
        "Źródło materiału": "Materialquelle",
        "Źródło wariantu": "Variantenquelle",
        "Zweryfikuj konfigurację integracji GA dla wybranej witryny i spróbuj odświeżyć dashboard.": "Überprüfen Sie die Konfiguration der GA-Integration für die ausgewählte Website und versuchen Sie, das Dashboard zu aktualisieren.",
        "Zwiększ": "Vergrößern",
        "Zwiększ wcięcie": "Einzug vergrößern",
        "Zwiń": "Einklappen",
        "Zwiń {name}": "{name} einklappen",
        "Zwiń menu": "Menü einklappen",
        "Zwiń sekcję": "Abschnitt einklappen",
        "Zwrócony": "Zurückgegeben"
    }
};
